// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AuthorizationV1AuthorizeApiToken2Data, AuthorizationV1AuthorizeApiToken2Responses, AuthorizationV1AuthorizeApiTokenData, AuthorizationV1AuthorizeApiTokenResponses, AuthorizationV1HeartbeatData, AuthorizationV1HeartbeatResponses, AuthorizationV1TestStateMismatchData, AuthorizationV1TestStateMismatchResponses, DbAdminLegacyDbDiagram2Data, DbAdminLegacyDbDiagram2Responses, DbAdminLegacyDbDiagramData, DbAdminLegacyDbDiagramPost2Data, DbAdminLegacyDbDiagramPost2Responses, DbAdminLegacyDbDiagramPostData, DbAdminLegacyDbDiagramPostResponses, DbAdminLegacyDbDiagramResponses, DbAdminLegacyFulfillments2Data, DbAdminLegacyFulfillments2Responses, DbAdminLegacyFulfillments3Data, DbAdminLegacyFulfillments3Responses, DbAdminLegacyFulfillmentsData, DbAdminLegacyFulfillmentsResponses, DbAdminLegacyTokenValidationData, DbAdminLegacyTokenValidationResponses, DbAdminV1DbDiagram2Data, DbAdminV1DbDiagram2Responses, DbAdminV1DbDiagramData, DbAdminV1DbDiagramPost2Data, DbAdminV1DbDiagramPost2Responses, DbAdminV1DbDiagramPostData, DbAdminV1DbDiagramPostResponses, DbAdminV1DbDiagramResponses, DbAdminV1Fulfillments2Data, DbAdminV1Fulfillments2Responses, DbAdminV1Fulfillments3Data, DbAdminV1Fulfillments3Responses, DbAdminV1FulfillmentsData, DbAdminV1FulfillmentsResponses, DbAdminV1TokenValidationData, DbAdminV1TokenValidationResponses, EsignatureV1EventCallbackData, EsignatureV1EventCallbackResponses, EsignatureV1OnScreenSignData, EsignatureV1OnScreenSignResponses, EsignatureV1RefreshOrderEsignatureData, EsignatureV1RefreshOrderEsignatureResponses, EsignatureV1RequestOrderEsignatureData, EsignatureV1RequestOrderEsignatureResponses, GetServicesV1FrontrunnerV1MongoDiscoveryEventData, GetServicesV1FrontrunnerV1MongoDiscoveryEventResponses, InsuranceV1CategoriesV1DetailsData, InsuranceV1CategoriesV1DetailsResponses, InsuranceV1CategoriesV1HeartbeatData, InsuranceV1CategoriesV1HeartbeatResponses, InsuranceV1CategoriesV1Search2Data, InsuranceV1CategoriesV1Search2Responses, InsuranceV1CategoriesV1SearchData, InsuranceV1CategoriesV1SearchResponses, InsuranceV1DetailsData, InsuranceV1DetailsResponses, InsuranceV1HeartbeatData, InsuranceV1HeartbeatResponses, InsuranceV1Search2Data, InsuranceV1Search2Responses, InsuranceV1SearchData, InsuranceV1SearchResponses, InsuranceV2BulkUploadPlanFeeSchedulesData, InsuranceV2BulkUploadPlanFeeSchedulesResponses, InsuranceV2GetCarrierProductData, InsuranceV2GetCarrierProductLegacyData, InsuranceV2GetCarrierProductLegacyResponses, InsuranceV2GetCarrierProductResponses, InsuranceV2GetCarrierProductsData, InsuranceV2GetCarrierProductsResponses, InsuranceV2GetCarriersByStateData, InsuranceV2GetCarriersByStateResponses, InsuranceV2GetCoverageZonesData, InsuranceV2GetCoverageZonesResponses, InsuranceV2GetPlanFeeSchedulesData, InsuranceV2GetPlanFeeSchedulesResponses, InsuranceV2GetPlanFeeScheduleTemplateSourcesData, InsuranceV2GetPlanFeeScheduleTemplateSourcesResponses, InsuranceV2GetPrimaryIcdsData, InsuranceV2GetPrimaryIcdsResponses, InsuranceV2HeartbeatData, InsuranceV2HeartbeatResponses, InsuranceV2RefillsData, InsuranceV2RefillsResponses, InsuranceV2SearchIcdsData, InsuranceV2SearchIcdsResponses, InsuranceV2SeedPlanFeeSchedulesData, InsuranceV2SeedPlanFeeSchedulesResponses, InsuranceV3CardUploadUrlData, InsuranceV3CardUploadUrlErrors, InsuranceV3CardUploadUrlResponses, InsuranceV3CarrierStatusesV3ListCarrierStatusesData, InsuranceV3CarrierStatusesV3ListCarrierStatusesResponses, InsuranceV3CarriersV3CreateCarrierData, InsuranceV3CarriersV3CreateCarrierResponses, InsuranceV3CarriersV3SearchCarriersData, InsuranceV3CarriersV3SearchCarriersResponses, InsuranceV3CarriersV3UpdateCarrierData, InsuranceV3CarriersV3UpdateCarrierResponses, InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideData, InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideErrors, InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideData, InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideErrors, InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData, InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponses, InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideData, InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideErrors, InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideResponses, InsuranceV3CodesV3SearchCodesData, InsuranceV3CodesV3SearchCodesResponses, InsuranceV3CoverageZonesV3ListCoverageZonesData, InsuranceV3CoverageZonesV3ListCoverageZonesResponses, InsuranceV3DiscoveryData, InsuranceV3DiscoveryResponses, InsuranceV3GetCarriersByStateData, InsuranceV3GetCarriersByStateResponses, InsuranceV3HeartbeatData, InsuranceV3HeartbeatResponses, InsuranceV3MappyData, InsuranceV3MappyErrors, InsuranceV3MappyResponses, InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationData, InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationErrors, InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationData, InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationErrors, InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData, InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponses, InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationData, InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationErrors, InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationResponses, InsuranceV3OrderDiscoveryData, InsuranceV3OrderDiscoveryResponses, InsuranceV3OrderEligibilityData, InsuranceV3OrderEligibilityResponses, InsuranceV3PlanCodesV3CreatePlanCodeData, InsuranceV3PlanCodesV3CreatePlanCodeResponses, InsuranceV3PlanCodesV3GetPlanCodeData, InsuranceV3PlanCodesV3GetPlanCodeResponses, InsuranceV3PlanCodesV3SearchPlanCodesData, InsuranceV3PlanCodesV3SearchPlanCodesResponses, InsuranceV3PlanCodesV3UpdatePlanCodeData, InsuranceV3PlanCodesV3UpdatePlanCodeResponses, InsuranceV3PlansV3CreatePlanData, InsuranceV3PlansV3CreatePlanResponses, InsuranceV3PlansV3GetPlanData, InsuranceV3PlansV3GetPlanResponses, InsuranceV3PlansV3SearchCandidPayersData, InsuranceV3PlansV3SearchCandidPayersResponses, InsuranceV3PlansV3SearchEhrPlansData, InsuranceV3PlansV3SearchEhrPlansResponses, InsuranceV3PlansV3SearchPlansData, InsuranceV3PlansV3SearchPlansResponses, InsuranceV3PlansV3UpdatePlanData, InsuranceV3PlansV3UpdatePlanResponses, InsuranceV3PutCardsData, InsuranceV3PutCardsErrors, InsuranceV3PutCardsResponses, InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentData, InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentErrors, InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentResponses, InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentData, InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentErrors, InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentResponses, InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsData, InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsResponses, InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentData, InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentErrors, InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentResponses, InsuranceV3TestVerificationKeyData, InsuranceV3TestVerificationKeyResponses, InsuranceV3VerificationData, InsuranceV3VerificationResponses, InsuranceV4PlansV4CreatePlanAdminData, InsuranceV4PlansV4CreatePlanAdminResponses, InsuranceV4PlansV4GetPlanAdminData, InsuranceV4PlansV4GetPlanAdminResponses, InsuranceV4PlansV4SearchPlansAdminData, InsuranceV4PlansV4SearchPlansAdminResponses, InsuranceV4PlansV4UpdatePlanAdminData, InsuranceV4PlansV4UpdatePlanAdminResponses, ManagementV1DbV1DbExportData, ManagementV1DbV1DbExportErrors, ManagementV1DbV1DbExportManifestData, ManagementV1DbV1DbExportManifestErrors, ManagementV1DbV1DbExportManifestResponses, ManagementV1DbV1DbExportPruneData, ManagementV1DbV1DbExportPruneErrors, ManagementV1DbV1DbExportPruneResponses, ManagementV1DbV1DbExportResponses, ManagementV1DbV1DbImportData, ManagementV1DbV1DbImportErrors, ManagementV1DbV1DbImportResponses, ManagementV1FeeScheduleV1CreateFeeScheduleRouteData, ManagementV1FeeScheduleV1CreateFeeScheduleRouteResponses, ManagementV1FeeScheduleV1UpdateFeeScheduleData, ManagementV1FeeScheduleV1UpdateFeeScheduleResponses, NpiV1GetProviderData, NpiV1GetProviderResponses, NpiV1SearchProvidersData, NpiV1SearchProvidersResponses, NpiV2AddProviderAddressData, NpiV2AddProviderAddressResponses, NpiV2GetProviderData, NpiV2GetProviderResponses, NpiV2SearchProvidersData, NpiV2SearchProvidersResponses, NpiV2ToggleProviderAddressData, NpiV2ToggleProviderAddressResponses, NpiV2UpdateProviderAddressData, NpiV2UpdateProviderAddressResponses, NpiV2UpdateProviderData, NpiV2UpdateProviderResponses, OrderLookupV1CheckData, OrderLookupV1CheckErrors, OrderLookupV1CheckResponses, OrderLookupV1StartData, OrderLookupV1StartErrors, OrderLookupV1StartResponses, OrdersV1AcceptOrderData, OrdersV1AcceptOrderResponses, OrdersV1AssignOrderInsurancesData, OrdersV1AssignOrderInsurancesResponses, OrdersV1AuthorizeData, OrdersV1AuthorizeResponses, OrdersV1AuthRecoveryData, OrdersV1AuthRecoveryResponses, OrdersV1BackfillRxDateData, OrdersV1BackfillRxDateResponses, OrdersV1BillingData, OrdersV1BillingErrors, OrdersV1BillingResponses, OrdersV1CreateOrderEndpointData, OrdersV1CreateOrderEndpointResponses, OrdersV1DeleteOrderFileData, OrdersV1DeleteOrderFileResponses, OrdersV1DeleteOrderProductsData, OrdersV1DeleteOrderProductsResponses, OrdersV1DuplicateOrderEndpointData, OrdersV1DuplicateOrderEndpointResponses, OrdersV1GetCarrierCoverageZoneProductsData, OrdersV1GetCarrierCoverageZoneProductsResponses, OrdersV1GetChangeReasonsData, OrdersV1GetChangeReasonsResponses, OrdersV1GetDocumentTypesData, OrdersV1GetDocumentTypesResponses, OrdersV1GetFulfillmentsData, OrdersV1GetFulfillmentsResponses, OrdersV1GetIneligibilityReasonsData, OrdersV1GetIneligibilityReasonsResponses, OrdersV1GetInsuranceCardDownloadUrlData, OrdersV1GetInsuranceCardDownloadUrlResponses, OrdersV1GetOnHoldReasonsData, OrdersV1GetOnHoldReasonsResponses, OrdersV1GetOrderFeeSchedulesData, OrdersV1GetOrderFeeSchedulesResponses, OrdersV1GetOrderFileData, OrdersV1GetOrderFileResponses, OrdersV1GetOrderFilesData, OrdersV1GetOrderFilesResponses, OrdersV1GetRejectionReasonsData, OrdersV1GetRejectionReasonsResponses, OrdersV1GetTelehealthErrorReasonsData, OrdersV1GetTelehealthErrorReasonsResponses, OrdersV1MoveTempFilesToOrderData, OrdersV1MoveTempFilesToOrderResponses, OrdersV1OrderDetailsData, OrdersV1OrderDetailsResponses, OrdersV1OrderListData, OrdersV1OrderListResponses, OrdersV1OrderScheduleResupplyData, OrdersV1OrderScheduleResupplyResponses, OrdersV1RejectOrderData, OrdersV1RejectOrderResponses, OrdersV1RequestOrderChangesData, OrdersV1RequestOrderChangesResponses, OrdersV1SearchPatientsWithOrdersData, OrdersV1SearchPatientsWithOrdersResponses, OrdersV1SkipOrder2Data, OrdersV1SkipOrder2Responses, OrdersV1SkipOrderData, OrdersV1SkipOrderResponses, OrdersV1ToggleFulfillmentActiveData, OrdersV1ToggleFulfillmentActiveResponses, OrdersV1ToggleFulfillmentInactiveData, OrdersV1ToggleFulfillmentInactiveResponses, OrdersV1UpdateFulfillmentAssigneeData, OrdersV1UpdateFulfillmentAssigneeErrors, OrdersV1UpdateFulfillmentAssigneeResponses, OrdersV1UpdateFulfillmentData, OrdersV1UpdateFulfillmentErrors, OrdersV1UpdateFulfillmentResponses, OrdersV1UpdateOrderAssigneeData, OrdersV1UpdateOrderAssigneeResponses, OrdersV1UpdateOrderClinicalDocsData, OrdersV1UpdateOrderClinicalDocsResponses, OrdersV1UpdateOrderContactData, OrdersV1UpdateOrderContactResponses, OrdersV1UpdateOrderFileTypeData, OrdersV1UpdateOrderFileTypeResponses, OrdersV1UpdateOrderInsuranceData, OrdersV1UpdateOrderInsuranceResponses, OrdersV1UpdateOrderPatientData, OrdersV1UpdateOrderPatientResponses, OrdersV1UpdateOrderPhysicianData, OrdersV1UpdateOrderPhysicianResponses, OrdersV1UpdateOrderProductsData, OrdersV1UpdateOrderProductsResponses, OrdersV1UpdateOrderReferralData, OrdersV1UpdateOrderReferralResponses, OrdersV1UpdateOrderShippingAddressData, OrdersV1UpdateOrderShippingAddressResponses, OrdersV1UpdateOrderSupplierData, OrdersV1UpdateOrderSupplierResponses, OrdersV1UpdateRxDateData, OrdersV1UpdateRxDateResponses, OrdersV1UploadOrderFileData, OrdersV1UploadOrderFileResponses, OrdersV1UploadOrderTmpFileData, OrdersV1UploadOrderTmpFileResponses, OrdersV2DuplicateOrderV2Data, OrdersV2DuplicateOrderV2Responses, OrdersV2GetOrderStatusesV2Data, OrdersV2GetOrderStatusesV2Responses, OrdersV2MoveOrderToBillingData, OrdersV2MoveOrderToBillingResponses, OrdersV2MoveOrderToCantReachPatientData, OrdersV2MoveOrderToCantReachPatientResponses, OrdersV2MoveOrderToDoneData, OrdersV2MoveOrderToDoneResponses, OrdersV2MoveOrderToInProgressWithSupplierData, OrdersV2MoveOrderToInProgressWithSupplierResponses, OrdersV2MoveOrderToOnHoldWithSupplierData, OrdersV2MoveOrderToOnHoldWithSupplierResponses, OrdersV2MoveOrderToPendingAuthorizationData, OrdersV2MoveOrderToPendingAuthorizationResponses, OrdersV2MoveOrderToPendingRerouteData, OrdersV2MoveOrderToPendingRerouteResponses, OrdersV2MoveOrderToPendingSupplierAcceptanceData, OrdersV2MoveOrderToPendingSupplierAcceptanceResponses, OrdersV2MoveOrderToPreparingShipmentData, OrdersV2MoveOrderToPreparingShipmentResponses, OrdersV2MoveOrderToSupplierCompletedData, OrdersV2MoveOrderToSupplierCompletedResponses, OrdersV2MoveOrderToSupplierShippedData, OrdersV2MoveOrderToSupplierShippedResponses, OrdersV2MoveOrderToTelehealthChasingClinicalsData, OrdersV2MoveOrderToTelehealthChasingClinicalsResponses, OrdersV2MoveOrderToTelehealthCompletedData, OrdersV2MoveOrderToTelehealthCompletedResponses, OrdersV2MoveOrderToTelehealthContactingPatientData, OrdersV2MoveOrderToTelehealthContactingPatientResponses, OrdersV2MoveOrderToTelehealthNeedsReschedulingData, OrdersV2MoveOrderToTelehealthNeedsReschedulingResponses, OrdersV2MoveOrderToTelehealthOnHoldData, OrdersV2MoveOrderToTelehealthOnHoldResponses, OrdersV2MoveOrderToTelehealthPostVisitCompletedData, OrdersV2MoveOrderToTelehealthPostVisitCompletedResponses, OrdersV2MoveOrderToTelehealthUpcomingData, OrdersV2MoveOrderToTelehealthUpcomingResponses, OrdersV2RefreshEsignatureData, OrdersV2RefreshEsignatureResponses, OrdersV2RequestEsignatureData, OrdersV2RequestEsignatureResponses, OrdersV4CloseRetellConversationsData, OrdersV4CloseRetellConversationsResponses, OrdersV4CreateOrderDtcEndpointData, OrdersV4CreateOrderDtcEndpointResponses, OrdersV4CreateOrderMcpEndpointData, OrdersV4CreateOrderMcpEndpointResponses, OrdersV4EscalateMcpOrderData, OrdersV4EscalateMcpOrderResponses, OrdersV4PatchConfirmationStatusData, OrdersV4PatchConfirmationStatusErrors, OrdersV4PatchConfirmationStatusResponses, OrdersV4PatchManualVerificationData, OrdersV4PatchManualVerificationErrors, OrdersV4PatchManualVerificationResponses, OrdersV4PostCantReachPatientData, OrdersV4PostCantReachPatientErrors, OrdersV4PostCantReachPatientResponses, OrdersV4PostConfirmationRequestData, OrdersV4PostConfirmationRequestErrors, OrdersV4PostConfirmationRequestResponses, OrdersV5BillingData, OrdersV5BillingErrors, OrdersV5BillingResponses, OrdersV5CancelOrderData, OrdersV5CancelOrderErrors, OrdersV5CancelOrderResponses, OrdersV5ListActionReasonsData, OrdersV5ListActionReasonsResponses, OrdersV5MessagesV5CreateMessageData, OrdersV5MessagesV5CreateMessageErrors, OrdersV5MessagesV5CreateMessageResponses, OrdersV5MessagesV5DeleteMessageData, OrdersV5MessagesV5DeleteMessageErrors, OrdersV5MessagesV5DeleteMessageResponses, OrdersV5MessagesV5GetOrderMessageData, OrdersV5MessagesV5GetOrderMessageErrors, OrdersV5MessagesV5GetOrderMessageResponses, OrdersV5MessagesV5MarkMessagesSeenData, OrdersV5MessagesV5MarkMessagesSeenErrors, OrdersV5MessagesV5MarkMessagesSeenResponses, OrdersV5NotificationsV5ListNotificationsData, OrdersV5NotificationsV5ListNotificationsResponses, OrdersV5NotificationsV5MarkNotificationsSeenData, OrdersV5NotificationsV5MarkNotificationsSeenErrors, OrdersV5NotificationsV5MarkNotificationsSeenResponses, OrdersV5OrderDetailsData, OrdersV5OrderDetailsResponses, OrdersV5TimelineV5GetOrderTimelineData, OrdersV5TimelineV5GetOrderTimelineErrors, OrdersV5TimelineV5GetOrderTimelineResponses, OrdersV5TriggerRentalClaimsEndpointData, OrdersV5TriggerRentalClaimsEndpointResponses, OrdersV5UncancelOrdersData, OrdersV5UncancelOrdersResponses, OrdersV6HeartbeatData, OrdersV6HeartbeatResponses, OrdersV6OrderDetailsData, OrdersV6OrderDetailsResponses, OrganizationsV1CreateOrganizationData, OrganizationsV1CreateOrganizationResponses, OrganizationsV1GetOrganizationData, OrganizationsV1GetOrganizationResponses, OrganizationsV1SearchOrganizationsData, OrganizationsV1SearchOrganizationsResponses, OrganizationsV1UpdateOrganizationData, OrganizationsV1UpdateOrganizationResponses, PatientsV2GetContactFieldOptionsData, PatientsV2GetContactFieldOptionsResponses, PatientsV2HeartbeatData, PatientsV2HeartbeatResponses, PatientsV2PatientAddressesData, PatientsV2PatientAddressesResponses, PatientsV2PatientContactsData, PatientsV2PatientContactsResponses, PatientsV2PatientCustomerioProfileData, PatientsV2PatientCustomerioProfileResponses, PatientsV2PatientDetailsData, PatientsV2PatientDetailsResponses, PatientsV2PatientInsurancesData, PatientsV2PatientInsurancesResponses, PatientsV2PatientOrdersData, PatientsV2PatientOrdersResponses, PatientsV2PatientPrescriptionsData, PatientsV2PatientPrescriptionsResponses, PatientsV2ReassignPatientData, PatientsV2ReassignPatientResponses, PatientsV2SearchPatientsData, PatientsV2SearchPatientsResponses, PostProductsV2CartV2CreateUpdateCartData, PostProductsV2CartV2CreateUpdateCartResponses, PostServicesV1FrontrunnerV1MongoDiscoveryEventData, PostServicesV1FrontrunnerV1MongoDiscoveryEventResponses, PrescriptionsV1AttachOrderDocumentData, PrescriptionsV1AttachOrderDocumentErrors, PrescriptionsV1AttachOrderDocumentResponses, PrescriptionsV1CreatePrescriptionData, PrescriptionsV1CreatePrescriptionErrors, PrescriptionsV1CreatePrescriptionResponses, PrescriptionsV1DeactivatePrescriptionData, PrescriptionsV1DeactivatePrescriptionErrors, PrescriptionsV1DeactivatePrescriptionResponses, PrescriptionsV1GetPrescriptionData, PrescriptionsV1GetPrescriptionDocumentUrlData, PrescriptionsV1GetPrescriptionDocumentUrlErrors, PrescriptionsV1GetPrescriptionDocumentUrlResponses, PrescriptionsV1GetPrescriptionErrors, PrescriptionsV1GetPrescriptionResponses, PrescriptionsV1LinkOrderData, PrescriptionsV1LinkOrderErrors, PrescriptionsV1LinkOrderResponses, PrescriptionsV1UnlinkOrderData, PrescriptionsV1UnlinkOrderErrors, PrescriptionsV1UnlinkOrderResponses, PrescriptionsV1UploadPrescriptionDocumentData, PrescriptionsV1UploadPrescriptionDocumentErrors, PrescriptionsV1UploadPrescriptionDocumentResponses, ProductsV1CategoriesV1HeartbeatData, ProductsV1CategoriesV1HeartbeatResponses, ProductsV1CategoriesV1SearchData, ProductsV1CategoriesV1SearchResponses, ProductsV1HeartbeatData, ProductsV1HeartbeatResponses, ProductsV1ProductDetailsData, ProductsV1ProductDetailsResponses, ProductsV1SearchProductsData, ProductsV1SearchProductsResponses, ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductData, ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductResponses, ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductData, ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductResponses, ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductData, ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductResponses, ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsData, ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsResponses, ProductsV2CarrierCoverageZoneProductsV2HeartbeatData, ProductsV2CarrierCoverageZoneProductsV2HeartbeatResponses, ProductsV2CartV2DeleteCartData, ProductsV2CartV2DeleteCartResponses, ProductsV2CartV2GetCartData, ProductsV2CartV2GetCartResponses, ProductsV2CategoriesV2GetAllCategoriesData, ProductsV2CategoriesV2GetAllCategoriesResponses, ProductsV2CategoriesV2HeartbeatData, ProductsV2CategoriesV2HeartbeatResponses, ProductsV2CategoriesV2SearchCategoriesData, ProductsV2CategoriesV2SearchCategoriesResponses, ProductsV2EditProductData, ProductsV2EditProductResponses, ProductsV2FoldProducts2Data, ProductsV2FoldProducts2Responses, ProductsV2FoldProducts3Data, ProductsV2FoldProducts3Responses, ProductsV2FoldProducts4Data, ProductsV2FoldProducts4Responses, ProductsV2FoldProductsData, ProductsV2FoldProductsResponses, ProductsV2GetProductDetailsData, ProductsV2GetProductDetailsResponses, ProductsV2HeartbeatData, ProductsV2HeartbeatResponses, ProductsV2SearchProductsData, ProductsV2SearchProductsResponses, ProductsV3ExportCatalog2Data, ProductsV3ExportCatalog2Responses, ProductsV3ExportCatalogData, ProductsV3ExportCatalogResponses, ProductsV3GetCategoriesData, ProductsV3GetCategoriesResponses, ProductsV3GetCoverageZonesData, ProductsV3GetCoverageZonesResponses, ProductsV3GetProductsData, ProductsV3GetProductsResponses, ProductsV3HeartbeatData, ProductsV3HeartbeatResponses, ProductsV4GetAllCategoriesData, ProductsV4GetAllCategoriesResponses, ProductsV4GetCarriersData, ProductsV4GetCarriersResponses, ProductsV4GetCatalogProductData, ProductsV4GetCatalogProductResponses, ProductsV4GetCatalogProductsData, ProductsV4GetCatalogProductsResponses, ProductsV4GetCoverageZonesData, ProductsV4GetCoverageZonesResponses, ProductsV4GetFeeScheduleData, ProductsV4GetFeeScheduleResponses, ProductsV4GetProductAuditData, ProductsV4GetProductAuditResponses, ProductsV4GetProductDetailData, ProductsV4GetProductDetailResponses, ProductsV4SearchCategoriesData, ProductsV4SearchCategoriesResponses, ProductsV4SearchProductsData, ProductsV4SearchProductsResponses, ProductsV5CloneProductToPlansRouteData, ProductsV5CloneProductToPlansRouteResponses, ProductsV5CreateBundleItemRouteData, ProductsV5CreateBundleItemRouteResponses, ProductsV5CreateProductRouteData, ProductsV5CreateProductRouteResponses, ProductsV5DeleteBundleItemRouteData, ProductsV5DeleteBundleItemRouteResponses, ProductsV5DeleteProductPhotoRouteData, ProductsV5DeleteProductPhotoRouteResponses, ProductsV5DeleteProductRouteData, ProductsV5DeleteProductRouteResponses, ProductsV5GetAdminCatalogData, ProductsV5GetAdminCatalogResponses, ProductsV5GetAdminCategoriesData, ProductsV5GetAdminCategoriesResponses, ProductsV5GetAdminPlansData, ProductsV5GetAdminPlansResponses, ProductsV5GetAdminProductStatesData, ProductsV5GetAdminProductStatesResponses, ProductsV5GetBundleTypesRouteData, ProductsV5GetBundleTypesRouteResponses, ProductsV5GetProductBundleItemsData, ProductsV5GetProductBundleItemsResponses, ProductsV5GetProductHcpcsRouteData, ProductsV5GetProductHcpcsRouteResponses, ProductsV5PatchProductPhotosRouteData, ProductsV5PatchProductPhotosRouteResponses, ProductsV5PutProductDimensionSettingsRouteData, ProductsV5PutProductDimensionSettingsRouteResponses, ProductsV5PutProductHcpcsRouteData, ProductsV5PutProductHcpcsRouteResponses, ProductsV5UpdateProductRouteData, ProductsV5UpdateProductRouteResponses, ProductsV6GetCatalogProductData, ProductsV6GetCatalogProductResponses, ProductsV6GetCatalogProductsData, ProductsV6GetCatalogProductsResponses, ProductsV6GetCoverageZonesData, ProductsV6GetCoverageZonesResponses, ProductsV6GetPhcFeeSchedulesRouteData, ProductsV6GetPhcFeeSchedulesRouteResponses, ProductsV6GetProductsData, ProductsV6GetProductsResponses, ProductsV6GetQualifyingIcdsRouteData, ProductsV6GetQualifyingIcdsRouteResponses, PutProductsV2CartV2CreateUpdateCartData, PutProductsV2CartV2CreateUpdateCartResponses, SchedulingV3CalcomWebhookData, SchedulingV3CalcomWebhookErrors, SchedulingV3CalcomWebhookResponses, SchedulingV3GetSlotsData, SchedulingV3GetSlotsErrors, SchedulingV3GetSlotsResponses, SchedulingV3ReserveSlotData, SchedulingV3ReserveSlotErrors, SchedulingV3ReserveSlotResponses, SchedulingV4BookSelfScheduledAppointmentData, SchedulingV4BookSelfScheduledAppointmentErrors, SchedulingV4BookSelfScheduledAppointmentResponses, SchedulingV4CallToRescheduleData, SchedulingV4CallToRescheduleErrors, SchedulingV4CallToRescheduleResponses, SchedulingV4CancelAppointmentData, SchedulingV4CancelAppointmentErrors, SchedulingV4CancelAppointmentResponses, SchedulingV4GetAppointmentData, SchedulingV4GetAppointmentErrors, SchedulingV4GetAppointmentResponses, SchedulingV4GetDaysData, SchedulingV4GetDaysErrors, SchedulingV4GetDaysResponses, SchedulingV4GetSlotsData, SchedulingV4GetSlotsErrors, SchedulingV4GetSlotsResponses, SchedulingV4RequestSelfScheduleData, SchedulingV4RequestSelfScheduleErrors, SchedulingV4RequestSelfScheduleResponses, SchedulingV4RescheduleAppointmentData, SchedulingV4RescheduleAppointmentErrors, SchedulingV4RescheduleAppointmentResponses, SchedulingV4ScheduleOrRescheduleAppointmentData, SchedulingV4ScheduleOrRescheduleAppointmentErrors, SchedulingV4ScheduleOrRescheduleAppointmentResponses, SchedulingV4VerifyPatientBookingData, SchedulingV4VerifyPatientBookingErrors, SchedulingV4VerifyPatientBookingResponses, ServicesV1Auth0V1DuplicateAuth0UsersData, ServicesV1Auth0V1DuplicateAuth0UsersResponses, ServicesV1Auth0V1ExportAuth0UsersData, ServicesV1Auth0V1ExportAuth0UsersResponses, ServicesV1Auth0V1GetAuth0UserData, ServicesV1Auth0V1GetAuth0UserResponses, ServicesV1Auth0V1HeartbeatData, ServicesV1Auth0V1HeartbeatResponses, ServicesV1Auth0V1ListAuth0Users2Data, ServicesV1Auth0V1ListAuth0Users2Responses, ServicesV1Auth0V1ListAuth0UsersData, ServicesV1Auth0V1ListAuth0UsersResponses, ServicesV1AvailityV1HeartbeatData, ServicesV1AvailityV1HeartbeatResponses, ServicesV1AvailityV1PreviewPriorAuthorizationData, ServicesV1AvailityV1PreviewPriorAuthorizationErrors, ServicesV1AvailityV1PreviewPriorAuthorizationResponses, ServicesV1CandidV1GenerateEncounterPayloadData, ServicesV1CandidV1GenerateEncounterPayloadErrors, ServicesV1CandidV1GenerateEncounterPayloadResponses, ServicesV1CandidV1HeartbeatData, ServicesV1CandidV1HeartbeatResponses, ServicesV1CandidV1SearchOrderEncounterData, ServicesV1CandidV1SearchOrderEncounterErrors, ServicesV1CandidV1SearchOrderEncounterResponses, ServicesV1CandidV1SyncFulfillmentByOrderData, ServicesV1CandidV1SyncFulfillmentByOrderResponses, ServicesV1CandidV1SyncRentalClaimsData, ServicesV1CandidV1SyncRentalClaimsResponses, ServicesV1CustomerioV1PostCreateTicketData, ServicesV1CustomerioV1PostCreateTicketErrors, ServicesV1CustomerioV1PostCreateTicketResponses, ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Data, ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Responses, ServicesV1EpacesV1CancelPriorAuthorizationsForOrderData, ServicesV1EpacesV1CancelPriorAuthorizationsForOrderResponses, ServicesV1EpacesV1GetEligibilityResponsesData, ServicesV1EpacesV1GetEligibilityResponsesResponses, ServicesV1EpacesV1GetPriorAuthorizationResponsesData, ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderData, ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderResponses, ServicesV1EpacesV1GetPriorAuthorizationResponsesResponses, ServicesV1EpacesV1HeartbeatData, ServicesV1EpacesV1HeartbeatResponses, ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Data, ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Responses, ServicesV1EpacesV1SubmitPriorAuthorizationForOrderData, ServicesV1EpacesV1SubmitPriorAuthorizationForOrderResponses, ServicesV1FrontrunnerV1DiscoveryByOrderEndpointData, ServicesV1FrontrunnerV1DiscoveryByOrderEndpointResponses, ServicesV1FrontrunnerV1DiscoveryByPatientEndpointData, ServicesV1FrontrunnerV1DiscoveryByPatientEndpointResponses, ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Data, ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Responses, ServicesV1FrontrunnerV1EligibilityByOrderEndpointData, ServicesV1FrontrunnerV1EligibilityByOrderEndpointResponses, ServicesV1FrontrunnerV1EligibilityByPatientEndpointData, ServicesV1FrontrunnerV1EligibilityByPatientEndpointResponses, ServicesV1FrontrunnerV1HeartbeatData, ServicesV1FrontrunnerV1HeartbeatResponses, ServicesV1FrontrunnerV1MockDiscoveryData, ServicesV1FrontrunnerV1MockDiscoveryResponses, ServicesV1FrontrunnerV1MongoDiscoverySourceData, ServicesV1FrontrunnerV1MongoDiscoverySourceResponses, ServicesV1FrontrunnerV1MongoEligibilityEvent2Data, ServicesV1FrontrunnerV1MongoEligibilityEvent2Responses, ServicesV1FrontrunnerV1MongoEligibilityEventData, ServicesV1FrontrunnerV1MongoEligibilityEventResponses, ServicesV1FrontrunnerV1MongoEligibilitySource2Data, ServicesV1FrontrunnerV1MongoEligibilitySource2Responses, ServicesV1FrontrunnerV1MongoEligibilitySourceData, ServicesV1FrontrunnerV1MongoEligibilitySourceResponses, ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointData, ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointResponses, ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointData, ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointResponses, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Data, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Responses, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointData, ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointResponses, ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointData, ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointResponses, ServicesV1HeartbeatData, ServicesV1HeartbeatResponses, ServicesV1HubspotV1ContactsData, ServicesV1HubspotV1ContactsResponses, ServicesV1HubspotV1HeartbeatData, ServicesV1HubspotV1HeartbeatResponses, ServicesV1HubspotV1IngestContactsData, ServicesV1HubspotV1IngestContactsResponses, ServicesV1HubspotV1IngestOrdersData, ServicesV1HubspotV1IngestOrdersResponses, ServicesV1HubspotV1OrdersData, ServicesV1HubspotV1OrdersResponses, ServicesV1HubspotV1ProductsData, ServicesV1HubspotV1ProductsResponses, ServicesV1IntercomV1IntercomSendReplyData, ServicesV1IntercomV1IntercomSendReplyResponses, ServicesV1LuminaV1HeartbeatData, ServicesV1LuminaV1HeartbeatResponses, ServicesV1LuminaV1SubmitOrderData, ServicesV1LuminaV1SubmitOrderResponses, ServicesV1MedlineV1PostShipmentReportData, ServicesV1MedlineV1PostShipmentReportErrors, ServicesV1MedlineV1PostShipmentReportResponses, ServicesV1Ship24V1PostTrackingData, ServicesV1Ship24V1PostTrackingErrors, ServicesV1Ship24V1PostTrackingResponses, ServicesV1SlackV1SlackPostData, ServicesV1SlackV1SlackPostResponses, ServicesV2FrontrunnerV2HeartbeatData, ServicesV2FrontrunnerV2HeartbeatResponses, ServicesV2FrontrunnerV2PipelineReplayData, ServicesV2FrontrunnerV2PipelineReplayResponses, ServicesV2FrontrunnerV2PlanDetailsData, ServicesV2FrontrunnerV2PlanDetailsResponses, ServicesV2HeartbeatData, ServicesV2HeartbeatResponses, SessionsV3PreviewSessionData, SessionsV3PreviewSessionErrors, SessionsV3PreviewSessionResponses, SessionsV3SaveSessionData, SessionsV3SaveSessionErrors, SessionsV3SaveSessionResponses, SessionsV3VerifySessionData, SessionsV3VerifySessionErrors, SessionsV3VerifySessionResponses, SuppliersV1DetailsData, SuppliersV1DetailsResponses, SuppliersV1GetAllSuppliersData, SuppliersV1GetAllSuppliersResponses, SuppliersV1HeartbeatData, SuppliersV1HeartbeatResponses, SuppliersV1Search2Data, SuppliersV1Search2Responses, SuppliersV1SearchData, SuppliersV1SearchResponses, SuppliersV2DetailsData, SuppliersV2DetailsResponses, SuppliersV2GetAllSuppliersData, SuppliersV2GetAllSuppliersResponses, SuppliersV2HeartbeatData, SuppliersV2HeartbeatResponses, SuppliersV2Search2Data, SuppliersV2Search2Responses, SuppliersV2SearchData, SuppliersV2SearchResponses, SystemV1AggregateLegacyContactsData, SystemV1AggregateLegacyContactsResponses, SystemV1AlignOrderUuidsData, SystemV1AlignOrderUuidsErrors, SystemV1AlignOrderUuidsResponses, SystemV1AnalyzeProgressNoteRouteData, SystemV1AnalyzeProgressNoteRouteResponses, SystemV1BackfillFulfillmentHcpcsCodesRouteData, SystemV1BackfillFulfillmentHcpcsCodesRouteResponses, SystemV1BackfillInsurancePlanUuidRouteData, SystemV1BackfillInsurancePlanUuidRouteResponses, SystemV1BackfillSupplierOrganizationIdRouteData, SystemV1BackfillSupplierOrganizationIdRouteErrors, SystemV1BackfillSupplierOrganizationIdRouteResponses, SystemV1CompareOrderDetailContractRouteData, SystemV1CompareOrderDetailContractRouteErrors, SystemV1CompareOrderDetailContractRouteResponses, SystemV1EpacesData, SystemV1EpacesResponses, SystemV1FailedFulfillmentResupplyData, SystemV1FailedFulfillmentResupplyResponses, SystemV1GenerateLomnRouteData, SystemV1GenerateLomnRouteResponses, SystemV1HeartbeatData, SystemV1HeartbeatResponses, SystemV1LomnHistoryData, SystemV1LomnHistoryResponses, SystemV1LomnPdfData, SystemV1LomnPdfResponses, SystemV1LomnRequirementsData, SystemV1LomnRequirementsPopulateData, SystemV1LomnRequirementsPopulateResponses, SystemV1LomnRequirementsResponses, SystemV1MessageConversionEventsData, SystemV1MessageConversionEventsResponses, SystemV1MigrateLegacyPatientRouteData, SystemV1MigrateLegacyPatientRouteErrors, SystemV1MigrateLegacyPatientRouteResponses, SystemV1MigrateMongoOrderAncestryData, SystemV1MigrateMongoOrderAncestryResponses, SystemV1MigrateMongoOrdersRouteData, SystemV1MigrateMongoOrdersRouteResponses, SystemV1MongoHealthData, SystemV1MongoHealthResponses, SystemV1OrdersMissingOtData, SystemV1OrdersMissingOtResponses, SystemV1PdfReaderData, SystemV1PdfReaderResponses, SystemV1ProduceMessageData, SystemV1ProduceMessageResponses, SystemV1PromoteToConfirmOrderData, SystemV1PromoteToConfirmOrderResponses, SystemV1RerunInsuranceDiscoveryData, SystemV1RerunInsuranceDiscoveryResponses, SystemV1ResyncPrescriptionFieldsData, SystemV1ResyncPrescriptionFieldsResponses, SystemV1Ship24RegisterTrackersRouteData, SystemV1Ship24RegisterTrackersRouteResponses, SystemV1Ship24SeedSamplesRouteData, SystemV1Ship24SeedSamplesRouteErrors, SystemV1Ship24SeedSamplesRouteResponses, SystemV1SyncCioOrdersByIdData, SystemV1SyncCioOrdersByIdResponses, SystemV1SyncIntercomConvoByIdData, SystemV1SyncIntercomConvoByIdResponses, SystemV1SyncMongoOrdersByIdData, SystemV1SyncMongoOrdersByIdResponses, SystemV1TriggerResupplyReportData, SystemV1TriggerResupplyReportResponses, TrackingV4VerifyAndGetTrackingData, TrackingV4VerifyAndGetTrackingResponses, UsersV1ActivateUserData, UsersV1ActivateUserResponses, UsersV1CreateUserData, UsersV1CreateUserResponses, UsersV1DeleteUserData, UsersV1DeleteUserResponses, UsersV1GetUserData, UsersV1GetUserResponses, UsersV1ListCommunicationPreferencesData, UsersV1ListCommunicationPreferencesResponses, UsersV1SearchUsersData, UsersV1SearchUsersResponses, UsersV1UpdateCommunicationPreferencesData, UsersV1UpdateCommunicationPreferencesResponses, UsersV1UpdateUserData, UsersV1UpdateUserResponses, VerifyV3CheckData, VerifyV3CheckErrors, VerifyV3CheckResponses, VerifyV3StartData, VerifyV3StartErrors, VerifyV3StartResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminLegacyDbDiagram = <ThrowOnError extends boolean = false>(options?: Options<DbAdminLegacyDbDiagramData, ThrowOnError>): RequestResult<DbAdminLegacyDbDiagramResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DbAdminLegacyDbDiagramResponses, unknown, ThrowOnError>({ url: '/api/legacy/db/admin/db-diagram', ...options });

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminLegacyDbDiagramPost = <ThrowOnError extends boolean = false>(options?: Options<DbAdminLegacyDbDiagramPostData, ThrowOnError>): RequestResult<DbAdminLegacyDbDiagramPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<DbAdminLegacyDbDiagramPostResponses, unknown, ThrowOnError>({ url: '/api/legacy/db/admin/db-diagram', ...options });

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminLegacyDbDiagram2 = <ThrowOnError extends boolean = false>(options: Options<DbAdminLegacyDbDiagram2Data, ThrowOnError>): RequestResult<DbAdminLegacyDbDiagram2Responses, unknown, ThrowOnError> => (options.client ?? client).get<DbAdminLegacyDbDiagram2Responses, unknown, ThrowOnError>({ url: '/api/legacy/db/admin/db-diagram/{bind_key}', ...options });

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminLegacyDbDiagramPost2 = <ThrowOnError extends boolean = false>(options: Options<DbAdminLegacyDbDiagramPost2Data, ThrowOnError>): RequestResult<DbAdminLegacyDbDiagramPost2Responses, unknown, ThrowOnError> => (options.client ?? client).post<DbAdminLegacyDbDiagramPost2Responses, unknown, ThrowOnError>({ url: '/api/legacy/db/admin/db-diagram/{bind_key}', ...options });

export const dbAdminLegacyFulfillments = <ThrowOnError extends boolean = false>(options?: Options<DbAdminLegacyFulfillmentsData, ThrowOnError>): RequestResult<DbAdminLegacyFulfillmentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DbAdminLegacyFulfillmentsResponses, unknown, ThrowOnError>({ url: '/api/legacy/db/admin/orders/fulfillments', ...options });

export const dbAdminLegacyFulfillments2 = <ThrowOnError extends boolean = false>(options: Options<DbAdminLegacyFulfillments2Data, ThrowOnError>): RequestResult<DbAdminLegacyFulfillments2Responses, unknown, ThrowOnError> => (options.client ?? client).get<DbAdminLegacyFulfillments2Responses, unknown, ThrowOnError>({ url: '/api/legacy/db/admin/orders/fulfillments/{upper_bound}', ...options });

export const dbAdminLegacyFulfillments3 = <ThrowOnError extends boolean = false>(options: Options<DbAdminLegacyFulfillments3Data, ThrowOnError>): RequestResult<DbAdminLegacyFulfillments3Responses, unknown, ThrowOnError> => (options.client ?? client).get<DbAdminLegacyFulfillments3Responses, unknown, ThrowOnError>({ url: '/api/legacy/db/admin/orders/fulfillments/{upper_bound}/{lower_bound}', ...options });

/**
 * Validate Token
 *
 * Token testing
 */
export const dbAdminLegacyTokenValidation = <ThrowOnError extends boolean = false>(options: Options<DbAdminLegacyTokenValidationData, ThrowOnError>): RequestResult<DbAdminLegacyTokenValidationResponses, unknown, ThrowOnError> => (options.client ?? client).post<DbAdminLegacyTokenValidationResponses, unknown, ThrowOnError>({
  url: '/api/legacy/db/admin/validate-token',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const authorizationV1AuthorizeApiToken = <ThrowOnError extends boolean = false>(options?: Options<AuthorizationV1AuthorizeApiTokenData, ThrowOnError>): RequestResult<AuthorizationV1AuthorizeApiTokenResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthorizationV1AuthorizeApiTokenResponses, unknown, ThrowOnError>({ url: '/api/v1/authorization/authorize_api_token', ...options });

export const authorizationV1AuthorizeApiToken2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizationV1AuthorizeApiToken2Data, ThrowOnError>): RequestResult<AuthorizationV1AuthorizeApiToken2Responses, unknown, ThrowOnError> => (options.client ?? client).get<AuthorizationV1AuthorizeApiToken2Responses, unknown, ThrowOnError>({ url: '/api/v1/authorization/authorize_api_token/{token}', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const authorizationV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<AuthorizationV1HeartbeatData, ThrowOnError>): RequestResult<AuthorizationV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthorizationV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/authorization/heartbeat', ...options });

/**
 * Test endpoint to simulate mismatching_state error.
 *
 * This endpoint clears the session and then redirects to the callback
 * with fake OAuth parameters, triggering a state mismatch.
 */
export const authorizationV1TestStateMismatch = <ThrowOnError extends boolean = false>(options?: Options<AuthorizationV1TestStateMismatchData, ThrowOnError>): RequestResult<AuthorizationV1TestStateMismatchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthorizationV1TestStateMismatchResponses, unknown, ThrowOnError>({ url: '/api/v1/authorization/test_state_mismatch', ...options });

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminV1DbDiagram = <ThrowOnError extends boolean = false>(options?: Options<DbAdminV1DbDiagramData, ThrowOnError>): RequestResult<DbAdminV1DbDiagramResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DbAdminV1DbDiagramResponses, unknown, ThrowOnError>({ url: '/api/v1/db/admin/db-diagram', ...options });

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminV1DbDiagramPost = <ThrowOnError extends boolean = false>(options?: Options<DbAdminV1DbDiagramPostData, ThrowOnError>): RequestResult<DbAdminV1DbDiagramPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<DbAdminV1DbDiagramPostResponses, unknown, ThrowOnError>({ url: '/api/v1/db/admin/db-diagram', ...options });

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminV1DbDiagram2 = <ThrowOnError extends boolean = false>(options: Options<DbAdminV1DbDiagram2Data, ThrowOnError>): RequestResult<DbAdminV1DbDiagram2Responses, unknown, ThrowOnError> => (options.client ?? client).get<DbAdminV1DbDiagram2Responses, unknown, ThrowOnError>({ url: '/api/v1/db/admin/db-diagram/{bind_key}', ...options });

/**
 * Generate DB ERD
 *
 * Generate and DB entity relationship diagram for the given bind_key
 */
export const dbAdminV1DbDiagramPost2 = <ThrowOnError extends boolean = false>(options: Options<DbAdminV1DbDiagramPost2Data, ThrowOnError>): RequestResult<DbAdminV1DbDiagramPost2Responses, unknown, ThrowOnError> => (options.client ?? client).post<DbAdminV1DbDiagramPost2Responses, unknown, ThrowOnError>({ url: '/api/v1/db/admin/db-diagram/{bind_key}', ...options });

export const dbAdminV1Fulfillments = <ThrowOnError extends boolean = false>(options?: Options<DbAdminV1FulfillmentsData, ThrowOnError>): RequestResult<DbAdminV1FulfillmentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DbAdminV1FulfillmentsResponses, unknown, ThrowOnError>({ url: '/api/v1/db/admin/orders/fulfillments', ...options });

export const dbAdminV1Fulfillments2 = <ThrowOnError extends boolean = false>(options: Options<DbAdminV1Fulfillments2Data, ThrowOnError>): RequestResult<DbAdminV1Fulfillments2Responses, unknown, ThrowOnError> => (options.client ?? client).get<DbAdminV1Fulfillments2Responses, unknown, ThrowOnError>({ url: '/api/v1/db/admin/orders/fulfillments/{upper_bound}', ...options });

export const dbAdminV1Fulfillments3 = <ThrowOnError extends boolean = false>(options: Options<DbAdminV1Fulfillments3Data, ThrowOnError>): RequestResult<DbAdminV1Fulfillments3Responses, unknown, ThrowOnError> => (options.client ?? client).get<DbAdminV1Fulfillments3Responses, unknown, ThrowOnError>({ url: '/api/v1/db/admin/orders/fulfillments/{upper_bound}/{lower_bound}', ...options });

/**
 * Validate Token
 *
 * Token testing
 */
export const dbAdminV1TokenValidation = <ThrowOnError extends boolean = false>(options: Options<DbAdminV1TokenValidationData, ThrowOnError>): RequestResult<DbAdminV1TokenValidationResponses, unknown, ThrowOnError> => (options.client ?? client).post<DbAdminV1TokenValidationResponses, unknown, ThrowOnError>({
  url: '/api/v1/db/admin/validate-token',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const esignatureV1EventCallback = <ThrowOnError extends boolean = false>(options: Options<EsignatureV1EventCallbackData, ThrowOnError>): RequestResult<EsignatureV1EventCallbackResponses, unknown, ThrowOnError> => (options.client ?? client).post<EsignatureV1EventCallbackResponses, unknown, ThrowOnError>({
  url: '/api/v1/esignature/callback',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const esignatureV1OnScreenSign = <ThrowOnError extends boolean = false>(options: Options<EsignatureV1OnScreenSignData, ThrowOnError>): RequestResult<EsignatureV1OnScreenSignResponses, unknown, ThrowOnError> => (options.client ?? client).get<EsignatureV1OnScreenSignResponses, unknown, ThrowOnError>({ url: '/api/v1/esignature/sign/on-screen/{envelope_id}', ...options });

export const esignatureV1RequestOrderEsignature = <ThrowOnError extends boolean = false>(options: Options<EsignatureV1RequestOrderEsignatureData, ThrowOnError>): RequestResult<EsignatureV1RequestOrderEsignatureResponses, unknown, ThrowOnError> => (options.client ?? client).post<EsignatureV1RequestOrderEsignatureResponses, unknown, ThrowOnError>({
  ...formDataBodySerializer,
  url: '/api/v1/esignature/{order_id}/',
  ...options,
  headers: {
    'Content-Type': null,
    ...options.headers
  }
});

export const esignatureV1RefreshOrderEsignature = <ThrowOnError extends boolean = false>(options: Options<EsignatureV1RefreshOrderEsignatureData, ThrowOnError>): RequestResult<EsignatureV1RefreshOrderEsignatureResponses, unknown, ThrowOnError> => (options.client ?? client).post<EsignatureV1RefreshOrderEsignatureResponses, unknown, ThrowOnError>({
  url: '/api/v1/esignature/{order_id}/refresh',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Details
 *
 * Retrieve the extended Code Category record by uuid
 */
export const insuranceV1CategoriesV1Details = <ThrowOnError extends boolean = false>(options: Options<InsuranceV1CategoriesV1DetailsData, ThrowOnError>): RequestResult<InsuranceV1CategoriesV1DetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV1CategoriesV1DetailsResponses, unknown, ThrowOnError>({ url: '/api/v1/insurance/categories/details/{code_category_id}', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const insuranceV1CategoriesV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV1CategoriesV1HeartbeatData, ThrowOnError>): RequestResult<InsuranceV1CategoriesV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV1CategoriesV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/insurance/categories/heartbeat', ...options });

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1CategoriesV1Search = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV1CategoriesV1SearchData, ThrowOnError>): RequestResult<InsuranceV1CategoriesV1SearchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV1CategoriesV1SearchResponses, unknown, ThrowOnError>({ url: '/api/v1/insurance/categories/search', ...options });

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1CategoriesV1Search2 = <ThrowOnError extends boolean = false>(options: Options<InsuranceV1CategoriesV1Search2Data, ThrowOnError>): RequestResult<InsuranceV1CategoriesV1Search2Responses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV1CategoriesV1Search2Responses, unknown, ThrowOnError>({ url: '/api/v1/insurance/categories/search/{category}', ...options });

/**
 * Details
 *
 * Retrieve the extended Insurance record by uuid
 */
export const insuranceV1Details = <ThrowOnError extends boolean = false>(options: Options<InsuranceV1DetailsData, ThrowOnError>): RequestResult<InsuranceV1DetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV1DetailsResponses, unknown, ThrowOnError>({ url: '/api/v1/insurance/details/{insurance_id}', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const insuranceV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV1HeartbeatData, ThrowOnError>): RequestResult<InsuranceV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/insurance/heartbeat', ...options });

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1Search = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV1SearchData, ThrowOnError>): RequestResult<InsuranceV1SearchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV1SearchResponses, unknown, ThrowOnError>({ url: '/api/v1/insurance/search', ...options });

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV1Search2 = <ThrowOnError extends boolean = false>(options: Options<InsuranceV1Search2Data, ThrowOnError>): RequestResult<InsuranceV1Search2Responses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV1Search2Responses, unknown, ThrowOnError>({ url: '/api/v1/insurance/search/{category}', ...options });

/**
 * Enqueue an ad hoc Postgres export to S3. Returns 202 with the Celery task ID.
 */
export const managementV1DbV1DbExport = <ThrowOnError extends boolean = false>(options: Options<ManagementV1DbV1DbExportData, ThrowOnError>): RequestResult<ManagementV1DbV1DbExportResponses, ManagementV1DbV1DbExportErrors, ThrowOnError> => (options.client ?? client).post<ManagementV1DbV1DbExportResponses, ManagementV1DbV1DbExportErrors, ThrowOnError>({
  url: '/api/v1/management/db/export',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Enqueue a partial Postgres restore from S3. Returns 202 with the Celery task ID.
 *
 * Monitor task progress in Flower or Sentry. If the task fails with a
 * ``RestoreError``, the most likely cause locally is a failed ``flask db upgrade``
 * step at the end of the restore. Connect to the api service and run
 * ``flask db upgrade`` manually to apply any pending migrations.
 */
export const managementV1DbV1DbImport = <ThrowOnError extends boolean = false>(options: Options<ManagementV1DbV1DbImportData, ThrowOnError>): RequestResult<ManagementV1DbV1DbImportResponses, ManagementV1DbV1DbImportErrors, ThrowOnError> => (options.client ?? client).post<ManagementV1DbV1DbImportResponses, ManagementV1DbV1DbImportErrors, ThrowOnError>({
  url: '/api/v1/management/db/import',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Return the S3 export manifest. 404 if no exports have run yet.
 */
export const managementV1DbV1DbExportManifest = <ThrowOnError extends boolean = false>(options?: Options<ManagementV1DbV1DbExportManifestData, ThrowOnError>): RequestResult<ManagementV1DbV1DbExportManifestResponses, ManagementV1DbV1DbExportManifestErrors, ThrowOnError> => (options?.client ?? client).get<ManagementV1DbV1DbExportManifestResponses, ManagementV1DbV1DbExportManifestErrors, ThrowOnError>({ url: '/api/v1/management/db/manifest', ...options });

/**
 * Prune exports older than before_date. Latest full per (db_type, environment) is always kept.
 */
export const managementV1DbV1DbExportPrune = <ThrowOnError extends boolean = false>(options: Options<ManagementV1DbV1DbExportPruneData, ThrowOnError>): RequestResult<ManagementV1DbV1DbExportPruneResponses, ManagementV1DbV1DbExportPruneErrors, ThrowOnError> => (options.client ?? client).post<ManagementV1DbV1DbExportPruneResponses, ManagementV1DbV1DbExportPruneErrors, ThrowOnError>({ url: '/api/v1/management/db/prune', ...options });

/**
 * Create a new per-plan fee schedule row.
 *
 * Carrier and coverage-zone are derived server-side from the plan's
 * carrier-coverage-zone (CCZ).  Returns 201 + the created FeeSchedule.
 */
export const managementV1FeeScheduleV1CreateFeeScheduleRoute = <ThrowOnError extends boolean = false>(options: Options<ManagementV1FeeScheduleV1CreateFeeScheduleRouteData, ThrowOnError>): RequestResult<ManagementV1FeeScheduleV1CreateFeeScheduleRouteResponses, unknown, ThrowOnError> => (options.client ?? client).post<ManagementV1FeeScheduleV1CreateFeeScheduleRouteResponses, unknown, ThrowOnError>({
  url: '/api/v1/management/fee_schedule',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const managementV1FeeScheduleV1UpdateFeeSchedule = <ThrowOnError extends boolean = false>(options: Options<ManagementV1FeeScheduleV1UpdateFeeScheduleData, ThrowOnError>): RequestResult<ManagementV1FeeScheduleV1UpdateFeeScheduleResponses, unknown, ThrowOnError> => (options.client ?? client).put<ManagementV1FeeScheduleV1UpdateFeeScheduleResponses, unknown, ThrowOnError>({
  url: '/api/v1/management/fee_schedule/{fee_schedule_uuid}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const npiV1SearchProviders = <ThrowOnError extends boolean = false>(options: Options<NpiV1SearchProvidersData, ThrowOnError>): RequestResult<NpiV1SearchProvidersResponses, unknown, ThrowOnError> => (options.client ?? client).get<NpiV1SearchProvidersResponses, unknown, ThrowOnError>({ url: '/api/v1/npi/search', ...options });

export const npiV1GetProvider = <ThrowOnError extends boolean = false>(options: Options<NpiV1GetProviderData, ThrowOnError>): RequestResult<NpiV1GetProviderResponses, unknown, ThrowOnError> => (options.client ?? client).get<NpiV1GetProviderResponses, unknown, ThrowOnError>({ url: '/api/v1/npi/{npi}', ...options });

/**
 * Verify the OTP, mint a single-use handoff ticket cookie, and return the public_id.
 */
export const orderLookupV1Check = <ThrowOnError extends boolean = false>(options: Options<OrderLookupV1CheckData, ThrowOnError>): RequestResult<OrderLookupV1CheckResponses, OrderLookupV1CheckErrors, ThrowOnError> => (options.client ?? client).post<OrderLookupV1CheckResponses, OrderLookupV1CheckErrors, ThrowOnError>({
  url: '/api/v1/order-lookup/check',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Resolve an order from name + DOB and send an OTP to the on-file phone.
 */
export const orderLookupV1Start = <ThrowOnError extends boolean = false>(options: Options<OrderLookupV1StartData, ThrowOnError>): RequestResult<OrderLookupV1StartResponses, OrderLookupV1StartErrors, ThrowOnError> => (options.client ?? client).post<OrderLookupV1StartResponses, OrderLookupV1StartErrors, ThrowOnError>({
  url: '/api/v1/order-lookup/start',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Enqueue the ePACES auth pipeline for selected fulfillments.
 *
 * Fulfillment ids must belong to the given order or that item fails.
 * Type '6' is queued for ePACES. Unset PA is skipped until mappy stamps auth need.
 * Type '0' after mappy is marked Not Required without enqueueing.
 */
export const ordersV1Authorize = <ThrowOnError extends boolean = false>(options: Options<OrdersV1AuthorizeData, ThrowOnError>): RequestResult<OrdersV1AuthorizeResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1AuthorizeResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/authorize',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * [DEPRECATED]
 */
export const ordersV1Billing = <ThrowOnError extends boolean = false>(options: Options<OrdersV1BillingData, ThrowOnError>): RequestResult<OrdersV1BillingResponses, OrdersV1BillingErrors, ThrowOnError> => (options.client ?? client).post<OrdersV1BillingResponses, OrdersV1BillingErrors, ThrowOnError>({
  url: '/api/v1/orders/billing',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Return the list of valid order change request reasons.
 *
 * Migrated from orders GraphQL query: getChangeReasons
 */
export const ordersV1GetChangeReasons = <ThrowOnError extends boolean = false>(options?: Options<OrdersV1GetChangeReasonsData, ThrowOnError>): RequestResult<OrdersV1GetChangeReasonsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1GetChangeReasonsResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/change-reasons', ...options });

export const ordersV1CreateOrderEndpoint = <ThrowOnError extends boolean = false>(options: Options<OrdersV1CreateOrderEndpointData, ThrowOnError>): RequestResult<OrdersV1CreateOrderEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1CreateOrderEndpointResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/create',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Return every document type tag, active and retired.
 *
 * Backed by the DocumentType table — adding, renaming, or retiring a type here
 * never requires a code change or migration on the frontend or backend. Callers
 * filter by is_active themselves: offering only active types when tagging a new
 * document, but still showing (and allowing removal of) a retired type that's
 * already assigned to an existing document.
 */
export const ordersV1GetDocumentTypes = <ThrowOnError extends boolean = false>(options?: Options<OrdersV1GetDocumentTypesData, ThrowOnError>): RequestResult<OrdersV1GetDocumentTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1GetDocumentTypesResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/document-types', ...options });

export const ordersV1MoveTempFilesToOrder = <ThrowOnError extends boolean = false>(options: Options<OrdersV1MoveTempFilesToOrderData, ThrowOnError>): RequestResult<OrdersV1MoveTempFilesToOrderResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1MoveTempFilesToOrderResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/documents/move',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV1UploadOrderTmpFile = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UploadOrderTmpFileData, ThrowOnError>): RequestResult<OrdersV1UploadOrderTmpFileResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1UploadOrderTmpFileResponses, unknown, ThrowOnError>({
  ...formDataBodySerializer,
  url: '/api/v1/orders/documents/upload',
  ...options,
  headers: {
    'Content-Type': null,
    ...options.headers
  }
});

/**
 * Update fulfillment authorization status and related fields.
 */
export const ordersV1UpdateFulfillment = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateFulfillmentData, ThrowOnError>): RequestResult<OrdersV1UpdateFulfillmentResponses, OrdersV1UpdateFulfillmentErrors, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateFulfillmentResponses, OrdersV1UpdateFulfillmentErrors, ThrowOnError>({
  url: '/api/v1/orders/fulfillments/{fulfillment_uuid}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Update the auth assignee on a fulfillment.
 */
export const ordersV1UpdateFulfillmentAssignee = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateFulfillmentAssigneeData, ThrowOnError>): RequestResult<OrdersV1UpdateFulfillmentAssigneeResponses, OrdersV1UpdateFulfillmentAssigneeErrors, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateFulfillmentAssigneeResponses, OrdersV1UpdateFulfillmentAssigneeErrors, ThrowOnError>({
  url: '/api/v1/orders/fulfillments/{fulfillment_uuid}/assignee',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV1GetFulfillments = <ThrowOnError extends boolean = false>(options: Options<OrdersV1GetFulfillmentsData, ThrowOnError>): RequestResult<OrdersV1GetFulfillmentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1GetFulfillmentsResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/get_fulfillments', ...options });

/**
 * Return the list of valid insurance ineligibility reasons.
 *
 * Migrated from orders GraphQL query: getIneligibilityReasons
 */
export const ordersV1GetIneligibilityReasons = <ThrowOnError extends boolean = false>(options?: Options<OrdersV1GetIneligibilityReasonsData, ThrowOnError>): RequestResult<OrdersV1GetIneligibilityReasonsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1GetIneligibilityReasonsResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/ineligibility-reasons', ...options });

/**
 * Return the list of valid on-hold reasons for supplier hold actions.
 *
 * Migrated from orders GraphQL query: getOnHoldReasons
 */
export const ordersV1GetOnHoldReasons = <ThrowOnError extends boolean = false>(options?: Options<OrdersV1GetOnHoldReasonsData, ThrowOnError>): RequestResult<OrdersV1GetOnHoldReasonsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1GetOnHoldReasonsResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/on-hold-reasons', ...options });

/**
 * Return the list of valid order rejection reasons, filtered by caller role.
 *
 * Migrated from orders GraphQL query: getRejectionReasons
 */
export const ordersV1GetRejectionReasons = <ThrowOnError extends boolean = false>(options?: Options<OrdersV1GetRejectionReasonsData, ThrowOnError>): RequestResult<OrdersV1GetRejectionReasonsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1GetRejectionReasonsResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/rejection-reasons', ...options });

/**
 * Backfill prescription_metadata from legacy prescription_expiration field.
 *
 * Targets orders where ``prescription_expiration`` is set AND
 * ``prescription_metadata`` is None. Idempotent — skips orders that already
 * have ``prescription_metadata``.
 *
 * Pass ``{"dry_run": true}`` to preview matching order IDs without writing.
 * Otherwise enqueues a Celery task and returns ``{"task_id": "..."}`` with 202.
 */
export const ordersV1BackfillRxDate = <ThrowOnError extends boolean = false>(options: Options<OrdersV1BackfillRxDateData, ThrowOnError>): RequestResult<OrdersV1BackfillRxDateResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1BackfillRxDateResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/rx-date/backfill',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV1OrderList = <ThrowOnError extends boolean = false>(options?: Options<OrdersV1OrderListData, ThrowOnError>): RequestResult<OrdersV1OrderListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1OrderListResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/search', ...options });

/**
 * Search orders by patient name or order ID, grouped by patient.
 *
 * Query parameter:
 * query (str) — patient first/last name substring, or a numeric order ID.
 *
 * Migrated from orders GraphQL query: searchPatientsWithOrders
 */
export const ordersV1SearchPatientsWithOrders = <ThrowOnError extends boolean = false>(options?: Options<OrdersV1SearchPatientsWithOrdersData, ThrowOnError>): RequestResult<OrdersV1SearchPatientsWithOrdersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1SearchPatientsWithOrdersResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/search/patients', ...options });

/**
 * Return the list of valid telehealth error reasons for rescheduling actions.
 *
 * Migrated from orders GraphQL query: getTelehealthErrorReasons
 */
export const ordersV1GetTelehealthErrorReasons = <ThrowOnError extends boolean = false>(options?: Options<OrdersV1GetTelehealthErrorReasonsData, ThrowOnError>): RequestResult<OrdersV1GetTelehealthErrorReasonsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV1GetTelehealthErrorReasonsResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/telehealth-error-reasons', ...options });

export const ordersV1OrderDetails = <ThrowOnError extends boolean = false>(options: Options<OrdersV1OrderDetailsData, ThrowOnError>): RequestResult<OrdersV1OrderDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1OrderDetailsResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}', ...options });

/**
 * Accept a pending order.
 *
 * Migrated from orders GraphQL mutation: acceptOrder
 */
export const ordersV1AcceptOrder = <ThrowOnError extends boolean = false>(options: Options<OrdersV1AcceptOrderData, ThrowOnError>): RequestResult<OrdersV1AcceptOrderResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1AcceptOrderResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/accept', ...options });

export const ordersV1UpdateOrderAssignee = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateOrderAssigneeData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderAssigneeResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderAssigneeResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/assignee/update',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Recover epaces authorization info
 *
 * - This will retireve auth info for a given order targeting a specific date authorization was run
 * - This is meant to be used when auth is run manually after updating the order
 * - NOTE: fulfillment authorization_date_embargo and authorization_date_start must  be set, otherwise no fulfillments will be found
 * - The target date will supercede these values
 */
export const ordersV1AuthRecovery = <ThrowOnError extends boolean = false>(options: Options<OrdersV1AuthRecoveryData, ThrowOnError>): RequestResult<OrdersV1AuthRecoveryResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1AuthRecoveryResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/auth/recover/{target_date}', ...options });

/**
 * Get all CarrierCoverageZoneProducts for the order's items
 */
export const ordersV1GetCarrierCoverageZoneProducts = <ThrowOnError extends boolean = false>(options: Options<OrdersV1GetCarrierCoverageZoneProductsData, ThrowOnError>): RequestResult<OrdersV1GetCarrierCoverageZoneProductsResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1GetCarrierCoverageZoneProductsResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/carrier_coverage_zone_products', ...options });

export const ordersV1UpdateOrderClinicalDocs = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateOrderClinicalDocsData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderClinicalDocsResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderClinicalDocsResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/clinical-docs/update',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV1UpdateOrderContact = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateOrderContactData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderContactResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderContactResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/contact/update',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV1GetOrderFiles = <ThrowOnError extends boolean = false>(options: Options<OrdersV1GetOrderFilesData, ThrowOnError>): RequestResult<OrdersV1GetOrderFilesResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1GetOrderFilesResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/documents', ...options });

export const ordersV1UploadOrderFile = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UploadOrderFileData, ThrowOnError>): RequestResult<OrdersV1UploadOrderFileResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1UploadOrderFileResponses, unknown, ThrowOnError>({
  ...formDataBodySerializer,
  url: '/api/v1/orders/{order_id}/documents/upload',
  ...options,
  headers: {
    'Content-Type': null,
    ...options.headers
  }
});

export const ordersV1DeleteOrderFile = <ThrowOnError extends boolean = false>(options: Options<OrdersV1DeleteOrderFileData, ThrowOnError>): RequestResult<OrdersV1DeleteOrderFileResponses, unknown, ThrowOnError> => (options.client ?? client).delete<OrdersV1DeleteOrderFileResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/documents/{key}', ...options });

export const ordersV1GetOrderFile = <ThrowOnError extends boolean = false>(options: Options<OrdersV1GetOrderFileData, ThrowOnError>): RequestResult<OrdersV1GetOrderFileResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1GetOrderFileResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/documents/{key}', ...options });

export const ordersV1UpdateOrderFileType = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateOrderFileTypeData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderFileTypeResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderFileTypeResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/documents/{key}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV1DuplicateOrderEndpoint = <ThrowOnError extends boolean = false>(options: Options<OrdersV1DuplicateOrderEndpointData, ThrowOnError>): RequestResult<OrdersV1DuplicateOrderEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1DuplicateOrderEndpointResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/duplicate', ...options });

/**
 * Get fee schedules for an order's primary insurance.
 *
 * Carrier resolved via carrier_type → template slug → UUID (FrontRunner source of
 * truth, mirrors catalog resolution). Falls back to frhc_id + state → CCZ →
 * dme_template_uuid for unverified insurances. Cascades through all insurances in
 * coverage-priority order; returns fee schedules from the first insurance with
 * matching rows. Returns 200 with an empty payload when no insurance resolves to
 * fee schedules (mirrors v2 endpoint behaviour). ENG-1925.
 */
export const ordersV1GetOrderFeeSchedules = <ThrowOnError extends boolean = false>(options: Options<OrdersV1GetOrderFeeSchedulesData, ThrowOnError>): RequestResult<OrdersV1GetOrderFeeSchedulesResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1GetOrderFeeSchedulesResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/fee_schedules', ...options });

export const ordersV1ToggleFulfillmentActive = <ThrowOnError extends boolean = false>(options: Options<OrdersV1ToggleFulfillmentActiveData, ThrowOnError>): RequestResult<OrdersV1ToggleFulfillmentActiveResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1ToggleFulfillmentActiveResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/fulfillment/activate/{product_id}', ...options });

export const ordersV1ToggleFulfillmentInactive = <ThrowOnError extends boolean = false>(options: Options<OrdersV1ToggleFulfillmentInactiveData, ThrowOnError>): RequestResult<OrdersV1ToggleFulfillmentInactiveResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1ToggleFulfillmentInactiveResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/fulfillment/deactivate/{product_id}', ...options });

export const ordersV1GetInsuranceCardDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<OrdersV1GetInsuranceCardDownloadUrlData, ThrowOnError>): RequestResult<OrdersV1GetInsuranceCardDownloadUrlResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1GetInsuranceCardDownloadUrlResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/insurance-cards', ...options });

/**
 * Update a single insurance (primary or secondary) on an order.
 *
 * Migrated from orders GraphQL mutation: updateOrderInsurance
 */
export const ordersV1UpdateOrderInsurance = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateOrderInsuranceData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderInsuranceResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderInsuranceResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/insurance/update',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Assign Order Insurances
 *
 * Assigns a new slate of insurance information to the order.
 * Expects all insurances to be provided in the request.
 * At least one insurance must be marked as primary.
 * No more than one can be secondary.
 * Any insurances not provided will be deleted from the order.
 */
export const ordersV1AssignOrderInsurances = <ThrowOnError extends boolean = false>(options: Options<OrdersV1AssignOrderInsurancesData, ThrowOnError>): RequestResult<OrdersV1AssignOrderInsurancesResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV1AssignOrderInsurancesResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/insurances/assign-all',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV1DeleteOrderProducts = <ThrowOnError extends boolean = false>(options: Options<OrdersV1DeleteOrderProductsData, ThrowOnError>): RequestResult<OrdersV1DeleteOrderProductsResponses, unknown, ThrowOnError> => (options.client ?? client).delete<OrdersV1DeleteOrderProductsResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/items/{product_id}/delete', ...options });

export const ordersV1UpdateOrderProducts = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateOrderProductsData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderProductsResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderProductsResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/items/{product_id}/update',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV1UpdateOrderPatient = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateOrderPatientData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderPatientResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderPatientResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/patient/update',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV1UpdateOrderPhysician = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateOrderPhysicianData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderPhysicianResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderPhysicianResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/physician/update',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Update the referral (name, phone, email only) on an order.
 *
 * The referral lives on ``order.user`` (the ``OrderUser`` embedded doc surfaced to the
 * frontend as the order's "referral"), NOT ``order.physician`` — the physician is updated
 * separately via ``/physician/update``. We mutate the existing ``OrderUser`` in place so
 * identity fields populated at creation (``user_id``, ``role``, ``organization_*``) are
 * preserved and only the referral's contact fields change.
 *
 * PATCH semantics for the optional contact fields: a field that is present in the request
 * body overwrites (an explicit ``null`` clears it); a field that is omitted is left
 * unchanged. This intentionally diverges from the orders/ GraphQL ``updateOrderReferral``
 * (orders/app/models/order_user.py::OrderUser.update_order_referral), which unconditionally
 * overwrote ``phone``/``email`` and so wiped them when omitted.
 */
export const ordersV1UpdateOrderReferral = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateOrderReferralData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderReferralResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderReferralResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/referral/update',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Reject a pending order.
 *
 * Migrated from orders GraphQL mutation: rejectOrder
 */
export const ordersV1RejectOrder = <ThrowOnError extends boolean = false>(options: Options<OrdersV1RejectOrderData, ThrowOnError>): RequestResult<OrdersV1RejectOrderResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1RejectOrderResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/reject',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Request changes on an order.
 *
 * Migrated from orders GraphQL mutation: requestChanges, which appended the
 * requested changes and moved the order to PENDING_CH_FIX (the "CH Fix"
 * status). The append happens before the transition so apply_transition's
 * order.save() persists both; a guard failure (422) records neither.
 */
export const ordersV1RequestOrderChanges = <ThrowOnError extends boolean = false>(options: Options<OrdersV1RequestOrderChangesData, ThrowOnError>): RequestResult<OrdersV1RequestOrderChangesResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1RequestOrderChangesResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/request-changes',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Manually set the RX expiration date on an order.
 *
 * Sets default source=Manual otherwise leaves as is.
 * ``reference`` is taken from the request body when
 * provided (e.g. "Fax from Dr. Smith office"); falls back to the requesting
 * user's email when omitted. Does not touch ``signing_date`` — that field is
 * set only by the DocuSign callback.
 */
export const ordersV1UpdateRxDate = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateRxDateData, ThrowOnError>): RequestResult<OrdersV1UpdateRxDateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateRxDateResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/rx-date/update',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV1OrderScheduleResupply = <ThrowOnError extends boolean = false>(options: Options<OrdersV1OrderScheduleResupplyData, ThrowOnError>): RequestResult<OrdersV1OrderScheduleResupplyResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1OrderScheduleResupplyResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/schedule/resupply', ...options });

export const ordersV1UpdateOrderShippingAddress = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateOrderShippingAddressData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderShippingAddressResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderShippingAddressResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/shipping-address/update',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV1SkipOrder = <ThrowOnError extends boolean = false>(options: Options<OrdersV1SkipOrderData, ThrowOnError>): RequestResult<OrdersV1SkipOrderResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1SkipOrderResponses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/skip', ...options });

export const ordersV1SkipOrder2 = <ThrowOnError extends boolean = false>(options: Options<OrdersV1SkipOrder2Data, ThrowOnError>): RequestResult<OrdersV1SkipOrder2Responses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV1SkipOrder2Responses, unknown, ThrowOnError>({ url: '/api/v1/orders/{order_id}/skip/{days}', ...options });

export const ordersV1UpdateOrderSupplier = <ThrowOnError extends boolean = false>(options: Options<OrdersV1UpdateOrderSupplierData, ThrowOnError>): RequestResult<OrdersV1UpdateOrderSupplierResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV1UpdateOrderSupplierResponses, unknown, ThrowOnError>({
  url: '/api/v1/orders/{order_id}/supplier/update',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const organizationsV1CreateOrganization = <ThrowOnError extends boolean = false>(options: Options<OrganizationsV1CreateOrganizationData, ThrowOnError>): RequestResult<OrganizationsV1CreateOrganizationResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrganizationsV1CreateOrganizationResponses, unknown, ThrowOnError>({
  url: '/api/v1/organizations',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const organizationsV1SearchOrganizations = <ThrowOnError extends boolean = false>(options?: Options<OrganizationsV1SearchOrganizationsData, ThrowOnError>): RequestResult<OrganizationsV1SearchOrganizationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrganizationsV1SearchOrganizationsResponses, unknown, ThrowOnError>({ url: '/api/v1/organizations/search', ...options });

export const organizationsV1GetOrganization = <ThrowOnError extends boolean = false>(options: Options<OrganizationsV1GetOrganizationData, ThrowOnError>): RequestResult<OrganizationsV1GetOrganizationResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrganizationsV1GetOrganizationResponses, unknown, ThrowOnError>({ url: '/api/v1/organizations/{organization_id}', ...options });

export const organizationsV1UpdateOrganization = <ThrowOnError extends boolean = false>(options: Options<OrganizationsV1UpdateOrganizationData, ThrowOnError>): RequestResult<OrganizationsV1UpdateOrganizationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrganizationsV1UpdateOrganizationResponses, unknown, ThrowOnError>({
  url: '/api/v1/organizations/{organization_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Record an uploaded prescription and the codes it authorizes.
 *
 * The prescriber is resolved from the supplied NPI rather than inherited from an order: an
 * uploaded script may have been written by a clinician who has never appeared on one.
 */
export const prescriptionsV1CreatePrescription = <ThrowOnError extends boolean = false>(options: Options<PrescriptionsV1CreatePrescriptionData, ThrowOnError>): RequestResult<PrescriptionsV1CreatePrescriptionResponses, PrescriptionsV1CreatePrescriptionErrors, ThrowOnError> => (options.client ?? client).post<PrescriptionsV1CreatePrescriptionResponses, PrescriptionsV1CreatePrescriptionErrors, ThrowOnError>({
  url: '/api/v1/prescriptions/',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Withdraw a prescription that should not have been recorded.
 *
 * Refused while orders are still linked: an order placed under a script is a fact that
 * should not disappear silently. Unlink the orders first, which is a deliberate act.
 */
export const prescriptionsV1DeactivatePrescription = <ThrowOnError extends boolean = false>(options: Options<PrescriptionsV1DeactivatePrescriptionData, ThrowOnError>): RequestResult<PrescriptionsV1DeactivatePrescriptionResponses, PrescriptionsV1DeactivatePrescriptionErrors, ThrowOnError> => (options.client ?? client).delete<PrescriptionsV1DeactivatePrescriptionResponses, PrescriptionsV1DeactivatePrescriptionErrors, ThrowOnError>({ url: '/api/v1/prescriptions/{prescription_uuid}', ...options });

export const prescriptionsV1GetPrescription = <ThrowOnError extends boolean = false>(options: Options<PrescriptionsV1GetPrescriptionData, ThrowOnError>): RequestResult<PrescriptionsV1GetPrescriptionResponses, PrescriptionsV1GetPrescriptionErrors, ThrowOnError> => (options.client ?? client).get<PrescriptionsV1GetPrescriptionResponses, PrescriptionsV1GetPrescriptionErrors, ThrowOnError>({ url: '/api/v1/prescriptions/{prescription_uuid}', ...options });

/**
 * Store a document against a prescription.
 *
 * Separate from create so a failed upload does not lose the prescription, and so the caller
 * can attach more than one document -- a packet may be several files.
 */
export const prescriptionsV1UploadPrescriptionDocument = <ThrowOnError extends boolean = false>(options: Options<PrescriptionsV1UploadPrescriptionDocumentData, ThrowOnError>): RequestResult<PrescriptionsV1UploadPrescriptionDocumentResponses, PrescriptionsV1UploadPrescriptionDocumentErrors, ThrowOnError> => (options.client ?? client).post<PrescriptionsV1UploadPrescriptionDocumentResponses, PrescriptionsV1UploadPrescriptionDocumentErrors, ThrowOnError>({
  ...formDataBodySerializer,
  url: '/api/v1/prescriptions/{prescription_uuid}/documents',
  ...options,
  headers: {
    'Content-Type': null,
    ...options.headers
  }
});

/**
 * Reference a document already stored under an order, without copying the file.
 *
 * One stored object, two pointers: it stays an order asset and becomes a prescription asset.
 * The caller names an existing order document rather than a path, so an arbitrary S3 key
 * cannot be attached.
 */
export const prescriptionsV1AttachOrderDocument = <ThrowOnError extends boolean = false>(options: Options<PrescriptionsV1AttachOrderDocumentData, ThrowOnError>): RequestResult<PrescriptionsV1AttachOrderDocumentResponses, PrescriptionsV1AttachOrderDocumentErrors, ThrowOnError> => (options.client ?? client).post<PrescriptionsV1AttachOrderDocumentResponses, PrescriptionsV1AttachOrderDocumentErrors, ThrowOnError>({
  url: '/api/v1/prescriptions/{prescription_uuid}/documents/from-order',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Time-limited download link for one of a prescription's documents.
 *
 * Minted per request rather than returned with the prescription: the signature expires, so a
 * cached list response would hand out dead links.
 */
export const prescriptionsV1GetPrescriptionDocumentUrl = <ThrowOnError extends boolean = false>(options: Options<PrescriptionsV1GetPrescriptionDocumentUrlData, ThrowOnError>): RequestResult<PrescriptionsV1GetPrescriptionDocumentUrlResponses, PrescriptionsV1GetPrescriptionDocumentUrlErrors, ThrowOnError> => (options.client ?? client).get<PrescriptionsV1GetPrescriptionDocumentUrlResponses, PrescriptionsV1GetPrescriptionDocumentUrlErrors, ThrowOnError>({ url: '/api/v1/prescriptions/{prescription_uuid}/documents/{document_uuid}', ...options });

/**
 * Record that an order was placed under this prescription.
 *
 * Written only from an explicit action: ops is looking at the script in the context of this
 * order, which is a better link than anything derivable from the Mongo ancestry walk.
 * Re-linking the same order is a no-op rather than an error.
 */
export const prescriptionsV1LinkOrder = <ThrowOnError extends boolean = false>(options: Options<PrescriptionsV1LinkOrderData, ThrowOnError>): RequestResult<PrescriptionsV1LinkOrderResponses, PrescriptionsV1LinkOrderErrors, ThrowOnError> => (options.client ?? client).post<PrescriptionsV1LinkOrderResponses, PrescriptionsV1LinkOrderErrors, ThrowOnError>({
  url: '/api/v1/prescriptions/{prescription_uuid}/orders',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Remove the record that an order was placed under this prescription.
 *
 * Document operations do not cascade into prescription records, so this is the only way to
 * undo a mis-attached order. Unlinking an order that is not linked is a no-op.
 */
export const prescriptionsV1UnlinkOrder = <ThrowOnError extends boolean = false>(options: Options<PrescriptionsV1UnlinkOrderData, ThrowOnError>): RequestResult<PrescriptionsV1UnlinkOrderResponses, PrescriptionsV1UnlinkOrderErrors, ThrowOnError> => (options.client ?? client).delete<PrescriptionsV1UnlinkOrderResponses, PrescriptionsV1UnlinkOrderErrors, ThrowOnError>({ url: '/api/v1/prescriptions/{prescription_uuid}/orders/{order_id}', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV1CategoriesV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ProductsV1CategoriesV1HeartbeatData, ThrowOnError>): RequestResult<ProductsV1CategoriesV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV1CategoriesV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/products/categories/heartbeat', ...options });

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const productsV1CategoriesV1Search = <ThrowOnError extends boolean = false>(options?: Options<ProductsV1CategoriesV1SearchData, ThrowOnError>): RequestResult<ProductsV1CategoriesV1SearchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV1CategoriesV1SearchResponses, unknown, ThrowOnError>({ url: '/api/v1/products/categories/search', ...options });

/**
 * Details
 *
 * Retrieve the extended Product record by uuid
 */
export const productsV1ProductDetails = <ThrowOnError extends boolean = false>(options: Options<ProductsV1ProductDetailsData, ThrowOnError>): RequestResult<ProductsV1ProductDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV1ProductDetailsResponses, unknown, ThrowOnError>({ url: '/api/v1/products/details/{product_id}', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ProductsV1HeartbeatData, ThrowOnError>): RequestResult<ProductsV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/products/heartbeat', ...options });

/**
 * Search Products
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const productsV1SearchProducts = <ThrowOnError extends boolean = false>(options?: Options<ProductsV1SearchProductsData, ThrowOnError>): RequestResult<ProductsV1SearchProductsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV1SearchProductsResponses, unknown, ThrowOnError>({ url: '/api/v1/products/search', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1Auth0V1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1Auth0V1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1Auth0V1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1Auth0V1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/services/auth0/heartbeat', ...options });

/**
 * Auth0 Users
 *
 * Retrieve 1 auth0 registered user based on provided user_id
 */
export const servicesV1Auth0V1GetAuth0User = <ThrowOnError extends boolean = false>(options: Options<ServicesV1Auth0V1GetAuth0UserData, ThrowOnError>): RequestResult<ServicesV1Auth0V1GetAuth0UserResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1Auth0V1GetAuth0UserResponses, unknown, ThrowOnError>({ url: '/api/v1/services/auth0/user/{user_id}', ...options });

/**
 * Auth0 Users
 *
 * Retrieve list of a max of 1000 auth0 registered users for current tenant
 */
export const servicesV1Auth0V1ListAuth0Users = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1Auth0V1ListAuth0UsersData, ThrowOnError>): RequestResult<ServicesV1Auth0V1ListAuth0UsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1Auth0V1ListAuth0UsersResponses, unknown, ThrowOnError>({ url: '/api/v1/services/auth0/users', ...options });

/**
 * Auth0 Users
 *
 * Retrieve list of all auth0 registered users for current tenant
 */
export const servicesV1Auth0V1DuplicateAuth0Users = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1Auth0V1DuplicateAuth0UsersData, ThrowOnError>): RequestResult<ServicesV1Auth0V1DuplicateAuth0UsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1Auth0V1DuplicateAuth0UsersResponses, unknown, ThrowOnError>({ url: '/api/v1/services/auth0/users/duplicates', ...options });

/**
 * Auth0 Users
 *
 * Retrieve list of all auth0 registered users for current tenant
 */
export const servicesV1Auth0V1ExportAuth0Users = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1Auth0V1ExportAuth0UsersData, ThrowOnError>): RequestResult<ServicesV1Auth0V1ExportAuth0UsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1Auth0V1ExportAuth0UsersResponses, unknown, ThrowOnError>({ url: '/api/v1/services/auth0/users/export', ...options });

/**
 * Auth0 Users
 *
 * Retrieve list of a max of 1000 auth0 registered users for current tenant
 */
export const servicesV1Auth0V1ListAuth0Users2 = <ThrowOnError extends boolean = false>(options: Options<ServicesV1Auth0V1ListAuth0Users2Data, ThrowOnError>): RequestResult<ServicesV1Auth0V1ListAuth0Users2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1Auth0V1ListAuth0Users2Responses, unknown, ThrowOnError>({ url: '/api/v1/services/auth0/users/{search_term}', ...options });

/**
 * Heartbeat
 */
export const servicesV1AvailityV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1AvailityV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1AvailityV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1AvailityV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/services/availity/heartbeat', ...options });

/**
 * Return the prior authorization service review body and context for one fulfillment.
 *
 * Does not send the request or write fulfillment state.
 */
export const servicesV1AvailityV1PreviewPriorAuthorization = <ThrowOnError extends boolean = false>(options: Options<ServicesV1AvailityV1PreviewPriorAuthorizationData, ThrowOnError>): RequestResult<ServicesV1AvailityV1PreviewPriorAuthorizationResponses, ServicesV1AvailityV1PreviewPriorAuthorizationErrors, ThrowOnError> => (options.client ?? client).get<ServicesV1AvailityV1PreviewPriorAuthorizationResponses, ServicesV1AvailityV1PreviewPriorAuthorizationErrors, ThrowOnError>({ url: '/api/v1/services/availity/orders/{order_id}/fulfillments/{fulfillment_id}/preview', ...options });

/**
 * Candid Payload
 *
 * Generate the payload that is sent when order is submitted to candid
 */
export const servicesV1CandidV1GenerateEncounterPayload = <ThrowOnError extends boolean = false>(options: Options<ServicesV1CandidV1GenerateEncounterPayloadData, ThrowOnError>): RequestResult<ServicesV1CandidV1GenerateEncounterPayloadResponses, ServicesV1CandidV1GenerateEncounterPayloadErrors, ThrowOnError> => (options.client ?? client).get<ServicesV1CandidV1GenerateEncounterPayloadResponses, ServicesV1CandidV1GenerateEncounterPayloadErrors, ThrowOnError>({ url: '/api/v1/services/candid/encounter/{order_id}', ...options });

/**
 * Candid Payload
 *
 * Get candid encounter by order
 */
export const servicesV1CandidV1SearchOrderEncounter = <ThrowOnError extends boolean = false>(options: Options<ServicesV1CandidV1SearchOrderEncounterData, ThrowOnError>): RequestResult<ServicesV1CandidV1SearchOrderEncounterResponses, ServicesV1CandidV1SearchOrderEncounterErrors, ThrowOnError> => (options.client ?? client).get<ServicesV1CandidV1SearchOrderEncounterResponses, ServicesV1CandidV1SearchOrderEncounterErrors, ThrowOnError>({ url: '/api/v1/services/candid/encounter/{order_id}/search', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1CandidV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1CandidV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1CandidV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1CandidV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/services/candid/heartbeat', ...options });

export const servicesV1CandidV1SyncFulfillmentByOrder = <ThrowOnError extends boolean = false>(options: Options<ServicesV1CandidV1SyncFulfillmentByOrderData, ThrowOnError>): RequestResult<ServicesV1CandidV1SyncFulfillmentByOrderResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1CandidV1SyncFulfillmentByOrderResponses, unknown, ThrowOnError>({
  url: '/api/v1/services/candid/sync-fulfillment-by-order',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const servicesV1CandidV1SyncRentalClaims = <ThrowOnError extends boolean = false>(options: Options<ServicesV1CandidV1SyncRentalClaimsData, ThrowOnError>): RequestResult<ServicesV1CandidV1SyncRentalClaimsResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1CandidV1SyncRentalClaimsResponses, unknown, ThrowOnError>({
  url: '/api/v1/services/candid/sync-rental-claims',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Create an Intercom ticket from a Customer.io webhook action.
 *
 * The Customer.io webhook body must send the raw JSON that this schema
 * describes, since the same raw bytes are what ``X-CIO-Signature`` is
 * computed over.
 *
 * When the request carries ``X-CIO-Idempotency-Key``, the created ticket id
 * is cached under that key so retries (from a lost/slow response or a manual
 * resend) return the original ticket instead of opening a duplicate.
 *
 * When ``order_id`` is present, the order is looked up to enrich structured
 * logs with ``is_resupply`` and ``confirmation_status``.
 */
export const servicesV1CustomerioV1PostCreateTicket = <ThrowOnError extends boolean = false>(options: Options<ServicesV1CustomerioV1PostCreateTicketData, ThrowOnError>): RequestResult<ServicesV1CustomerioV1PostCreateTicketResponses, ServicesV1CustomerioV1PostCreateTicketErrors, ThrowOnError> => (options.client ?? client).post<ServicesV1CustomerioV1PostCreateTicketResponses, ServicesV1CustomerioV1PostCreateTicketErrors, ThrowOnError>({
  url: '/api/v1/services/customerio/create-ticket',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const servicesV1EpacesV1GetEligibilityResponses = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1EpacesV1GetEligibilityResponsesData, ThrowOnError>): RequestResult<ServicesV1EpacesV1GetEligibilityResponsesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1EpacesV1GetEligibilityResponsesResponses, unknown, ThrowOnError>({ url: '/api/v1/services/epaces/eligibility', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1EpacesV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1EpacesV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1EpacesV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1EpacesV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/services/epaces/heartbeat', ...options });

export const servicesV1EpacesV1GetPriorAuthorizationResponses = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1EpacesV1GetPriorAuthorizationResponsesData, ThrowOnError>): RequestResult<ServicesV1EpacesV1GetPriorAuthorizationResponsesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1EpacesV1GetPriorAuthorizationResponsesResponses, unknown, ThrowOnError>({ url: '/api/v1/services/epaces/prior-authorization', ...options });

export const servicesV1EpacesV1GetPriorAuthorizationResponsesForOrder = <ThrowOnError extends boolean = false>(options: Options<ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderData, ThrowOnError>): RequestResult<ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1EpacesV1GetPriorAuthorizationResponsesForOrderResponses, unknown, ThrowOnError>({ url: '/api/v1/services/epaces/prior-authorization/{order_id}', ...options });

export const servicesV1EpacesV1CancelPriorAuthorizationsForOrder = <ThrowOnError extends boolean = false>(options: Options<ServicesV1EpacesV1CancelPriorAuthorizationsForOrderData, ThrowOnError>): RequestResult<ServicesV1EpacesV1CancelPriorAuthorizationsForOrderResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1EpacesV1CancelPriorAuthorizationsForOrderResponses, unknown, ThrowOnError>({ url: '/api/v1/services/epaces/prior-authorization/{order_id}/cancel', ...options });

export const servicesV1EpacesV1CancelPriorAuthorizationsForOrder2 = <ThrowOnError extends boolean = false>(options: Options<ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Data, ThrowOnError>): RequestResult<ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1EpacesV1CancelPriorAuthorizationsForOrder2Responses, unknown, ThrowOnError>({ url: '/api/v1/services/epaces/prior-authorization/{order_id}/cancel/{hcpc}', ...options });

export const servicesV1EpacesV1SubmitPriorAuthorizationForOrder = <ThrowOnError extends boolean = false>(options: Options<ServicesV1EpacesV1SubmitPriorAuthorizationForOrderData, ThrowOnError>): RequestResult<ServicesV1EpacesV1SubmitPriorAuthorizationForOrderResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1EpacesV1SubmitPriorAuthorizationForOrderResponses, unknown, ThrowOnError>({ url: '/api/v1/services/epaces/prior-authorization/{order_id}/submit', ...options });

export const servicesV1EpacesV1SubmitPriorAuthorizationForOrder2 = <ThrowOnError extends boolean = false>(options: Options<ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Data, ThrowOnError>): RequestResult<ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1EpacesV1SubmitPriorAuthorizationForOrder2Responses, unknown, ThrowOnError>({ url: '/api/v1/services/epaces/prior-authorization/{order_id}/submit/{hcpc}', ...options });

/**
 * Prioritized Order Discovery
 *
 * Run discovery for patient demographics of a given order and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpoint = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1PrioritizedDiscoveryByOrderEndpointResponses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/discovery/by-order/prioritized/{order_id}', ...options });

/**
 * Order Discovery
 *
 * Run discovery for patient demographics of a given order
 */
export const servicesV1FrontrunnerV1DiscoveryByOrderEndpoint = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1DiscoveryByOrderEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1DiscoveryByOrderEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1DiscoveryByOrderEndpointResponses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/discovery/by-order/{order_id}', ...options });

/**
 * Patient Discovery
 *
 * Run discovery for supplied patient demographics
 */
export const servicesV1FrontrunnerV1DiscoveryByPatientEndpoint = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1DiscoveryByPatientEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1DiscoveryByPatientEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1FrontrunnerV1DiscoveryByPatientEndpointResponses, unknown, ThrowOnError>({
  url: '/api/v1/services/frontrunner/discovery/by-patient',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Prioritized Patient Discovery
 *
 * Run discovery for supplied patient demographics and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpoint = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1FrontrunnerV1PrioritizedDiscoveryByPatientEndpointResponses, unknown, ThrowOnError>({
  url: '/api/v1/services/frontrunner/discovery/by-patient/prioritized',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Generate Kafka Message to Write FR data to Mongo
 *
 * Generate the message for kafka based on the same output generated by `mongo-discovery-source`
 */
export const getServicesV1FrontrunnerV1MongoDiscoveryEvent = <ThrowOnError extends boolean = false>(options: Options<GetServicesV1FrontrunnerV1MongoDiscoveryEventData, ThrowOnError>): RequestResult<GetServicesV1FrontrunnerV1MongoDiscoveryEventResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetServicesV1FrontrunnerV1MongoDiscoveryEventResponses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/discovery/mongo/event/{order_id}', ...options });

/**
 * Generate Kafka Message to Write FR data to Mongo
 *
 * Generate the message for kafka based on the same output generated by `mongo-discovery-source`
 */
export const postServicesV1FrontrunnerV1MongoDiscoveryEvent = <ThrowOnError extends boolean = false>(options: Options<PostServicesV1FrontrunnerV1MongoDiscoveryEventData, ThrowOnError>): RequestResult<PostServicesV1FrontrunnerV1MongoDiscoveryEventResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostServicesV1FrontrunnerV1MongoDiscoveryEventResponses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/discovery/mongo/event/{order_id}', ...options });

/**
 * Generate Order Discovery Source
 *
 * Run discovery for an order and return the source data used to create the frontrunner_discovery event
 */
export const servicesV1FrontrunnerV1MongoDiscoverySource = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1MongoDiscoverySourceData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1MongoDiscoverySourceResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1MongoDiscoverySourceResponses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/discovery/mongo/source/{order_id}', ...options });

/**
 * Prioritized Order Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpointResponses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/eligibility/by-order/prioritized/{order_id}', ...options });

/**
 * Prioritized Order Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2 = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Data, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1PrioritizedEligibilityByOrderEndpoint2Responses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/eligibility/by-order/prioritized/{order_id}/{member_id}', ...options });

/**
 * Order Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order
 */
export const servicesV1FrontrunnerV1EligibilityByOrderEndpoint = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1EligibilityByOrderEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1EligibilityByOrderEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1EligibilityByOrderEndpointResponses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/eligibility/by-order/{order_id}', ...options });

/**
 * Order Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order
 */
export const servicesV1FrontrunnerV1EligibilityByOrderEndpoint2 = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Data, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1EligibilityByOrderEndpoint2Responses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/eligibility/by-order/{order_id}/{member_id}', ...options });

/**
 * Patient Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order
 */
export const servicesV1FrontrunnerV1EligibilityByPatientEndpoint = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1EligibilityByPatientEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1EligibilityByPatientEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1FrontrunnerV1EligibilityByPatientEndpointResponses, unknown, ThrowOnError>({
  url: '/api/v1/services/frontrunner/eligibility/by-patient',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Prioritized Patient Eligibility
 *
 * Check patient eligibility based on an existing order and optional member_id or frhc_id that is already associated with the order and return prioritized results
 */
export const servicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpoint = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1FrontrunnerV1PrioritizedEligibilityByPatientEndpointResponses, unknown, ThrowOnError>({
  url: '/api/v1/services/frontrunner/eligibility/by-patient/prioritized',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Generate Kafka Message to Write FR data to Mongo
 *
 * Generate the message for kafka based on the same output generated by `/eligibility/mongo/source`
 */
export const servicesV1FrontrunnerV1MongoEligibilityEvent = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1MongoEligibilityEventData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1MongoEligibilityEventResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1MongoEligibilityEventResponses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/eligibility/mongo/event/{order_id}', ...options });

/**
 * Generate Kafka Message to Write FR data to Mongo
 *
 * Generate the message for kafka based on the same output generated by `/eligibility/mongo/source`
 */
export const servicesV1FrontrunnerV1MongoEligibilityEvent2 = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1MongoEligibilityEvent2Data, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1MongoEligibilityEvent2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1MongoEligibilityEvent2Responses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/eligibility/mongo/event/{order_id}/{member_id}', ...options });

/**
 * Generate Order eligibility Source
 *
 * Run eligibility for an order and return the source data used to create the frontrunner_eligibility event
 */
export const servicesV1FrontrunnerV1MongoEligibilitySource = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1MongoEligibilitySourceData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1MongoEligibilitySourceResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1MongoEligibilitySourceResponses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/eligibility/mongo/source/{order_id}', ...options });

/**
 * Generate Order eligibility Source
 *
 * Run eligibility for an order and return the source data used to create the frontrunner_eligibility event
 */
export const servicesV1FrontrunnerV1MongoEligibilitySource2 = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1MongoEligibilitySource2Data, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1MongoEligibilitySource2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1FrontrunnerV1MongoEligibilitySource2Responses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/eligibility/mongo/source/{order_id}/{member_id}', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1FrontrunnerV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1FrontrunnerV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1FrontrunnerV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/services/frontrunner/heartbeat', ...options });

export const servicesV1FrontrunnerV1MockDiscovery = <ThrowOnError extends boolean = false>(options: Options<ServicesV1FrontrunnerV1MockDiscoveryData, ThrowOnError>): RequestResult<ServicesV1FrontrunnerV1MockDiscoveryResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1FrontrunnerV1MockDiscoveryResponses, unknown, ThrowOnError>({
  url: '/api/v1/services/frontrunner/mocks/{subpath}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/services/heartbeat', ...options });

/**
 * Retrieve Contact Data
 *
 * Retrieve a list of contacts
 */
export const servicesV1HubspotV1Contacts = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1HubspotV1ContactsData, ThrowOnError>): RequestResult<ServicesV1HubspotV1ContactsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1HubspotV1ContactsResponses, unknown, ThrowOnError>({ url: '/api/v1/services/hubspot/contacts', ...options });

export const servicesV1HubspotV1IngestContacts = <ThrowOnError extends boolean = false>(options: Options<ServicesV1HubspotV1IngestContactsData, ThrowOnError>): RequestResult<ServicesV1HubspotV1IngestContactsResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1HubspotV1IngestContactsResponses, unknown, ThrowOnError>({
  url: '/api/v1/services/hubspot/contacts',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1HubspotV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1HubspotV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1HubspotV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1HubspotV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/services/hubspot/heartbeat', ...options });

/**
 * Retrieve Order Data
 *
 * Retrieve a list of orders
 */
export const servicesV1HubspotV1Orders = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1HubspotV1OrdersData, ThrowOnError>): RequestResult<ServicesV1HubspotV1OrdersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1HubspotV1OrdersResponses, unknown, ThrowOnError>({ url: '/api/v1/services/hubspot/orders', ...options });

export const servicesV1HubspotV1IngestOrders = <ThrowOnError extends boolean = false>(options: Options<ServicesV1HubspotV1IngestOrdersData, ThrowOnError>): RequestResult<ServicesV1HubspotV1IngestOrdersResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1HubspotV1IngestOrdersResponses, unknown, ThrowOnError>({
  url: '/api/v1/services/hubspot/orders',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Retrieve Product Data
 *
 * Retrieve a list of products
 */
export const servicesV1HubspotV1Products = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1HubspotV1ProductsData, ThrowOnError>): RequestResult<ServicesV1HubspotV1ProductsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1HubspotV1ProductsResponses, unknown, ThrowOnError>({ url: '/api/v1/services/hubspot/products', ...options });

/**
 * MCP-authorized route to send a reply to an Intercom conversation.
 */
export const servicesV1IntercomV1IntercomSendReply = <ThrowOnError extends boolean = false>(options: Options<ServicesV1IntercomV1IntercomSendReplyData, ThrowOnError>): RequestResult<ServicesV1IntercomV1IntercomSendReplyResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1IntercomV1IntercomSendReplyResponses, unknown, ThrowOnError>({
  url: '/api/v1/services/intercom/send-reply',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const servicesV1LuminaV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ServicesV1LuminaV1HeartbeatData, ThrowOnError>): RequestResult<ServicesV1LuminaV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV1LuminaV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/services/lumina/heartbeat', ...options });

/**
 * Order Submission to Lumina
 *
 * Kickoff Order Submission to Lumina Data
 */
export const servicesV1LuminaV1SubmitOrder = <ThrowOnError extends boolean = false>(options: Options<ServicesV1LuminaV1SubmitOrderData, ThrowOnError>): RequestResult<ServicesV1LuminaV1SubmitOrderResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV1LuminaV1SubmitOrderResponses, unknown, ThrowOnError>({ url: '/api/v1/services/lumina/submit-order/{order_id}', ...options });

/**
 * Accept Medline's daily shipment tracking report and queue it for ingestion.
 *
 * The report is archived to S3 and handed to a Celery task, so the caller gets a
 * ``202`` without waiting on the parse. The file arrives base64-encoded in the JSON
 * body, whose exact raw bytes the signature covers.
 *
 * Ingestion is idempotent, so re-pushing the same report is safe.
 */
export const servicesV1MedlineV1PostShipmentReport = <ThrowOnError extends boolean = false>(options: Options<ServicesV1MedlineV1PostShipmentReportData, ThrowOnError>): RequestResult<ServicesV1MedlineV1PostShipmentReportResponses, ServicesV1MedlineV1PostShipmentReportErrors, ThrowOnError> => (options.client ?? client).post<ServicesV1MedlineV1PostShipmentReportResponses, ServicesV1MedlineV1PostShipmentReportErrors, ThrowOnError>({
  url: '/api/v1/services/medline/shipment-report',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Accept pushed tracking snapshots and queue them for processing.
 *
 * Returns ``202`` before writing anything, so a slow write cannot cost the provider a
 * delivery retry. Processing is idempotent: each snapshot only lands if it is newer
 * than the one already stored, so a replay changes nothing.
 *
 * An employee replaying a payload by hand authenticates with a session cookie rather
 * than a bearer token, because a bearer on this path skips JWT validation.
 */
export const servicesV1Ship24V1PostTracking = <ThrowOnError extends boolean = false>(options: Options<ServicesV1Ship24V1PostTrackingData, ThrowOnError>): RequestResult<ServicesV1Ship24V1PostTrackingResponses, ServicesV1Ship24V1PostTrackingErrors, ThrowOnError> => (options.client ?? client).post<ServicesV1Ship24V1PostTrackingResponses, ServicesV1Ship24V1PostTrackingErrors, ThrowOnError>({
  url: '/api/v1/services/ship24/tracking',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const servicesV1SlackV1SlackPost = <ThrowOnError extends boolean = false>(options: Options<ServicesV1SlackV1SlackPostData, ThrowOnError>): RequestResult<ServicesV1SlackV1SlackPostResponses, unknown, ThrowOnError> => (options.client ?? client).post<ServicesV1SlackV1SlackPostResponses, unknown, ThrowOnError>({
  url: '/api/v1/services/slack/send-message',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get all Suppliers
 */
export const suppliersV1GetAllSuppliers = <ThrowOnError extends boolean = false>(options?: Options<SuppliersV1GetAllSuppliersData, ThrowOnError>): RequestResult<SuppliersV1GetAllSuppliersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuppliersV1GetAllSuppliersResponses, unknown, ThrowOnError>({ url: '/api/v1/suppliers/all', ...options });

/**
 * Details
 *
 * Retrieve the extended Supplier record by uuid
 */
export const suppliersV1Details = <ThrowOnError extends boolean = false>(options: Options<SuppliersV1DetailsData, ThrowOnError>): RequestResult<SuppliersV1DetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SuppliersV1DetailsResponses, unknown, ThrowOnError>({ url: '/api/v1/suppliers/details/{supplier_id}', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const suppliersV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<SuppliersV1HeartbeatData, ThrowOnError>): RequestResult<SuppliersV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuppliersV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/suppliers/heartbeat', ...options });

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const suppliersV1Search = <ThrowOnError extends boolean = false>(options?: Options<SuppliersV1SearchData, ThrowOnError>): RequestResult<SuppliersV1SearchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuppliersV1SearchResponses, unknown, ThrowOnError>({ url: '/api/v1/suppliers/search', ...options });

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const suppliersV1Search2 = <ThrowOnError extends boolean = false>(options: Options<SuppliersV1Search2Data, ThrowOnError>): RequestResult<SuppliersV1Search2Responses, unknown, ThrowOnError> => (options.client ?? client).get<SuppliersV1Search2Responses, unknown, ThrowOnError>({ url: '/api/v1/suppliers/search/{category}', ...options });

/**
 * Sync Aggregate Legacy Contacts
 *
 * Regenerate contents of AggregateLegacyContacts Table
 */
export const systemV1AggregateLegacyContacts = <ThrowOnError extends boolean = false>(options?: Options<SystemV1AggregateLegacyContactsData, ThrowOnError>): RequestResult<SystemV1AggregateLegacyContactsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1AggregateLegacyContactsResponses, unknown, ThrowOnError>({ url: '/api/v1/system/aggregate-legacy-contacts', ...options });

/**
 * Rewrite mismatched ``orders.uuid`` values to match ``order_transitions.uuid``.
 *
 * Racey create paths can insert a Postgres order and order transition for the
 * same Mongo ``order_id`` with different uuids. Fulfillments, claims, and
 * order assets already reference the transition uuid, so this keeps that uuid
 * and retargets the order row plus child FKs (insurances, contacts,
 * prescriptions, appointments, status history, notes, shipments, child
 * ``parent_order_uuid``).
 *
 * Pass ``{"dry_run": true}`` to classify ids without writing. At most 100 ids
 * per request. Duplicate ids are ignored. Multiple order transitions for one
 * id are skipped.
 */
export const systemV1AlignOrderUuids = <ThrowOnError extends boolean = false>(options: Options<SystemV1AlignOrderUuidsData, ThrowOnError>): RequestResult<SystemV1AlignOrderUuidsResponses, SystemV1AlignOrderUuidsErrors, ThrowOnError> => (options.client ?? client).post<SystemV1AlignOrderUuidsResponses, SystemV1AlignOrderUuidsErrors, ThrowOnError>({
  url: '/api/v1/system/align-order-uuids',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const systemV1AnalyzeProgressNoteRoute = <ThrowOnError extends boolean = false>(options: Options<SystemV1AnalyzeProgressNoteRouteData, ThrowOnError>): RequestResult<SystemV1AnalyzeProgressNoteRouteResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1AnalyzeProgressNoteRouteResponses, unknown, ThrowOnError>({
  ...formDataBodySerializer,
  url: '/api/v1/system/analyze-progress-note',
  ...options,
  headers: {
    'Content-Type': null,
    ...options.headers
  }
});

/**
 * Backfill empty ``fulfillments.hcpcs_code_uuid`` from each fee schedule.
 *
 * Celery task reads fulfillments in batches where ``hcpcs_code_uuid`` is null
 * and a ``fee_schedule_uuid`` is set, then copies the fee schedule's
 * ``code_uuid`` onto the fulfillment.
 *
 * Query params (optional):
 * single_batch: if truthy (e.g. ?single_batch=1), run only one batch.
 * batch_size: positive integer batch size (default 500).
 */
export const systemV1BackfillFulfillmentHcpcsCodesRoute = <ThrowOnError extends boolean = false>(options?: Options<SystemV1BackfillFulfillmentHcpcsCodesRouteData, ThrowOnError>): RequestResult<SystemV1BackfillFulfillmentHcpcsCodesRouteResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1BackfillFulfillmentHcpcsCodesRouteResponses, unknown, ThrowOnError>({ url: '/api/v1/system/backfill-fulfillment-hcpcs-codes', ...options });

/**
 * Stamp CareOS ``plan_uuid`` onto Mongo order insurance from CareOS Plan
 *
 * lookup by ``frhc_id`` + state + plan_type + name/alias.
 *
 * Only non-final / pre-billing orders (excludes ``DONE`` / ``CANCELLED`` /
 * ``ERROR`` / ``BILLING``).
 *
 * General run (omit ``frhc_ids`` and ``stedi_ids``): active orders with a
 * FrontRunner id (``frhc_id``, or if that is empty, ``trading_partner_id``) or a
 * Stedi payer id. Stamps mapped carriers and clears stale ``plan_uuid`` stamps.
 *
 * Scoped run (``frhc_ids`` and/or ``stedi_ids`` set): refresh slots for those
 * clearinghouse payer ids after a CareOS Plan mapping change.
 *
 * Pass ``{"dry_run": true}`` to count matches without writing. Pass
 * ``{"single_batch": true, "batch_size": 1000}`` to process one chunk then stop.
 * Always enqueues the Celery task (including dry runs) and returns
 * ``{"task_id": "..."}`` with 202.
 */
export const systemV1BackfillInsurancePlanUuidRoute = <ThrowOnError extends boolean = false>(options: Options<SystemV1BackfillInsurancePlanUuidRouteData, ThrowOnError>): RequestResult<SystemV1BackfillInsurancePlanUuidRouteResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1BackfillInsurancePlanUuidRouteResponses, unknown, ThrowOnError>({
  url: '/api/v1/system/backfill-insurance-plan-uuid',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Copy ``organization_id`` from legacy suppliers onto Postgres ``suppliers``.
 *
 * Matches ``suppliers.integrations.conduithealth.legacy_id`` to
 * ``supplier.id`` on the ``legacy_supplier`` bind. Pass ``{"dry_run": true}``
 * to classify without writing. Safe to re-run.
 */
export const systemV1BackfillSupplierOrganizationIdRoute = <ThrowOnError extends boolean = false>(options: Options<SystemV1BackfillSupplierOrganizationIdRouteData, ThrowOnError>): RequestResult<SystemV1BackfillSupplierOrganizationIdRouteResponses, SystemV1BackfillSupplierOrganizationIdRouteErrors, ThrowOnError> => (options.client ?? client).post<SystemV1BackfillSupplierOrganizationIdRouteResponses, SystemV1BackfillSupplierOrganizationIdRouteErrors, ThrowOnError>({
  url: '/api/v1/system/backfill-supplier-organization-id',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Compare Mongo vs Postgres v1 order-detail payloads.
 *
 * Runs ``compare_order_detail_contract.run`` in-process (not enqueued). Pass
 * ``order_id`` to compare a specific legacy order; omit it to sample one
 * stale Mongo order. The comparison result is the response body.
 */
export const systemV1CompareOrderDetailContractRoute = <ThrowOnError extends boolean = false>(options?: Options<SystemV1CompareOrderDetailContractRouteData, ThrowOnError>): RequestResult<SystemV1CompareOrderDetailContractRouteResponses, SystemV1CompareOrderDetailContractRouteErrors, ThrowOnError> => (options?.client ?? client).get<SystemV1CompareOrderDetailContractRouteResponses, SystemV1CompareOrderDetailContractRouteErrors, ThrowOnError>({ url: '/api/v1/system/compare-order-detail-contract', ...options });

/**
 * Queue conversion events for server-side attribution tracking.
 */
export const systemV1MessageConversionEvents = <ThrowOnError extends boolean = false>(options: Options<SystemV1MessageConversionEventsData, ThrowOnError>): RequestResult<SystemV1MessageConversionEventsResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1MessageConversionEventsResponses, unknown, ThrowOnError>({
  url: '/api/v1/system/conversion-events',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * EPaces
 *
 * Display the contents of an epaces form
 */
export const systemV1Epaces = <ThrowOnError extends boolean = false>(options?: Options<SystemV1EpacesData, ThrowOnError>): RequestResult<SystemV1EpacesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1EpacesResponses, unknown, ThrowOnError>({ url: '/api/v1/system/epaces', ...options });

/**
 * Failed Fulfillment / Resupply Diagnostic
 *
 * Lists orders from order_confirmation_gate-enabled suppliers that are in a
 * qualifying status, have no resupply order, and failed to resupply due to
 * fulfillment misconfiguration.
 *
 * Query params:
 * created_after (required, YYYY-MM-DD): Lower bound for order creation date.
 * created_before (required, YYYY-MM-DD): Upper bound for order creation date.
 *
 * Failure classes per order:
 * missing_hcpc: item(s) with empty hcpc_code.
 * unknown_hcpc: item HCPC label not found in the PG codes table.
 * no_fee_schedule: HCPC known but no fee schedule attached.
 * missing_icd: item(s) with empty icds.
 * unknown_failure: no PG fulfillments and items appear configured.
 * missing_shipping_address: shipping address missing required fields for Candid submission.
 */
export const systemV1FailedFulfillmentResupply = <ThrowOnError extends boolean = false>(options: Options<SystemV1FailedFulfillmentResupplyData, ThrowOnError>): RequestResult<SystemV1FailedFulfillmentResupplyResponses, unknown, ThrowOnError> => (options.client ?? client).get<SystemV1FailedFulfillmentResupplyResponses, unknown, ThrowOnError>({ url: '/api/v1/system/failed-fulfillment-resupply', ...options });

export const systemV1GenerateLomnRoute = <ThrowOnError extends boolean = false>(options: Options<SystemV1GenerateLomnRouteData, ThrowOnError>): RequestResult<SystemV1GenerateLomnRouteResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1GenerateLomnRouteResponses, unknown, ThrowOnError>({
  ...formDataBodySerializer,
  url: '/api/v1/system/generate-lomn',
  ...options,
  headers: {
    'Content-Type': null,
    ...options.headers
  }
});

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const systemV1Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<SystemV1HeartbeatData, ThrowOnError>): RequestResult<SystemV1HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v1/system/heartbeat', ...options });

/**
 * Generate Kafka Message
 *
 * Generate an arbitrary message to the indicated topic
 */
export const systemV1ProduceMessage = <ThrowOnError extends boolean = false>(options: Options<SystemV1ProduceMessageData, ThrowOnError>): RequestResult<SystemV1ProduceMessageResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1ProduceMessageResponses, unknown, ThrowOnError>({
  url: '/api/v1/system/kafka-message/{topic}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const systemV1LomnHistory = <ThrowOnError extends boolean = false>(options: Options<SystemV1LomnHistoryData, ThrowOnError>): RequestResult<SystemV1LomnHistoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<SystemV1LomnHistoryResponses, unknown, ThrowOnError>({ url: '/api/v1/system/lomn-history/{order_id}', ...options });

export const systemV1LomnPdf = <ThrowOnError extends boolean = false>(options: Options<SystemV1LomnPdfData, ThrowOnError>): RequestResult<SystemV1LomnPdfResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1LomnPdfResponses, unknown, ThrowOnError>({ url: '/api/v1/system/lomn-pdf/{order_id}', ...options });

/**
 * Repopulate all LOMN requirement tables from the PRODUCT_REQUIREMENTS dict.
 *
 * Blocked when LOMN_REQUIREMENTS_FROM_DB=True to prevent overwriting
 * live DB-managed data after flag cutover.
 */
export const systemV1LomnRequirementsPopulate = <ThrowOnError extends boolean = false>(options?: Options<SystemV1LomnRequirementsPopulateData, ThrowOnError>): RequestResult<SystemV1LomnRequirementsPopulateResponses, unknown, ThrowOnError> => (options?.client ?? client).post<SystemV1LomnRequirementsPopulateResponses, unknown, ThrowOnError>({ url: '/api/v1/system/lomn-requirements/populate', ...options });

export const systemV1LomnRequirements = <ThrowOnError extends boolean = false>(options: Options<SystemV1LomnRequirementsData, ThrowOnError>): RequestResult<SystemV1LomnRequirementsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SystemV1LomnRequirementsResponses, unknown, ThrowOnError>({ url: '/api/v1/system/lomn-requirements/{order_id}', ...options });

/**
 * Migrate one legacy MySQL patient and related data into Postgres.
 */
export const systemV1MigrateLegacyPatientRoute = <ThrowOnError extends boolean = false>(options: Options<SystemV1MigrateLegacyPatientRouteData, ThrowOnError>): RequestResult<SystemV1MigrateLegacyPatientRouteResponses, SystemV1MigrateLegacyPatientRouteErrors, ThrowOnError> => (options.client ?? client).post<SystemV1MigrateLegacyPatientRouteResponses, SystemV1MigrateLegacyPatientRouteErrors, ThrowOnError>({
  url: '/api/v1/system/migrate-legacy-patient',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Migrate one Mongo order's missing ancestry, then remigrate the child.
 *
 * This explicit repair endpoint keeps ancestry traversal out of the normal
 * batch and ad hoc migration paths.
 */
export const systemV1MigrateMongoOrderAncestry = <ThrowOnError extends boolean = false>(options: Options<SystemV1MigrateMongoOrderAncestryData, ThrowOnError>): RequestResult<SystemV1MigrateMongoOrderAncestryResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1MigrateMongoOrderAncestryResponses, unknown, ThrowOnError>({
  url: '/api/v1/system/migrate-mongo-order-ancestry',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Migrate Mongo orders into Postgres orders bind tables.
 *
 * Celery task reads legacy Mongo orders in batches and creates or updates
 * ``orders`` and related rows by ``orders.legacy_id``.
 *
 * Query params (optional):
 * single_batch: if truthy (e.g. ?single_batch=1), run only one batch of 500.
 * starting_mongo_order_id: integer; first batch loads Mongo orders with
 * ``order_id >=`` this value, then continues in batches of 500 by ascending id.
 */
export const systemV1MigrateMongoOrdersRoute = <ThrowOnError extends boolean = false>(options?: Options<SystemV1MigrateMongoOrdersRouteData, ThrowOnError>): RequestResult<SystemV1MigrateMongoOrdersRouteResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1MigrateMongoOrdersRouteResponses, unknown, ThrowOnError>({ url: '/api/v1/system/migrate-mongo-orders', ...options });

export const systemV1MongoHealth = <ThrowOnError extends boolean = false>(options?: Options<SystemV1MongoHealthData, ThrowOnError>): RequestResult<SystemV1MongoHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1MongoHealthResponses, unknown, ThrowOnError>({ url: '/api/v1/system/mongo/health', ...options });

/**
 * Missing Order Transition Diagnostic
 *
 * Lists orders from order_confirmation_gate-enabled suppliers that are in a
 * qualifying resupply status, have no resupply_order, and are missing a
 * PostgreSQL OrderTransition record. These represent data-integrity gaps
 * where Mongo shows a shipped/billed order but the PG fulfillment pipeline
 * lost or never created the OT. The resupply task returns UNCONFIRMED ORDER
 * for these until the OT is backfilled.
 *
 * Query params:
 * created_after (required, YYYY-MM-DD): Lower bound for order creation date.
 * created_before (required, YYYY-MM-DD): Upper bound for order creation date.
 */
export const systemV1OrdersMissingOt = <ThrowOnError extends boolean = false>(options: Options<SystemV1OrdersMissingOtData, ThrowOnError>): RequestResult<SystemV1OrdersMissingOtResponses, unknown, ThrowOnError> => (options.client ?? client).get<SystemV1OrdersMissingOtResponses, unknown, ThrowOnError>({ url: '/api/v1/system/orders-missing-ot', ...options });

export const systemV1PdfReader = <ThrowOnError extends boolean = false>(options: Options<SystemV1PdfReaderData, ThrowOnError>): RequestResult<SystemV1PdfReaderResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1PdfReaderResponses, unknown, ThrowOnError>({
  ...formDataBodySerializer,
  url: '/api/v1/system/pdf-reader',
  ...options,
  headers: {
    'Content-Type': null,
    ...options.headers
  }
});

/**
 * Move CONTACTING_PATIENT orders to CONFIRM_ORDER if they pass the auth gate.
 *
 * For each order ID the Celery task will:
 * 1. Load the order and verify status is CONTACTING_PATIENT.
 * 2. Check the auth gate (same logic as validate_resupply):
 * - Must have a valid e-signature / prescription.
 * - Embargo date must be before prescription expiration.
 * 3. Transition CONTACTING_PATIENT → PROCESSING → CONFIRM_ORDER.
 *
 * Orders are chunked into batches of 100 and dispatched as async Celery
 * tasks. Each task result is a dict::
 *
 * {"succeeded": [...], "failed": {...}, "ignored": {...}}
 *
 * JSON body:
 * order_ids: list of integer order IDs (min 1, no upper cap).
 */
export const systemV1PromoteToConfirmOrder = <ThrowOnError extends boolean = false>(options: Options<SystemV1PromoteToConfirmOrderData, ThrowOnError>): RequestResult<SystemV1PromoteToConfirmOrderResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1PromoteToConfirmOrderResponses, unknown, ThrowOnError>({
  url: '/api/v1/system/promote-to-confirm-order',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Force-re-run insurance discovery for the given orders.
 *
 * Each order is enqueued as its own Celery task that runs ``process_order_discovery``
 * (force=True) from a worker — so ChangeLog writes are attributed to ``"system"`` and
 * manually-verified slots are preserved. Uses the unscoped provider set, which may
 * differ from what the Order Details buttons run. At most 100 ids per request; chunk
 * larger backfills across calls.
 *
 * JSON body:
 * order_ids: required list of Mongo order ids, e.g. ``{"order_ids": [1, 2, 3]}``.
 */
export const systemV1RerunInsuranceDiscovery = <ThrowOnError extends boolean = false>(options: Options<SystemV1RerunInsuranceDiscoveryData, ThrowOnError>): RequestResult<SystemV1RerunInsuranceDiscoveryResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1RerunInsuranceDiscoveryResponses, unknown, ThrowOnError>({
  url: '/api/v1/system/rerun-insurance-discovery',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Bulk-resync prescription_order + prescription_expiration for is_resupply orders.
 *
 * Reads authoritative values from the root_order pipeline and writes back via
 * the ORM (capturing change-log entries). Idempotent — already-correct orders
 * are counted but not written.
 *
 * JSON body (all optional)::
 *
 * order_ids:      Explicit list of integer order IDs. When provided, supersedes
 * created_after/created_before (no Mongo date-range query).
 * created_after:  Lower date bound, YYYY-MM-DD (default: 2026-05-01).
 * created_before: Upper date bound, YYYY-MM-DD (default: today, inclusive).
 * dry_run:        true = count + sample without writing (default: false).
 *
 * Dry-run response (200)::
 *
 * {
 * "metadata": {"version": 1, "timestamp": "...",
 * "function_profile": {...}, "input_parameters": {...}},
 * "payload":  {"dry_run": true, "total": N, "sample_order_ids": [...]}
 * }
 *
 * Live response (202)::
 *
 * {
 * "metadata": {"version": 1, "timestamp": "...",
 * "function_profile": {...}, "input_parameters": {...}},
 * "payload":  {"dry_run": false, "total": N, "batches": K,
 * "tasks": [{"task_id": "...", "order_ids": [...]}]}
 * }
 */
export const systemV1ResyncPrescriptionFields = <ThrowOnError extends boolean = false>(options: Options<SystemV1ResyncPrescriptionFieldsData, ThrowOnError>): RequestResult<SystemV1ResyncPrescriptionFieldsResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1ResyncPrescriptionFieldsResponses, unknown, ThrowOnError>({
  url: '/api/v1/system/resync-prescription-fields',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Register tracking-provider trackers for shipments, on demand.
 *
 * The scheduled task covers new shipments. This is for the two cases it does not: a
 * first run against the existing backlog, and registering specific tracking numbers
 * that the eligibility filter skips, which is how the seeded sample rows are set up in
 * a lower environment.
 *
 * Each tracker spends a shipment credit, so pass ``{"dry_run": true}`` to count
 * matches first, and ``{"limit": N}`` to cap how many a single run will buy. Always
 * enqueues the task and returns ``{"task_id": "..."}`` with 202.
 */
export const systemV1Ship24RegisterTrackersRoute = <ThrowOnError extends boolean = false>(options: Options<SystemV1Ship24RegisterTrackersRouteData, ThrowOnError>): RequestResult<SystemV1Ship24RegisterTrackersRouteResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1Ship24RegisterTrackersRouteResponses, unknown, ThrowOnError>({
  url: '/api/v1/system/ship24/register-trackers',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Insert the provider's reserved sample shipments in a lower environment.
 *
 * The samples return a synthetic event history, so registering them drives real
 * webhooks through the real route. Re-running inserts nothing and costs nothing.
 *
 * Blocked in production, where these are not real shipments. Register them afterwards
 * with ``POST /system/ship24/register-trackers`` and the returned tracking numbers,
 * since the scheduled task skips them by design.
 */
export const systemV1Ship24SeedSamplesRoute = <ThrowOnError extends boolean = false>(options?: Options<SystemV1Ship24SeedSamplesRouteData, ThrowOnError>): RequestResult<SystemV1Ship24SeedSamplesRouteResponses, SystemV1Ship24SeedSamplesRouteErrors, ThrowOnError> => (options?.client ?? client).post<SystemV1Ship24SeedSamplesRouteResponses, SystemV1Ship24SeedSamplesRouteErrors, ThrowOnError>({ url: '/api/v1/system/ship24/seed-samples', ...options });

/**
 * Enqueue Customer.io order syncs for the given Postgres order ids.
 *
 * Each order is enqueued as its own Celery task on the ``customerio`` queue.
 * At most 100 ids per request.
 *
 * JSON body:
 * order_ids: required list of Postgres order ids, e.g. ``{"order_ids": [1, 2, 3]}``.
 */
export const systemV1SyncCioOrdersById = <ThrowOnError extends boolean = false>(options: Options<SystemV1SyncCioOrdersByIdData, ThrowOnError>): RequestResult<SystemV1SyncCioOrdersByIdResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1SyncCioOrdersByIdResponses, unknown, ThrowOnError>({
  url: '/api/v1/system/sync-cio-orders-by-id',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Manually sync Intercom conversations that never triggered the inbound webhook
 *
 * (e.g. a sender was briefly misflagged as spam by Intercom).
 *
 * Each conversation is fetched from Intercom and dispatched into the same
 * email-agent pipeline the live webhook uses, as its own Celery task on the
 * ``email-agent`` queue. At most 25 ids per request.
 *
 * Conversations that already have an ``IntercomThread`` row (already processed
 * at least once) are skipped by default to avoid re-triggering the agent on an
 * old message. Pass ``"force": true`` to sync them anyway.
 *
 * JSON body:
 * conversation_ids: required list of Intercom conversation ids,
 * e.g. ``{"conversation_ids": ["123", "456"]}``.
 * force: optional bool, default false.
 */
export const systemV1SyncIntercomConvoById = <ThrowOnError extends boolean = false>(options: Options<SystemV1SyncIntercomConvoByIdData, ThrowOnError>): RequestResult<SystemV1SyncIntercomConvoByIdResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1SyncIntercomConvoByIdResponses, unknown, ThrowOnError>({
  url: '/api/v1/system/sync-intercom-convo-by-id',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Re-sync Mongo orders into Postgres by integer ``order_id``.
 *
 * Celery task loads current Mongo documents and upserts ``orders`` and related
 * rows (same as the batch migrator). Use when documents changed after the
 * initial migration. At most 100 ids per request.
 *
 * JSON body:
 * mongo_order_ids: required list of Mongo order ids, e.g. ``{"mongo_order_ids": [1, 2, 3]}``.
 */
export const systemV1SyncMongoOrdersById = <ThrowOnError extends boolean = false>(options: Options<SystemV1SyncMongoOrdersByIdData, ThrowOnError>): RequestResult<SystemV1SyncMongoOrdersByIdResponses, unknown, ThrowOnError> => (options.client ?? client).post<SystemV1SyncMongoOrdersByIdResponses, unknown, ThrowOnError>({
  url: '/api/v1/system/sync-mongo-orders-by-id',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const systemV1TriggerResupplyReport = <ThrowOnError extends boolean = false>(options?: Options<SystemV1TriggerResupplyReportData, ThrowOnError>): RequestResult<SystemV1TriggerResupplyReportResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemV1TriggerResupplyReportResponses, unknown, ThrowOnError>({ url: '/api/v1/system/trigger-resupply-report', ...options });

export const usersV1CreateUser = <ThrowOnError extends boolean = false>(options: Options<UsersV1CreateUserData, ThrowOnError>): RequestResult<UsersV1CreateUserResponses, unknown, ThrowOnError> => (options.client ?? client).post<UsersV1CreateUserResponses, unknown, ThrowOnError>({
  url: '/api/v1/users',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const usersV1ActivateUser = <ThrowOnError extends boolean = false>(options: Options<UsersV1ActivateUserData, ThrowOnError>): RequestResult<UsersV1ActivateUserResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UsersV1ActivateUserResponses, unknown, ThrowOnError>({ url: '/api/v1/users/activate/{user_id}', ...options });

export const usersV1ListCommunicationPreferences = <ThrowOnError extends boolean = false>(options?: Options<UsersV1ListCommunicationPreferencesData, ThrowOnError>): RequestResult<UsersV1ListCommunicationPreferencesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersV1ListCommunicationPreferencesResponses, unknown, ThrowOnError>({ url: '/api/v1/users/communication-preferences', ...options });

export const usersV1UpdateCommunicationPreferences = <ThrowOnError extends boolean = false>(options: Options<UsersV1UpdateCommunicationPreferencesData, ThrowOnError>): RequestResult<UsersV1UpdateCommunicationPreferencesResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UsersV1UpdateCommunicationPreferencesResponses, unknown, ThrowOnError>({
  url: '/api/v1/users/communication-preferences',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const usersV1SearchUsers = <ThrowOnError extends boolean = false>(options?: Options<UsersV1SearchUsersData, ThrowOnError>): RequestResult<UsersV1SearchUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersV1SearchUsersResponses, unknown, ThrowOnError>({ url: '/api/v1/users/search', ...options });

export const usersV1DeleteUser = <ThrowOnError extends boolean = false>(options: Options<UsersV1DeleteUserData, ThrowOnError>): RequestResult<UsersV1DeleteUserResponses, unknown, ThrowOnError> => (options.client ?? client).delete<UsersV1DeleteUserResponses, unknown, ThrowOnError>({ url: '/api/v1/users/{user_id}', ...options });

export const usersV1GetUser = <ThrowOnError extends boolean = false>(options: Options<UsersV1GetUserData, ThrowOnError>): RequestResult<UsersV1GetUserResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersV1GetUserResponses, unknown, ThrowOnError>({ url: '/api/v1/users/{user_id}', ...options });

export const usersV1UpdateUser = <ThrowOnError extends boolean = false>(options: Options<UsersV1UpdateUserData, ThrowOnError>): RequestResult<UsersV1UpdateUserResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UsersV1UpdateUserResponses, unknown, ThrowOnError>({
  url: '/api/v1/users/{user_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get list of carriers for a given state
 */
export const insuranceV2GetCarriersByState = <ThrowOnError extends boolean = false>(options: Options<InsuranceV2GetCarriersByStateData, ThrowOnError>): RequestResult<InsuranceV2GetCarriersByStateResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2GetCarriersByStateResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/carriers/{state}', ...options });

/**
 * Get all CoverageZones
 */
export const insuranceV2GetCoverageZones = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV2GetCoverageZonesData, ThrowOnError>): RequestResult<InsuranceV2GetCoverageZonesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV2GetCoverageZonesResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/coverage_zones/all', ...options });

/**
 * Get active per-plan fee schedules for a given plan UUID.
 *
 * Supports server-side filtering (``q``), sorting (``sort_by``,
 * ``sort_direction``), and pagination (``page``, ``limit``).
 * Returns an empty ``payload`` list when the plan has no per-plan rows —
 * never 404 on an empty result.
 */
export const insuranceV2GetPlanFeeSchedules = <ThrowOnError extends boolean = false>(options: Options<InsuranceV2GetPlanFeeSchedulesData, ThrowOnError>): RequestResult<InsuranceV2GetPlanFeeSchedulesResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2GetPlanFeeSchedulesResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/fee_schedule/plan/{plan_uuid}', ...options });

/**
 * Bulk-create/update per-plan fee schedule rows from a CSV upload.
 *
 * Accepts ``multipart/form-data`` with a ``file`` field — CSV in the format:
 * ``code,fee,rental_fee,max_units,pa,max_refills`` (also accepts ``hcpc_code``).
 *
 * Creates a ``PlanFeeScheduleSubmission`` record and runs validate+ingest
 * atomically.  Returns 200 with the ingest result regardless of partial
 * row-level failures; callers inspect ``errors`` to determine individual
 * row outcomes.
 */
export const insuranceV2BulkUploadPlanFeeSchedules = <ThrowOnError extends boolean = false>(options: Options<InsuranceV2BulkUploadPlanFeeSchedulesData, ThrowOnError>): RequestResult<InsuranceV2BulkUploadPlanFeeSchedulesResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV2BulkUploadPlanFeeSchedulesResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/fee_schedule/plan/{plan_uuid}/bulk_upload', ...options });

/**
 * Seed per-plan fee schedules from a template carrier+zone or another plan.
 *
 * JSON body — exactly one source required:
 *
 * * ``source_plan_uuid``: duplicate from another plan's per-plan rows.
 * * ``source_carrier_uuid`` + ``source_coverage_zone_uuid``: copy from
 * template rows (``plan_uuid IS NULL``) for that carrier+zone pair.
 *
 * Optional:
 *
 * * ``modifier_pct`` (float, default 100): scale ``fee`` and ``rental_fee``
 * by this percentage before ingesting (100 = no change).
 *
 * Fetches source rows server-side, builds a CSV, creates a
 * ``PlanFeeScheduleSubmission``, runs validate+ingest atomically, and returns
 * the same ``{submission_uuid, created, updated, errors}`` envelope as
 * ``bulk_upload``.
 */
export const insuranceV2SeedPlanFeeSchedules = <ThrowOnError extends boolean = false>(options: Options<InsuranceV2SeedPlanFeeSchedulesData, ThrowOnError>): RequestResult<InsuranceV2SeedPlanFeeSchedulesResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV2SeedPlanFeeSchedulesResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/fee_schedule/plan/{plan_uuid}/seed', ...options });

/**
 * Return distinct (carrier, coverage_zone) pairs that have active template fee
 *
 * schedules (plan_uuid IS NULL) in the same state as the given plan.
 *
 * Used by the UI bulk-add form to populate the "Generate from template" picker.
 * Returns 200 with an empty payload if the plan is not found or has no matching
 * template sources.
 */
export const insuranceV2GetPlanFeeScheduleTemplateSources = <ThrowOnError extends boolean = false>(options: Options<InsuranceV2GetPlanFeeScheduleTemplateSourcesData, ThrowOnError>): RequestResult<InsuranceV2GetPlanFeeScheduleTemplateSourcesResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2GetPlanFeeScheduleTemplateSourcesResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/fee_schedule/plan/{plan_uuid}/template_sources', ...options });

/**
 * Refills
 *
 * Retrieve the max refills Insurance record by product code(s) and insurance carrier
 */
export const insuranceV2Refills = <ThrowOnError extends boolean = false>(options: Options<InsuranceV2RefillsData, ThrowOnError>): RequestResult<InsuranceV2RefillsResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2RefillsResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/fee_schedule/{carrier}/{state}', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const insuranceV2Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV2HeartbeatData, ThrowOnError>): RequestResult<InsuranceV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV2HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/heartbeat', ...options });

export const insuranceV2SearchIcds = <ThrowOnError extends boolean = false>(options: Options<InsuranceV2SearchIcdsData, ThrowOnError>): RequestResult<InsuranceV2SearchIcdsResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2SearchIcdsResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/icds/search', ...options });

export const insuranceV2GetPrimaryIcds = <ThrowOnError extends boolean = false>(options: Options<InsuranceV2GetPrimaryIcdsData, ThrowOnError>): RequestResult<InsuranceV2GetPrimaryIcdsResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2GetPrimaryIcdsResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/icds/{hcpc}/qualifying', ...options });

/**
 * Get product details for a given carrier & state using a legacy id
 */
export const insuranceV2GetCarrierProductLegacy = <ThrowOnError extends boolean = false>(options: Options<InsuranceV2GetCarrierProductLegacyData, ThrowOnError>): RequestResult<InsuranceV2GetCarrierProductLegacyResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2GetCarrierProductLegacyResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/{carrier}/{state}/legacy_product/{legacy_product_id}', ...options });

/**
 * Get via Carrier/State
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV2GetCarrierProduct = <ThrowOnError extends boolean = false>(options: Options<InsuranceV2GetCarrierProductData, ThrowOnError>): RequestResult<InsuranceV2GetCarrierProductResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2GetCarrierProductResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/{carrier}/{state}/product/{carrier_coverage_product_uuid}', ...options });

/**
 * Get via Carrier/State
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const insuranceV2GetCarrierProducts = <ThrowOnError extends boolean = false>(options: Options<InsuranceV2GetCarrierProductsData, ThrowOnError>): RequestResult<InsuranceV2GetCarrierProductsResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV2GetCarrierProductsResponses, unknown, ThrowOnError>({ url: '/api/v2/insurance/{carrier}/{state}/products', ...options });

export const npiV2SearchProviders = <ThrowOnError extends boolean = false>(options?: Options<NpiV2SearchProvidersData, ThrowOnError>): RequestResult<NpiV2SearchProvidersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<NpiV2SearchProvidersResponses, unknown, ThrowOnError>({ url: '/api/v2/npi/search', ...options });

export const npiV2GetProvider = <ThrowOnError extends boolean = false>(options: Options<NpiV2GetProviderData, ThrowOnError>): RequestResult<NpiV2GetProviderResponses, unknown, ThrowOnError> => (options.client ?? client).get<NpiV2GetProviderResponses, unknown, ThrowOnError>({ url: '/api/v2/npi/{npi}', ...options });

export const npiV2UpdateProvider = <ThrowOnError extends boolean = false>(options: Options<NpiV2UpdateProviderData, ThrowOnError>): RequestResult<NpiV2UpdateProviderResponses, unknown, ThrowOnError> => (options.client ?? client).patch<NpiV2UpdateProviderResponses, unknown, ThrowOnError>({
  url: '/api/v2/npi/{npi}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const npiV2AddProviderAddress = <ThrowOnError extends boolean = false>(options: Options<NpiV2AddProviderAddressData, ThrowOnError>): RequestResult<NpiV2AddProviderAddressResponses, unknown, ThrowOnError> => (options.client ?? client).post<NpiV2AddProviderAddressResponses, unknown, ThrowOnError>({
  url: '/api/v2/npi/{npi}/addresses',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const npiV2UpdateProviderAddress = <ThrowOnError extends boolean = false>(options: Options<NpiV2UpdateProviderAddressData, ThrowOnError>): RequestResult<NpiV2UpdateProviderAddressResponses, unknown, ThrowOnError> => (options.client ?? client).patch<NpiV2UpdateProviderAddressResponses, unknown, ThrowOnError>({
  url: '/api/v2/npi/{npi}/addresses/{address_uuid}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const npiV2ToggleProviderAddress = <ThrowOnError extends boolean = false>(options: Options<NpiV2ToggleProviderAddressData, ThrowOnError>): RequestResult<NpiV2ToggleProviderAddressResponses, unknown, ThrowOnError> => (options.client ?? client).patch<NpiV2ToggleProviderAddressResponses, unknown, ThrowOnError>({
  url: '/api/v2/npi/{npi}/addresses/{address_uuid}/toggle',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Return the order statuses visible to the caller's role, grouped by display label.
 *
 * Migrated from orders GraphQL query: getOrderStatusesV2
 */
export const ordersV2GetOrderStatusesV2 = <ThrowOnError extends boolean = false>(options?: Options<OrdersV2GetOrderStatusesV2Data, ThrowOnError>): RequestResult<OrdersV2GetOrderStatusesV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV2GetOrderStatusesV2Responses, unknown, ThrowOnError>({ url: '/api/v2/orders/statuses', ...options });

/**
 * Move order to BILLING state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToBilling
 */
export const ordersV2MoveOrderToBilling = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToBillingData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToBillingResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToBillingResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/billing', ...options });

/**
 * Move order to CANT_REACH_PATIENT state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToCantReachPatient
 */
export const ordersV2MoveOrderToCantReachPatient = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToCantReachPatientData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToCantReachPatientResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToCantReachPatientResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/cant-reach-patient', ...options });

/**
 * Move order to DONE state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToDone
 */
export const ordersV2MoveOrderToDone = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToDoneData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToDoneResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToDoneResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/done', ...options });

/**
 * Duplicate an order (e.g. for resupply). Returns the new order's id and status.
 *
 * The duplicate_order utility internally emits ORDERS_REPLICATE_HISTORY_V1 and
 * ORDERS_ORDER_COPY_FILES_V1 so downstream services copy history and files onto
 * the new order.
 *
 * Migrated from orders GraphQL mutation: duplicateOrder (V2)
 */
export const ordersV2DuplicateOrderV2 = <ThrowOnError extends boolean = false>(options: Options<OrdersV2DuplicateOrderV2Data, ThrowOnError>): RequestResult<OrdersV2DuplicateOrderV2Responses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV2DuplicateOrderV2Responses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/duplicate', ...options });

/**
 * Move order to IN_PROGRESS_WITH_SUPPLIER state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToInProgressWithSupplier
 */
export const ordersV2MoveOrderToInProgressWithSupplier = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToInProgressWithSupplierData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToInProgressWithSupplierResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToInProgressWithSupplierResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/in-progress-with-supplier', ...options });

/**
 * Move order to ON_HOLD_WITH_SUPPLIER state with a required reason.
 *
 * Migrated from orders GraphQL mutation: moveOrderToOnHoldWithSupplier
 */
export const ordersV2MoveOrderToOnHoldWithSupplier = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToOnHoldWithSupplierData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToOnHoldWithSupplierResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToOnHoldWithSupplierResponses, unknown, ThrowOnError>({
  url: '/api/v2/orders/{order_id}/on-hold-with-supplier',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Move order to PENDING_AUTHORIZATION state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToPendingAuthorization
 */
export const ordersV2MoveOrderToPendingAuthorization = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToPendingAuthorizationData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToPendingAuthorizationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToPendingAuthorizationResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/pending-authorization', ...options });

/**
 * Move order to PENDING_REROUTE state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToPendingReroute
 */
export const ordersV2MoveOrderToPendingReroute = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToPendingRerouteData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToPendingRerouteResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToPendingRerouteResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/pending-reroute', ...options });

/**
 * Move order to PENDING_ACCEPTANCE state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToPendingSupplierAcceptance
 *
 * RX Date gate: when the order's supplier has ``require_rx_date_gate=True``
 * and the order has ``prescription_metadata`` present (not grandfathered),
 * the metadata must include a non-None ``expiration_date`` before the
 * transition is allowed.
 */
export const ordersV2MoveOrderToPendingSupplierAcceptance = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToPendingSupplierAcceptanceData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToPendingSupplierAcceptanceResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToPendingSupplierAcceptanceResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/pending-supplier-acceptance', ...options });

/**
 * Move order to PREPARING_SHIPMENT state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToPreparingShipment
 */
export const ordersV2MoveOrderToPreparingShipment = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToPreparingShipmentData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToPreparingShipmentResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToPreparingShipmentResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/preparing-shipment', ...options });

/**
 * Request a refresh of the e-signature for an order.
 *
 * Validates that:
 * - The order has an e-signature
 * - The e-signature is not already signed
 * - The e-signature link has expired (created more than 24 hours ago)
 *
 * Migrated from orders GraphQL mutation: refreshEsignature
 */
export const ordersV2RefreshEsignature = <ThrowOnError extends boolean = false>(options: Options<OrdersV2RefreshEsignatureData, ThrowOnError>): RequestResult<OrdersV2RefreshEsignatureResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2RefreshEsignatureResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/refresh-esignature', ...options });

/**
 * Request an e-signature for an order by uploading a document.
 *
 * Proxies the file upload to the esignature service.  MongoDB write is a
 * placeholder pending full migration.
 *
 * Migrated from orders service: POST /orders/api/esignature/request
 */
export const ordersV2RequestEsignature = <ThrowOnError extends boolean = false>(options: Options<OrdersV2RequestEsignatureData, ThrowOnError>): RequestResult<OrdersV2RequestEsignatureResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV2RequestEsignatureResponses, unknown, ThrowOnError>({
  ...formDataBodySerializer,
  url: '/api/v2/orders/{order_id}/request-esignature',
  ...options,
  headers: {
    'Content-Type': null,
    ...options.headers
  }
});

/**
 * Move order to SUPPLIER_COMPLETED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToSupplierCompleted
 */
export const ordersV2MoveOrderToSupplierCompleted = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToSupplierCompletedData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToSupplierCompletedResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToSupplierCompletedResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/supplier-completed', ...options });

/**
 * Move order to SUPPLIER_SHIPPED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToSupplierShipped
 */
export const ordersV2MoveOrderToSupplierShipped = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToSupplierShippedData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToSupplierShippedResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToSupplierShippedResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/supplier-shipped', ...options });

/**
 * Move order to CHASING_CLINICALS state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthChasingClinicals
 */
export const ordersV2MoveOrderToTelehealthChasingClinicals = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToTelehealthChasingClinicalsData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthChasingClinicalsResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthChasingClinicalsResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/telehealth-chasing-clinicals', ...options });

/**
 * Move order to TELEHEALTH_COMPLETED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthCompleted (V2)
 */
export const ordersV2MoveOrderToTelehealthCompleted = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToTelehealthCompletedData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthCompletedResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthCompletedResponses, unknown, ThrowOnError>({
  url: '/api/v2/orders/{order_id}/telehealth-completed',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Move order to CONTACTING_PATIENT state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthContactingPatient
 */
export const ordersV2MoveOrderToTelehealthContactingPatient = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToTelehealthContactingPatientData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthContactingPatientResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthContactingPatientResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/telehealth-contacting-patient', ...options });

/**
 * Move order to TELEHEALTH_NEEDS_RESCHED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthNeedsResched
 */
export const ordersV2MoveOrderToTelehealthNeedsRescheduling = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToTelehealthNeedsReschedulingData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthNeedsReschedulingResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthNeedsReschedulingResponses, unknown, ThrowOnError>({
  url: '/api/v2/orders/{order_id}/telehealth-needs-rescheduling',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Move order to TELEHEALTH_ON_HOLD state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthOnHold
 */
export const ordersV2MoveOrderToTelehealthOnHold = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToTelehealthOnHoldData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthOnHoldResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthOnHoldResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/telehealth-on-hold', ...options });

/**
 * Move order to POST_VISIT_ACTIONS_COMPLETED state.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthPostVisitActionsCompleted
 */
export const ordersV2MoveOrderToTelehealthPostVisitCompleted = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToTelehealthPostVisitCompletedData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthPostVisitCompletedResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthPostVisitCompletedResponses, unknown, ThrowOnError>({ url: '/api/v2/orders/{order_id}/telehealth-post-visit-completed', ...options });

/**
 * Move order to TELEHEALTH_UPCOMING state with a scheduled appointment time.
 *
 * Migrated from orders GraphQL mutation: moveOrderToTelehealthUpcoming
 */
export const ordersV2MoveOrderToTelehealthUpcoming = <ThrowOnError extends boolean = false>(options: Options<OrdersV2MoveOrderToTelehealthUpcomingData, ThrowOnError>): RequestResult<OrdersV2MoveOrderToTelehealthUpcomingResponses, unknown, ThrowOnError> => (options.client ?? client).patch<OrdersV2MoveOrderToTelehealthUpcomingResponses, unknown, ThrowOnError>({
  url: '/api/v2/orders/{order_id}/telehealth-upcoming',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Contact Field Options
 *
 * Return the static lookup options for the contact-details dropdowns
 * (relationship, phone type, preferred language). The option sets are small
 * and static, so there is no pagination and no DB access. Authorized to the
 * same roles that could read these via the patients-service GraphQL query.
 */
export const patientsV2GetContactFieldOptions = <ThrowOnError extends boolean = false>(options?: Options<PatientsV2GetContactFieldOptionsData, ThrowOnError>): RequestResult<PatientsV2GetContactFieldOptionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PatientsV2GetContactFieldOptionsResponses, unknown, ThrowOnError>({ url: '/api/v2/patients/contact-field-options', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const patientsV2Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<PatientsV2HeartbeatData, ThrowOnError>): RequestResult<PatientsV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PatientsV2HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v2/patients/heartbeat', ...options });

/**
 * Patient Search
 *
 * Get list of patients by case-insensitive partial match against
 * - First Name
 * - Last Name
 * - Email
 * - Auth0 ID
 */
export const patientsV2SearchPatients = <ThrowOnError extends boolean = false>(options?: Options<PatientsV2SearchPatientsData, ThrowOnError>): RequestResult<PatientsV2SearchPatientsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PatientsV2SearchPatientsResponses, unknown, ThrowOnError>({ url: '/api/v2/patients/search', ...options });

/**
 * Patient Detail
 *
 * Get patient details by numeric id
 */
export const patientsV2PatientDetails = <ThrowOnError extends boolean = false>(options: Options<PatientsV2PatientDetailsData, ThrowOnError>): RequestResult<PatientsV2PatientDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<PatientsV2PatientDetailsResponses, unknown, ThrowOnError>({ url: '/api/v2/patients/{patient_id}', ...options });

/**
 * Patient Detail
 *
 * Get patient address details by numeric id
 */
export const patientsV2PatientAddresses = <ThrowOnError extends boolean = false>(options: Options<PatientsV2PatientAddressesData, ThrowOnError>): RequestResult<PatientsV2PatientAddressesResponses, unknown, ThrowOnError> => (options.client ?? client).get<PatientsV2PatientAddressesResponses, unknown, ThrowOnError>({ url: '/api/v2/patients/{patient_id}/addresses', ...options });

/**
 * Patient Detail
 *
 * Get patient contacts details by numeric id
 */
export const patientsV2PatientContacts = <ThrowOnError extends boolean = false>(options: Options<PatientsV2PatientContactsData, ThrowOnError>): RequestResult<PatientsV2PatientContactsResponses, unknown, ThrowOnError> => (options.client ?? client).get<PatientsV2PatientContactsResponses, unknown, ThrowOnError>({ url: '/api/v2/patients/{patient_id}/contacts', ...options });

/**
 * Patient Customer.io Profile
 *
 * Look up the patient's Customer.io profile so internal tooling can link to it.
 * Payload is null when the patient has no patient UUID, or when the Customer.io
 * workspace has no profile for that UUID.
 */
export const patientsV2PatientCustomerioProfile = <ThrowOnError extends boolean = false>(options: Options<PatientsV2PatientCustomerioProfileData, ThrowOnError>): RequestResult<PatientsV2PatientCustomerioProfileResponses, unknown, ThrowOnError> => (options.client ?? client).get<PatientsV2PatientCustomerioProfileResponses, unknown, ThrowOnError>({ url: '/api/v2/patients/{patient_id}/customerio-profile', ...options });

/**
 * Patient Detail
 *
 * Get patient insurance details by numeric id
 */
export const patientsV2PatientInsurances = <ThrowOnError extends boolean = false>(options: Options<PatientsV2PatientInsurancesData, ThrowOnError>): RequestResult<PatientsV2PatientInsurancesResponses, unknown, ThrowOnError> => (options.client ?? client).get<PatientsV2PatientInsurancesResponses, unknown, ThrowOnError>({ url: '/api/v2/patients/{patient_id}/insurances', ...options });

/**
 * Patient Detail
 *
 * Get patient details by numeric id
 */
export const patientsV2PatientOrders = <ThrowOnError extends boolean = false>(options: Options<PatientsV2PatientOrdersData, ThrowOnError>): RequestResult<PatientsV2PatientOrdersResponses, unknown, ThrowOnError> => (options.client ?? client).get<PatientsV2PatientOrdersResponses, unknown, ThrowOnError>({ url: '/api/v2/patients/{patient_id}/orders', ...options });

/**
 * Patient Prescriptions
 *
 * Prescriptions recorded for a patient, newest first.
 *
 * Limited to uploaded scripts. The Mongo sync also writes one row per e-signature id, but
 * those carry no expiration date -- Mongo has no fee-schedule data to derive one -- so they
 * would all read as active and drown the list. Drop this filter once they carry real dates.
 */
export const patientsV2PatientPrescriptions = <ThrowOnError extends boolean = false>(options: Options<PatientsV2PatientPrescriptionsData, ThrowOnError>): RequestResult<PatientsV2PatientPrescriptionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<PatientsV2PatientPrescriptionsResponses, unknown, ThrowOnError>({ url: '/api/v2/patients/{patient_id}/prescriptions', ...options });

export const patientsV2ReassignPatient = <ThrowOnError extends boolean = false>(options: Options<PatientsV2ReassignPatientData, ThrowOnError>): RequestResult<PatientsV2ReassignPatientResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatientsV2ReassignPatientResponses, unknown, ThrowOnError>({
  url: '/api/v2/patients/{patient_id}/user',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Create a Carrier Coverage Zone Product
 */
export const productsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProduct = <ThrowOnError extends boolean = false>(options: Options<ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductData, ThrowOnError>): RequestResult<ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProductsV2CarrierCoverageZoneProductsV2CreateCarrierCoverageZoneProductResponses, unknown, ThrowOnError>({
  url: '/api/v2/products/carrier_coverage_zone_products/create',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const productsV2CarrierCoverageZoneProductsV2Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ProductsV2CarrierCoverageZoneProductsV2HeartbeatData, ThrowOnError>): RequestResult<ProductsV2CarrierCoverageZoneProductsV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2CarrierCoverageZoneProductsV2HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v2/products/carrier_coverage_zone_products/heartbeat', ...options });

/**
 * Get Carrier Coverage Zone Product by uuid
 */
export const productsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetails = <ThrowOnError extends boolean = false>(options: Options<ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsData, ThrowOnError>): RequestResult<ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV2CarrierCoverageZoneProductsV2GetCarrierCoverageZoneProductDetailsResponses, unknown, ThrowOnError>({ url: '/api/v2/products/carrier_coverage_zone_products/{uuid}', ...options });

/**
 * Delete a Carrier Coverage Zone Product
 */
export const productsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProduct = <ThrowOnError extends boolean = false>(options: Options<ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductData, ThrowOnError>): RequestResult<ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProductsV2CarrierCoverageZoneProductsV2DeleteCarrierCoverageZoneProductResponses, unknown, ThrowOnError>({ url: '/api/v2/products/carrier_coverage_zone_products/{uuid}/delete', ...options });

/**
 * Edit a Carrier Coverage Zone Product
 */
export const productsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProduct = <ThrowOnError extends boolean = false>(options: Options<ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductData, ThrowOnError>): RequestResult<ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductResponses, unknown, ThrowOnError> => (options.client ?? client).put<ProductsV2CarrierCoverageZoneProductsV2EditCarrierCoverageZoneProductResponses, unknown, ThrowOnError>({
  url: '/api/v2/products/carrier_coverage_zone_products/{uuid}/edit',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const productsV2CartV2DeleteCart = <ThrowOnError extends boolean = false>(options?: Options<ProductsV2CartV2DeleteCartData, ThrowOnError>): RequestResult<ProductsV2CartV2DeleteCartResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<ProductsV2CartV2DeleteCartResponses, unknown, ThrowOnError>({ url: '/api/v2/products/cart', ...options });

export const productsV2CartV2GetCart = <ThrowOnError extends boolean = false>(options?: Options<ProductsV2CartV2GetCartData, ThrowOnError>): RequestResult<ProductsV2CartV2GetCartResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2CartV2GetCartResponses, unknown, ThrowOnError>({ url: '/api/v2/products/cart', ...options });

export const postProductsV2CartV2CreateUpdateCart = <ThrowOnError extends boolean = false>(options: Options<PostProductsV2CartV2CreateUpdateCartData, ThrowOnError>): RequestResult<PostProductsV2CartV2CreateUpdateCartResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostProductsV2CartV2CreateUpdateCartResponses, unknown, ThrowOnError>({
  url: '/api/v2/products/cart',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const putProductsV2CartV2CreateUpdateCart = <ThrowOnError extends boolean = false>(options: Options<PutProductsV2CartV2CreateUpdateCartData, ThrowOnError>): RequestResult<PutProductsV2CartV2CreateUpdateCartResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutProductsV2CartV2CreateUpdateCartResponses, unknown, ThrowOnError>({
  url: '/api/v2/products/cart',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get all Product Categories
 */
export const productsV2CategoriesV2GetAllCategories = <ThrowOnError extends boolean = false>(options?: Options<ProductsV2CategoriesV2GetAllCategoriesData, ThrowOnError>): RequestResult<ProductsV2CategoriesV2GetAllCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2CategoriesV2GetAllCategoriesResponses, unknown, ThrowOnError>({ url: '/api/v2/products/categories/all', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV2CategoriesV2Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ProductsV2CategoriesV2HeartbeatData, ThrowOnError>): RequestResult<ProductsV2CategoriesV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2CategoriesV2HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v2/products/categories/heartbeat', ...options });

/**
 * Search
 *
 * Retrieve list of records by query term and/or template type (Medicaid/Medicare)
 */
export const productsV2CategoriesV2SearchCategories = <ThrowOnError extends boolean = false>(options?: Options<ProductsV2CategoriesV2SearchCategoriesData, ThrowOnError>): RequestResult<ProductsV2CategoriesV2SearchCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2CategoriesV2SearchCategoriesResponses, unknown, ThrowOnError>({ url: '/api/v2/products/categories/search', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV2Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ProductsV2HeartbeatData, ThrowOnError>): RequestResult<ProductsV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v2/products/heartbeat', ...options });

/**
 * Search through Products with filters for CoverageZone, Supplier, Category, and a search term.
 *
 * Filters for CoverageZone and Supplier apply to the product's CarrierCoverageZoneProduct. If any
 * of a products CarrierCoverageZoneProducts match those filters, the parent Product is included in the results.
 */
export const productsV2SearchProducts = <ThrowOnError extends boolean = false>(options?: Options<ProductsV2SearchProductsData, ThrowOnError>): RequestResult<ProductsV2SearchProductsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV2SearchProductsResponses, unknown, ThrowOnError>({ url: '/api/v2/products/search', ...options });

export const productsV2FoldProducts = <ThrowOnError extends boolean = false>(options: Options<ProductsV2FoldProductsData, ThrowOnError>): RequestResult<ProductsV2FoldProductsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV2FoldProductsResponses, unknown, ThrowOnError>({ url: '/api/v2/products/{product_uuid}/test', ...options });

export const productsV2FoldProducts2 = <ThrowOnError extends boolean = false>(options: Options<ProductsV2FoldProducts2Data, ThrowOnError>): RequestResult<ProductsV2FoldProducts2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV2FoldProducts2Responses, unknown, ThrowOnError>({ url: '/api/v2/products/{product_uuid}/test/all/{state}', ...options });

export const productsV2FoldProducts3 = <ThrowOnError extends boolean = false>(options: Options<ProductsV2FoldProducts3Data, ThrowOnError>): RequestResult<ProductsV2FoldProducts3Responses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV2FoldProducts3Responses, unknown, ThrowOnError>({ url: '/api/v2/products/{product_uuid}/test/{carrier}', ...options });

export const productsV2FoldProducts4 = <ThrowOnError extends boolean = false>(options: Options<ProductsV2FoldProducts4Data, ThrowOnError>): RequestResult<ProductsV2FoldProducts4Responses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV2FoldProducts4Responses, unknown, ThrowOnError>({ url: '/api/v2/products/{product_uuid}/test/{carrier}/{state}', ...options });

/**
 * Details
 *
 * Get the Product and its associated CarrierCoverageZoneProducts
 */
export const productsV2GetProductDetails = <ThrowOnError extends boolean = false>(options: Options<ProductsV2GetProductDetailsData, ThrowOnError>): RequestResult<ProductsV2GetProductDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV2GetProductDetailsResponses, unknown, ThrowOnError>({ url: '/api/v2/products/{uuid}', ...options });

/**
 * Edit a Product's top-level fields
 */
export const productsV2EditProduct = <ThrowOnError extends boolean = false>(options: Options<ProductsV2EditProductData, ThrowOnError>): RequestResult<ProductsV2EditProductResponses, unknown, ThrowOnError> => (options.client ?? client).put<ProductsV2EditProductResponses, unknown, ThrowOnError>({ url: '/api/v2/products/{uuid}/edit', ...options });

/**
 * Plan Details — plan-identity values read back from an order's stored eligibility responses.
 *
 * Covers the fields the billed insurance record does not keep: the payer's own name before
 * carrier resolution, the plan name and description the payer reported, and the plan
 * contract identifier. Reads stored responses only; runs no eligibility call.
 *
 * Each entry's memberId and payorId hold the member id and plan code recorded on the
 * insurance it describes, so callers can match on both. Returns payload: [] when the order
 * has no lines whose stored response is in this shape (not 404).
 */
export const servicesV2FrontrunnerV2PlanDetails = <ThrowOnError extends boolean = false>(options: Options<ServicesV2FrontrunnerV2PlanDetailsData, ThrowOnError>): RequestResult<ServicesV2FrontrunnerV2PlanDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV2FrontrunnerV2PlanDetailsResponses, unknown, ThrowOnError>({ url: '/api/v2/services/frontrunner/audit-trail/{order_id}/plan-details', ...options });

/**
 * Heartbeat — v2 FrontRunner services blueprint.
 */
export const servicesV2FrontrunnerV2Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ServicesV2FrontrunnerV2HeartbeatData, ThrowOnError>): RequestResult<ServicesV2FrontrunnerV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV2FrontrunnerV2HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v2/services/frontrunner/heartbeat', ...options });

/**
 * Pipeline Replay — run read-only Elgin discovery + payer ordering for an order.
 *
 * Query params:
 * no_cache (bool, default false): bypass the 24 h FrontRunner response cache.
 * raw (bool, default false): include the raw 271 JSON from the audit trail record.
 *
 * Returns 404 when the order does not exist in MongoDB.
 */
export const servicesV2FrontrunnerV2PipelineReplay = <ThrowOnError extends boolean = false>(options: Options<ServicesV2FrontrunnerV2PipelineReplayData, ThrowOnError>): RequestResult<ServicesV2FrontrunnerV2PipelineReplayResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServicesV2FrontrunnerV2PipelineReplayResponses, unknown, ThrowOnError>({ url: '/api/v2/services/frontrunner/pipeline/{order_id}/replay', ...options });

/**
 * Heartbeat — v2 services blueprint.
 */
export const servicesV2Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ServicesV2HeartbeatData, ThrowOnError>): RequestResult<ServicesV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServicesV2HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v2/services/heartbeat', ...options });

/**
 * Retrieve all active suppliers.
 */
export const suppliersV2GetAllSuppliers = <ThrowOnError extends boolean = false>(options?: Options<SuppliersV2GetAllSuppliersData, ThrowOnError>): RequestResult<SuppliersV2GetAllSuppliersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuppliersV2GetAllSuppliersResponses, unknown, ThrowOnError>({ url: '/api/v2/suppliers/all', ...options });

/**
 * Retrieve a supplier by UUID.
 */
export const suppliersV2Details = <ThrowOnError extends boolean = false>(options: Options<SuppliersV2DetailsData, ThrowOnError>): RequestResult<SuppliersV2DetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SuppliersV2DetailsResponses, unknown, ThrowOnError>({ url: '/api/v2/suppliers/details/{supplier_id}', ...options });

/**
 * Health check endpoint.
 */
export const suppliersV2Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<SuppliersV2HeartbeatData, ThrowOnError>): RequestResult<SuppliersV2HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuppliersV2HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v2/suppliers/heartbeat', ...options });

/**
 * Search suppliers by query term and/or category.
 */
export const suppliersV2Search = <ThrowOnError extends boolean = false>(options?: Options<SuppliersV2SearchData, ThrowOnError>): RequestResult<SuppliersV2SearchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuppliersV2SearchResponses, unknown, ThrowOnError>({ url: '/api/v2/suppliers/search', ...options });

/**
 * Search suppliers by query term and/or category.
 */
export const suppliersV2Search2 = <ThrowOnError extends boolean = false>(options: Options<SuppliersV2Search2Data, ThrowOnError>): RequestResult<SuppliersV2Search2Responses, unknown, ThrowOnError> => (options.client ?? client).get<SuppliersV2Search2Responses, unknown, ThrowOnError>({ url: '/api/v2/suppliers/search/{category}', ...options });

/**
 * Insurance Card Presigned Upload URL
 *
 * Issues a short-lived presigned S3 PUT URL the FE uses to upload one card
 * image directly to S3. After the upload succeeds the FE registers the
 * resulting s3_object_key on the cache entry via
 * PUT /v3/insurance/cards/<verification_key>.
 *
 * Returns 404 when the verification_key has no cache entry.
 */
export const insuranceV3CardUploadUrl = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3CardUploadUrlData, ThrowOnError>): RequestResult<InsuranceV3CardUploadUrlResponses, InsuranceV3CardUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<InsuranceV3CardUploadUrlResponses, InsuranceV3CardUploadUrlErrors, ThrowOnError>({
  url: '/api/v3/insurance/cards/upload-url',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Insurance Card Upload
 *
 * Stores front and back card paths on the cached verification record.
 * Returns 404 if the verification_key has no cache entry.
 */
export const insuranceV3PutCards = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3PutCardsData, ThrowOnError>): RequestResult<InsuranceV3PutCardsResponses, InsuranceV3PutCardsErrors, ThrowOnError> => (options.client ?? client).put<InsuranceV3PutCardsResponses, InsuranceV3PutCardsErrors, ThrowOnError>({
  url: '/api/v3/insurance/cards/{verification_key}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * List all carrier statuses, sorted by display order.
 *
 * Backs the carrier-admin status dropdown; the small, mostly-static row count
 * makes pagination unnecessary.
 */
export const insuranceV3CarrierStatusesV3ListCarrierStatuses = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV3CarrierStatusesV3ListCarrierStatusesData, ThrowOnError>): RequestResult<InsuranceV3CarrierStatusesV3ListCarrierStatusesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3CarrierStatusesV3ListCarrierStatusesResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/carrier-statuses', ...options });

export const insuranceV3CarriersV3CreateCarrier = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3CarriersV3CreateCarrierData, ThrowOnError>): RequestResult<InsuranceV3CarriersV3CreateCarrierResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3CarriersV3CreateCarrierResponses, unknown, ThrowOnError>({
  url: '/api/v3/insurance/carriers',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV3CarriersV3SearchCarriers = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV3CarriersV3SearchCarriersData, ThrowOnError>): RequestResult<InsuranceV3CarriersV3SearchCarriersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3CarriersV3SearchCarriersResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/carriers/search', ...options });

export const insuranceV3CarriersV3UpdateCarrier = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3CarriersV3UpdateCarrierData, ThrowOnError>): RequestResult<InsuranceV3CarriersV3UpdateCarrierResponses, unknown, ThrowOnError> => (options.client ?? client).patch<InsuranceV3CarriersV3UpdateCarrierResponses, unknown, ThrowOnError>({
  url: '/api/v3/insurance/carriers/{carrier_uuid}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV3GetCarriersByState = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3GetCarriersByStateData, ThrowOnError>): RequestResult<InsuranceV3GetCarriersByStateResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV3GetCarriersByStateResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/carriers/{state}', ...options });

export const insuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverrides = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesData, ThrowOnError>): RequestResult<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3CodeEligibilityOverridesV3ListCodeEligibilityOverridesResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/code-eligibility-overrides', ...options });

export const insuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverride = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideData, ThrowOnError>): RequestResult<InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideErrors, ThrowOnError> => (options.client ?? client).post<InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3CreateCodeEligibilityOverrideErrors, ThrowOnError>({
  url: '/api/v3/insurance/code-eligibility-overrides',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverride = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideData, ThrowOnError>): RequestResult<InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideErrors, ThrowOnError> => (options.client ?? client).delete<InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3DeleteCodeEligibilityOverrideErrors, ThrowOnError>({ url: '/api/v3/insurance/code-eligibility-overrides/{uuid}', ...options });

export const insuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverride = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideData, ThrowOnError>): RequestResult<InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideErrors, ThrowOnError> => (options.client ?? client).patch<InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideResponses, InsuranceV3CodeEligibilityOverridesV3UpdateCodeEligibilityOverrideErrors, ThrowOnError>({
  url: '/api/v3/insurance/code-eligibility-overrides/{uuid}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV3CodesV3SearchCodes = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV3CodesV3SearchCodesData, ThrowOnError>): RequestResult<InsuranceV3CodesV3SearchCodesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3CodesV3SearchCodesResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/codes/search', ...options });

/**
 * List all coverage zones (states), sorted by abbreviation.
 *
 * Backs the carrier-admin state multi-select; the small, mostly-static row count
 * makes pagination unnecessary.
 */
export const insuranceV3CoverageZonesV3ListCoverageZones = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV3CoverageZonesV3ListCoverageZonesData, ThrowOnError>): RequestResult<InsuranceV3CoverageZonesV3ListCoverageZonesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3CoverageZonesV3ListCoverageZonesResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/coverage-zones', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const insuranceV3Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV3HeartbeatData, ThrowOnError>): RequestResult<InsuranceV3HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/heartbeat', ...options });

/**
 * Run Mappy For Orders
 *
 * Run the ``initiate_mappy_for_order`` task for one or more orders, identified
 * by either ``order_uuids`` or numeric ``order_ids``. By default the work is
 * enqueued as a Celery task per order and the response returns the task ids.
 * Pass ``synchronous=true`` with exactly one order to run the task inline and
 * return its result directly.
 */
export const insuranceV3Mappy = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3MappyData, ThrowOnError>): RequestResult<InsuranceV3MappyResponses, InsuranceV3MappyErrors, ThrowOnError> => (options.client ?? client).post<InsuranceV3MappyResponses, InsuranceV3MappyErrors, ThrowOnError>({
  url: '/api/v3/insurance/mappy',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignations = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsData, ThrowOnError>): RequestResult<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3NetworkStatusDesignationsV3ListNetworkStatusDesignationsResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/network-status-designations', ...options });

export const insuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignation = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationData, ThrowOnError>): RequestResult<InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationErrors, ThrowOnError> => (options.client ?? client).post<InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3CreateNetworkStatusDesignationErrors, ThrowOnError>({
  url: '/api/v3/insurance/network-status-designations',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignation = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationData, ThrowOnError>): RequestResult<InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationErrors, ThrowOnError> => (options.client ?? client).delete<InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3DeleteNetworkStatusDesignationErrors, ThrowOnError>({ url: '/api/v3/insurance/network-status-designations/{uuid}', ...options });

export const insuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignation = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationData, ThrowOnError>): RequestResult<InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationErrors, ThrowOnError> => (options.client ?? client).patch<InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationResponses, InsuranceV3NetworkStatusDesignationsV3UpdateNetworkStatusDesignationErrors, ThrowOnError>({
  url: '/api/v3/insurance/network-status-designations/{uuid}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Order Insurance Discovery
 *
 * Run insurance discovery for an order, write results to the order document, and return an acknowledgment.
 */
export const insuranceV3OrderDiscovery = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3OrderDiscoveryData, ThrowOnError>): RequestResult<InsuranceV3OrderDiscoveryResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3OrderDiscoveryResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/orders/{order_id}/discover', ...options });

/**
 * Order Eligibility Verification
 *
 * Run eligibility check for an order's insurance, write results to the order document, and return an acknowledgment.
 */
export const insuranceV3OrderEligibility = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3OrderEligibilityData, ThrowOnError>): RequestResult<InsuranceV3OrderEligibilityResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3OrderEligibilityResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/orders/{order_id}/verify/{member_id}', ...options });

export const insuranceV3PlanCodesV3CreatePlanCode = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3PlanCodesV3CreatePlanCodeData, ThrowOnError>): RequestResult<InsuranceV3PlanCodesV3CreatePlanCodeResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3PlanCodesV3CreatePlanCodeResponses, unknown, ThrowOnError>({
  url: '/api/v3/insurance/plan-codes',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV3PlanCodesV3SearchPlanCodes = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV3PlanCodesV3SearchPlanCodesData, ThrowOnError>): RequestResult<InsuranceV3PlanCodesV3SearchPlanCodesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3PlanCodesV3SearchPlanCodesResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/plan-codes/search', ...options });

export const insuranceV3PlanCodesV3GetPlanCode = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3PlanCodesV3GetPlanCodeData, ThrowOnError>): RequestResult<InsuranceV3PlanCodesV3GetPlanCodeResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV3PlanCodesV3GetPlanCodeResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/plan-codes/{plan_code_uuid}', ...options });

export const insuranceV3PlanCodesV3UpdatePlanCode = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3PlanCodesV3UpdatePlanCodeData, ThrowOnError>): RequestResult<InsuranceV3PlanCodesV3UpdatePlanCodeResponses, unknown, ThrowOnError> => (options.client ?? client).patch<InsuranceV3PlanCodesV3UpdatePlanCodeResponses, unknown, ThrowOnError>({
  url: '/api/v3/insurance/plan-codes/{plan_code_uuid}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV3PlansV3CreatePlan = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3PlansV3CreatePlanData, ThrowOnError>): RequestResult<InsuranceV3PlansV3CreatePlanResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3PlansV3CreatePlanResponses, unknown, ThrowOnError>({
  url: '/api/v3/insurance/plans',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV3PlansV3SearchCandidPayers = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3PlansV3SearchCandidPayersData, ThrowOnError>): RequestResult<InsuranceV3PlansV3SearchCandidPayersResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV3PlansV3SearchCandidPayersResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/plans/candid/search', ...options });

export const insuranceV3PlansV3SearchEhrPlans = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV3PlansV3SearchEhrPlansData, ThrowOnError>): RequestResult<InsuranceV3PlansV3SearchEhrPlansResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3PlansV3SearchEhrPlansResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/plans/ehr/search', ...options });

export const insuranceV3PlansV3SearchPlans = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV3PlansV3SearchPlansData, ThrowOnError>): RequestResult<InsuranceV3PlansV3SearchPlansResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3PlansV3SearchPlansResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/plans/search', ...options });

export const insuranceV3PlansV3GetPlan = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3PlansV3GetPlanData, ThrowOnError>): RequestResult<InsuranceV3PlansV3GetPlanResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV3PlansV3GetPlanResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/plans/{plan_uuid}', ...options });

export const insuranceV3PlansV3UpdatePlan = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3PlansV3UpdatePlanData, ThrowOnError>): RequestResult<InsuranceV3PlansV3UpdatePlanResponses, unknown, ThrowOnError> => (options.client ?? client).patch<InsuranceV3PlansV3UpdatePlanResponses, unknown, ThrowOnError>({
  url: '/api/v3/insurance/plans/{plan_uuid}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Insurance Discovery: delegate to discovery service, then shape HTTP response and metrics.
 */
export const insuranceV3Discovery = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3DiscoveryData, ThrowOnError>): RequestResult<InsuranceV3DiscoveryResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3DiscoveryResponses, unknown, ThrowOnError>({
  url: '/api/v3/insurance/search',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignments = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsData, ThrowOnError>): RequestResult<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV3SupplierBillingAssignmentsV3ListSupplierBillingAssignmentsResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/supplier-billing-assignments', ...options });

export const insuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignment = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentData, ThrowOnError>): RequestResult<InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentResponses, InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentErrors, ThrowOnError> => (options.client ?? client).post<InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentResponses, InsuranceV3SupplierBillingAssignmentsV3CreateSupplierBillingAssignmentErrors, ThrowOnError>({
  url: '/api/v3/insurance/supplier-billing-assignments',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignment = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentData, ThrowOnError>): RequestResult<InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentResponses, InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentErrors, ThrowOnError> => (options.client ?? client).delete<InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentResponses, InsuranceV3SupplierBillingAssignmentsV3DeleteSupplierBillingAssignmentErrors, ThrowOnError>({ url: '/api/v3/insurance/supplier-billing-assignments/{uuid}', ...options });

export const insuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignment = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentData, ThrowOnError>): RequestResult<InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentResponses, InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentErrors, ThrowOnError> => (options.client ?? client).patch<InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentResponses, InsuranceV3SupplierBillingAssignmentsV3UpdateSupplierBillingAssignmentErrors, ThrowOnError>({
  url: '/api/v3/insurance/supplier-billing-assignments/{uuid}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV3TestVerificationKey = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3TestVerificationKeyData, ThrowOnError>): RequestResult<InsuranceV3TestVerificationKeyResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV3TestVerificationKeyResponses, unknown, ThrowOnError>({ url: '/api/v3/insurance/test-verification/{verification_key}', ...options });

/**
 * Patient Eligibility: delegate to verification service, then shape HTTP response and metrics.
 */
export const insuranceV3Verification = <ThrowOnError extends boolean = false>(options: Options<InsuranceV3VerificationData, ThrowOnError>): RequestResult<InsuranceV3VerificationResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV3VerificationResponses, unknown, ThrowOnError>({
  url: '/api/v3/insurance/verify',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const productsV3GetProducts = <ThrowOnError extends boolean = false>(options: Options<ProductsV3GetProductsData, ThrowOnError>): RequestResult<ProductsV3GetProductsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV3GetProductsResponses, unknown, ThrowOnError>({ url: '/api/v3/products/', ...options });

/**
 * Get Categories
 *
 * Returns a flat list of all active and visible product categories
 * (both parent and subcategories) filtered by the specified catalog.
 *
 * This endpoint does not require authentication.
 * Categories are filtered to include all categories (parents and subcategories)
 * that are both active and visible, belong to the specified catalog (Marketplace or D2C),
 * and are sorted alphabetically by name. Subcategories include their parent_uuid in the response.
 *
 * Query Parameters:
 * catalog (required): Must be either "Marketplace" or "D2C" (case-insensitive)
 *
 * Returns:
 * Response with metadata (timestamp, catalog) and payload (array of category objects).
 * Each category object contains uuid (UUID), label (string), parent_uuid (UUID or null),
 * description (string or null), and image_url (string or null).
 */
export const productsV3GetCategories = <ThrowOnError extends boolean = false>(options: Options<ProductsV3GetCategoriesData, ThrowOnError>): RequestResult<ProductsV3GetCategoriesResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV3GetCategoriesResponses, unknown, ThrowOnError>({ url: '/api/v3/products/categories', ...options });

/**
 * Get Coverage Zones
 *
 * Returns active coverage zones that have at least one active, visible product.
 * Optionally filtered to zones whose products belong to the specified catalog.
 *
 * Query Parameters:
 * catalog (optional): "Marketplace" or "D2C" (case-insensitive). Omit for all zones.
 *
 * Returns:
 * Response with metadata (timestamp, catalog) and payload (array of zone objects).
 * Each zone contains uuid, label (state name), and abbreviation (2-letter code).
 */
export const productsV3GetCoverageZones = <ThrowOnError extends boolean = false>(options?: Options<ProductsV3GetCoverageZonesData, ThrowOnError>): RequestResult<ProductsV3GetCoverageZonesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV3GetCoverageZonesResponses, unknown, ThrowOnError>({ url: '/api/v3/products/coverage_zones/', ...options });

/**
 * Export Flat Catalog
 *
 * Returns a flat list of every billable product × HCPC configuration.
 * Each row contains catalog, category, bundle name, product name, description, and HCPC code.
 *
 * Optionally filtered to a single catalog by name (case-sensitive, must match DB label).
 *
 * Path Parameters:
 * catalog_name (optional): Catalog label to filter by (e.g. "Marketplace", "D2C").
 * Omit to return rows across all catalogs.
 *
 * Returns:
 * Response with metadata (timestamp, catalog) and payload (list of flat catalog rows).
 */
export const productsV3ExportCatalog = <ThrowOnError extends boolean = false>(options?: Options<ProductsV3ExportCatalogData, ThrowOnError>): RequestResult<ProductsV3ExportCatalogResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV3ExportCatalogResponses, unknown, ThrowOnError>({ url: '/api/v3/products/export-catalog/', ...options });

/**
 * Export Flat Catalog
 *
 * Returns a flat list of every billable product × HCPC configuration.
 * Each row contains catalog, category, bundle name, product name, description, and HCPC code.
 *
 * Optionally filtered to a single catalog by name (case-sensitive, must match DB label).
 *
 * Path Parameters:
 * catalog_name (optional): Catalog label to filter by (e.g. "Marketplace", "D2C").
 * Omit to return rows across all catalogs.
 *
 * Returns:
 * Response with metadata (timestamp, catalog) and payload (list of flat catalog rows).
 */
export const productsV3ExportCatalog2 = <ThrowOnError extends boolean = false>(options: Options<ProductsV3ExportCatalog2Data, ThrowOnError>): RequestResult<ProductsV3ExportCatalog2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV3ExportCatalog2Responses, unknown, ThrowOnError>({ url: '/api/v3/products/export-catalog/{catalog_name}', ...options });

/**
 * Heartbeat
 *
 * Base validation for the heartbeat endpoint
 */
export const productsV3Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<ProductsV3HeartbeatData, ThrowOnError>): RequestResult<ProductsV3HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV3HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v3/products/heartbeat', ...options });

/**
 * Get available time slots for the specified date range.
 */
export const schedulingV3GetSlots = <ThrowOnError extends boolean = false>(options: Options<SchedulingV3GetSlotsData, ThrowOnError>): RequestResult<SchedulingV3GetSlotsResponses, SchedulingV3GetSlotsErrors, ThrowOnError> => (options.client ?? client).get<SchedulingV3GetSlotsResponses, SchedulingV3GetSlotsErrors, ThrowOnError>({ url: '/api/v3/scheduling/slots', ...options });

/**
 * Reserve a time slot.
 */
export const schedulingV3ReserveSlot = <ThrowOnError extends boolean = false>(options: Options<SchedulingV3ReserveSlotData, ThrowOnError>): RequestResult<SchedulingV3ReserveSlotResponses, SchedulingV3ReserveSlotErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV3ReserveSlotResponses, SchedulingV3ReserveSlotErrors, ThrowOnError>({
  url: '/api/v3/scheduling/slots/reserve',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Handle booking lifecycle webhook events.
 */
export const schedulingV3CalcomWebhook = <ThrowOnError extends boolean = false>(options?: Options<SchedulingV3CalcomWebhookData, ThrowOnError>): RequestResult<SchedulingV3CalcomWebhookResponses, SchedulingV3CalcomWebhookErrors, ThrowOnError> => (options?.client ?? client).post<SchedulingV3CalcomWebhookResponses, SchedulingV3CalcomWebhookErrors, ThrowOnError>({ url: '/api/v3/scheduling/webhooks/calcom', ...options });

export const sessionsV3PreviewSession = <ThrowOnError extends boolean = false>(options: Options<SessionsV3PreviewSessionData, ThrowOnError>): RequestResult<SessionsV3PreviewSessionResponses, SessionsV3PreviewSessionErrors, ThrowOnError> => (options.client ?? client).get<SessionsV3PreviewSessionResponses, SessionsV3PreviewSessionErrors, ThrowOnError>({ url: '/api/v3/sessions/preview/{token}', ...options });

export const sessionsV3SaveSession = <ThrowOnError extends boolean = false>(options: Options<SessionsV3SaveSessionData, ThrowOnError>): RequestResult<SessionsV3SaveSessionResponses, SessionsV3SaveSessionErrors, ThrowOnError> => (options.client ?? client).post<SessionsV3SaveSessionResponses, SessionsV3SaveSessionErrors, ThrowOnError>({
  url: '/api/v3/sessions/save',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const sessionsV3VerifySession = <ThrowOnError extends boolean = false>(options: Options<SessionsV3VerifySessionData, ThrowOnError>): RequestResult<SessionsV3VerifySessionResponses, SessionsV3VerifySessionErrors, ThrowOnError> => (options.client ?? client).post<SessionsV3VerifySessionResponses, SessionsV3VerifySessionErrors, ThrowOnError>({
  url: '/api/v3/sessions/verify',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Check phone verification code.
 */
export const verifyV3Check = <ThrowOnError extends boolean = false>(options: Options<VerifyV3CheckData, ThrowOnError>): RequestResult<VerifyV3CheckResponses, VerifyV3CheckErrors, ThrowOnError> => (options.client ?? client).post<VerifyV3CheckResponses, VerifyV3CheckErrors, ThrowOnError>({
  url: '/api/v3/verify/check',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Start phone verification by sending a code via SMS.
 */
export const verifyV3Start = <ThrowOnError extends boolean = false>(options: Options<VerifyV3StartData, ThrowOnError>): RequestResult<VerifyV3StartResponses, VerifyV3StartErrors, ThrowOnError> => (options.client ?? client).post<VerifyV3StartResponses, VerifyV3StartErrors, ThrowOnError>({
  url: '/api/v3/verify/start',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV4PlansV4CreatePlanAdmin = <ThrowOnError extends boolean = false>(options: Options<InsuranceV4PlansV4CreatePlanAdminData, ThrowOnError>): RequestResult<InsuranceV4PlansV4CreatePlanAdminResponses, unknown, ThrowOnError> => (options.client ?? client).post<InsuranceV4PlansV4CreatePlanAdminResponses, unknown, ThrowOnError>({
  url: '/api/v4/insurance/plans',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const insuranceV4PlansV4SearchPlansAdmin = <ThrowOnError extends boolean = false>(options?: Options<InsuranceV4PlansV4SearchPlansAdminData, ThrowOnError>): RequestResult<InsuranceV4PlansV4SearchPlansAdminResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InsuranceV4PlansV4SearchPlansAdminResponses, unknown, ThrowOnError>({ url: '/api/v4/insurance/plans/search', ...options });

export const insuranceV4PlansV4GetPlanAdmin = <ThrowOnError extends boolean = false>(options: Options<InsuranceV4PlansV4GetPlanAdminData, ThrowOnError>): RequestResult<InsuranceV4PlansV4GetPlanAdminResponses, unknown, ThrowOnError> => (options.client ?? client).get<InsuranceV4PlansV4GetPlanAdminResponses, unknown, ThrowOnError>({ url: '/api/v4/insurance/plans/{plan_uuid}', ...options });

export const insuranceV4PlansV4UpdatePlanAdmin = <ThrowOnError extends boolean = false>(options: Options<InsuranceV4PlansV4UpdatePlanAdminData, ThrowOnError>): RequestResult<InsuranceV4PlansV4UpdatePlanAdminResponses, unknown, ThrowOnError> => (options.client ?? client).patch<InsuranceV4PlansV4UpdatePlanAdminResponses, unknown, ThrowOnError>({
  url: '/api/v4/insurance/plans/{plan_uuid}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV4CreateOrderDtcEndpoint = <ThrowOnError extends boolean = false>(options: Options<OrdersV4CreateOrderDtcEndpointData, ThrowOnError>): RequestResult<OrdersV4CreateOrderDtcEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV4CreateOrderDtcEndpointResponses, unknown, ThrowOnError>({
  url: '/api/v4/orders/create-dtc',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * [DEPRECATED] Use POST /api/v1/orders with role=mcp instead.
 */
export const ordersV4CreateOrderMcpEndpoint = <ThrowOnError extends boolean = false>(options: Options<OrdersV4CreateOrderMcpEndpointData, ThrowOnError>): RequestResult<OrdersV4CreateOrderMcpEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV4CreateOrderMcpEndpointResponses, unknown, ThrowOnError>({
  url: '/api/v4/orders/create-mcp',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Endpoint to escalate an MCP order to the team. Adds an escalation tag to the Intercom conversation and posts a message to Slack.
 */
export const ordersV4EscalateMcpOrder = <ThrowOnError extends boolean = false>(options: Options<OrdersV4EscalateMcpOrderData, ThrowOnError>): RequestResult<OrdersV4EscalateMcpOrderResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV4EscalateMcpOrderResponses, unknown, ThrowOnError>({
  url: '/api/v4/orders/escalate-mcp',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Mark an order cannot-reach-patient after exhausted reschedule outreach.
 *
 * Only ``TELEHEALTH_NEEDS_RESCHED`` and ``CONTACTING_PATIENT`` transition.
 * Already cannot-reach, rescheduled, completed, or cancelled is a 200 no-op
 * so a late webhook cannot undo a successful booking.
 */
export const ordersV4PostCantReachPatient = <ThrowOnError extends boolean = false>(options: Options<OrdersV4PostCantReachPatientData, ThrowOnError>): RequestResult<OrdersV4PostCantReachPatientResponses, OrdersV4PostCantReachPatientErrors, ThrowOnError> => (options.client ?? client).post<OrdersV4PostCantReachPatientResponses, OrdersV4PostCantReachPatientErrors, ThrowOnError>({
  url: '/api/v4/orders/{order_id}/cant-reach-patient',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Close every Retell conversation recorded for an order.
 *
 * Reads the order's ``order_external_connections`` rows and ends each Retell
 * chat they reference. Chats Retell reports as no longer ongoing are reported
 * as ``already_closed`` without an end-chat call, so the endpoint is safe to
 * re-run. A chat Retell rejects is reported as ``failure`` and the response
 * status is 207; the remaining chats are still closed.
 */
export const ordersV4CloseRetellConversations = <ThrowOnError extends boolean = false>(options: Options<OrdersV4CloseRetellConversationsData, ThrowOnError>): RequestResult<OrdersV4CloseRetellConversationsResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV4CloseRetellConversationsResponses, unknown, ThrowOnError>({ url: '/api/v4/orders/{order_id}/close-retell-conversations', ...options });

export const ordersV4PostConfirmationRequest = <ThrowOnError extends boolean = false>(options: Options<OrdersV4PostConfirmationRequestData, ThrowOnError>): RequestResult<OrdersV4PostConfirmationRequestResponses, OrdersV4PostConfirmationRequestErrors, ThrowOnError> => (options.client ?? client).post<OrdersV4PostConfirmationRequestResponses, OrdersV4PostConfirmationRequestErrors, ThrowOnError>({
  url: '/api/v4/orders/{order_id}/confirmation-request',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV4PatchConfirmationStatus = <ThrowOnError extends boolean = false>(options: Options<OrdersV4PatchConfirmationStatusData, ThrowOnError>): RequestResult<OrdersV4PatchConfirmationStatusResponses, OrdersV4PatchConfirmationStatusErrors, ThrowOnError> => (options.client ?? client).patch<OrdersV4PatchConfirmationStatusResponses, OrdersV4PatchConfirmationStatusErrors, ThrowOnError>({
  url: '/api/v4/orders/{order_id}/confirmation-status',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV4PatchManualVerification = <ThrowOnError extends boolean = false>(options: Options<OrdersV4PatchManualVerificationData, ThrowOnError>): RequestResult<OrdersV4PatchManualVerificationResponses, OrdersV4PatchManualVerificationErrors, ThrowOnError> => (options.client ?? client).patch<OrdersV4PatchManualVerificationResponses, OrdersV4PatchManualVerificationErrors, ThrowOnError>({
  url: '/api/v4/orders/{order_id}/insurance/{slot}/manual-verification',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Product Configuration Audit (v4)
 *
 * Read-only audit surfacing three classes of product misconfiguration:
 * missing coverage zones, missing fee schedules, and duplicate fee schedules.
 *
 * Optional product_uuid query param scopes per-product checks to one product.
 * Duplicate fee schedule check always runs globally.
 * Auth: conduit_employee only.
 */
export const productsV4GetProductAudit = <ThrowOnError extends boolean = false>(options?: Options<ProductsV4GetProductAuditData, ThrowOnError>): RequestResult<ProductsV4GetProductAuditResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV4GetProductAuditResponses, unknown, ThrowOnError>({ url: '/api/v4/products/audit', ...options });

/**
 * Get Carriers (v4)
 *
 * Returns template carriers with an approved status and products in the given state.
 * Accepts an optional ?catalog param to restrict to carriers with products in that catalog.
 * Filters to carriers with a non-null frhc_id (Python-side, matching v2 behavior).
 */
export const productsV4GetCarriers = <ThrowOnError extends boolean = false>(options: Options<ProductsV4GetCarriersData, ThrowOnError>): RequestResult<ProductsV4GetCarriersResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV4GetCarriersResponses, unknown, ThrowOnError>({ url: '/api/v4/products/carriers', ...options });

export const productsV4GetCatalogProducts = <ThrowOnError extends boolean = false>(options: Options<ProductsV4GetCatalogProductsData, ThrowOnError>): RequestResult<ProductsV4GetCatalogProductsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV4GetCatalogProductsResponses, unknown, ThrowOnError>({ url: '/api/v4/products/catalog', ...options });

export const productsV4GetCatalogProduct = <ThrowOnError extends boolean = false>(options: Options<ProductsV4GetCatalogProductData, ThrowOnError>): RequestResult<ProductsV4GetCatalogProductResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV4GetCatalogProductResponses, unknown, ThrowOnError>({ url: '/api/v4/products/catalog/{product_uuid}', ...options });

/**
 * Get All Categories (v4)
 *
 * Returns ProductCategory records filtered by catalog (default: Marketplace).
 * Pass ``catalog=`` (empty) to return all categories regardless of catalog association.
 * Fixes the v2 bug where the role was 'marketplace_employee' (non-existent); v4
 * uses 'marketplace_user'.
 */
export const productsV4GetAllCategories = <ThrowOnError extends boolean = false>(options?: Options<ProductsV4GetAllCategoriesData, ThrowOnError>): RequestResult<ProductsV4GetAllCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV4GetAllCategoriesResponses, unknown, ThrowOnError>({ url: '/api/v4/products/categories/all', ...options });

/**
 * Search Categories (v4)
 *
 * Returns top-level product categories and their subcategories as a label-keyed dict.
 * No authentication required — mirrors v2 GET /products/categories/search behavior.
 * Cannot use @response decorator because the payload shape is variable (parent label →
 * list of subcategory labels). See D-8 in plan v5.
 */
export const productsV4SearchCategories = <ThrowOnError extends boolean = false>(options?: Options<ProductsV4SearchCategoriesData, ThrowOnError>): RequestResult<ProductsV4SearchCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV4SearchCategoriesResponses, unknown, ThrowOnError>({ url: '/api/v4/products/categories/search', ...options });

/**
 * Get Coverage Zones (v4)
 *
 * Returns all CoverageZone records regardless of product availability.
 * Accepts an optional ?catalog param — when provided, filters to zones that have at least
 * one product in that catalog (mirrors v3 /products/coverage_zones/ behaviour).
 * Identical to v2 GET /insurance/coverage_zones/all when no catalog filter is applied.
 */
export const productsV4GetCoverageZones = <ThrowOnError extends boolean = false>(options?: Options<ProductsV4GetCoverageZonesData, ThrowOnError>): RequestResult<ProductsV4GetCoverageZonesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV4GetCoverageZonesResponses, unknown, ThrowOnError>({ url: '/api/v4/products/coverage_zones', ...options });

/**
 * Get Fee Schedule (v4)
 *
 * Returns fee/refill data for HCPC codes in a given carrier/state context.
 * Identical logic to v2 GET /insurance/fee_schedule/{carrier}/{state}.
 * No authentication required — matches v2 behavior.
 */
export const productsV4GetFeeSchedule = <ThrowOnError extends boolean = false>(options: Options<ProductsV4GetFeeScheduleData, ThrowOnError>): RequestResult<ProductsV4GetFeeScheduleResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV4GetFeeScheduleResponses, unknown, ThrowOnError>({ url: '/api/v4/products/fee_schedule', ...options });

/**
 * Search Products (v4 admin)
 *
 * Admin product search with filters for category, catalog, coverage zone, supplier, and
 * a free-text search term. Defaults to active/visible/approved products — the same scope
 * as v2 GET /products/search. Non-approved products are managed via Flask-admin directly.
 */
export const productsV4SearchProducts = <ThrowOnError extends boolean = false>(options?: Options<ProductsV4SearchProductsData, ThrowOnError>): RequestResult<ProductsV4SearchProductsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV4SearchProductsResponses, unknown, ThrowOnError>({ url: '/api/v4/products/search', ...options });

/**
 * Get Product Detail (v4 admin)
 *
 * Admin view of a single product across all carrier/state configurations.
 * Uses a direct query (not get_query()) so products without categories or CCZ records
 * are not silently 404'd — admin needs to see all products (D-9 in plan v5).
 *
 * Optional carrier/state params scope the response to a single carrier/state combination.
 * legacy_settings() slugifies carrier internally before matching (D-10 in plan v5).
 */
export const productsV4GetProductDetail = <ThrowOnError extends boolean = false>(options: Options<ProductsV4GetProductDetailData, ThrowOnError>): RequestResult<ProductsV4GetProductDetailResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV4GetProductDetailResponses, unknown, ThrowOnError>({ url: '/api/v4/products/{product_uuid}', ...options });

/**
 * Fetch a Healthie appointment by ID for the scheduling UI.
 */
export const schedulingV4GetAppointment = <ThrowOnError extends boolean = false>(options: Options<SchedulingV4GetAppointmentData, ThrowOnError>): RequestResult<SchedulingV4GetAppointmentResponses, SchedulingV4GetAppointmentErrors, ThrowOnError> => (options.client ?? client).get<SchedulingV4GetAppointmentResponses, SchedulingV4GetAppointmentErrors, ThrowOnError>({ url: '/api/v4/scheduling/appointment', ...options });

/**
 * Start an outbound voice call asking the patient to reschedule a missed appointment.
 *
 * Campaign webhook retries will place another call; campaigns should not retry 5xx aggressively.
 */
export const schedulingV4CallToReschedule = <ThrowOnError extends boolean = false>(options: Options<SchedulingV4CallToRescheduleData, ThrowOnError>): RequestResult<SchedulingV4CallToRescheduleResponses, SchedulingV4CallToRescheduleErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV4CallToRescheduleResponses, SchedulingV4CallToRescheduleErrors, ThrowOnError>({
  url: '/api/v4/scheduling/appointment/call-to-reschedule',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Cancel a telehealth appointment.
 *
 * Updates the appointment status to cancelled in Healthie, which will trigger the appointment_updated webhook handling.
 */
export const schedulingV4CancelAppointment = <ThrowOnError extends boolean = false>(options: Options<SchedulingV4CancelAppointmentData, ThrowOnError>): RequestResult<SchedulingV4CancelAppointmentResponses, SchedulingV4CancelAppointmentErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV4CancelAppointmentResponses, SchedulingV4CancelAppointmentErrors, ThrowOnError>({
  url: '/api/v4/scheduling/cancel',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get days with available appointment slots from Healthie.
 */
export const schedulingV4GetDays = <ThrowOnError extends boolean = false>(options?: Options<SchedulingV4GetDaysData, ThrowOnError>): RequestResult<SchedulingV4GetDaysResponses, SchedulingV4GetDaysErrors, ThrowOnError> => (options?.client ?? client).get<SchedulingV4GetDaysResponses, SchedulingV4GetDaysErrors, ThrowOnError>({ url: '/api/v4/scheduling/days', ...options });

/**
 * Reschedule a patient's appointment. The flow is:
 *
 * 1. Book a new appointment
 * 2. Mark any upcoming appointments of the same Healthie appointment-type as "Re-Scheduled"
 */
export const schedulingV4RescheduleAppointment = <ThrowOnError extends boolean = false>(options: Options<SchedulingV4RescheduleAppointmentData, ThrowOnError>): RequestResult<SchedulingV4RescheduleAppointmentResponses, SchedulingV4RescheduleAppointmentErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV4RescheduleAppointmentResponses, SchedulingV4RescheduleAppointmentErrors, ThrowOnError>({
  url: '/api/v4/scheduling/reschedule',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Book a telehealth appointment for a self-scheduling patient.
 *
 * Re-verifies DOB, books the telehealth appointment, attaches it to the
 * order, and transitions the order to TELEHEALTH_UPCOMING.
 */
export const schedulingV4BookSelfScheduledAppointment = <ThrowOnError extends boolean = false>(options: Options<SchedulingV4BookSelfScheduledAppointmentData, ThrowOnError>): RequestResult<SchedulingV4BookSelfScheduledAppointmentResponses, SchedulingV4BookSelfScheduledAppointmentErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV4BookSelfScheduledAppointmentResponses, SchedulingV4BookSelfScheduledAppointmentErrors, ThrowOnError>({
  url: '/api/v4/scheduling/schedule',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Enqueue a CIO event inviting the patient to self-schedule a telehealth visit.
 */
export const schedulingV4RequestSelfSchedule = <ThrowOnError extends boolean = false>(options: Options<SchedulingV4RequestSelfScheduleData, ThrowOnError>): RequestResult<SchedulingV4RequestSelfScheduleResponses, SchedulingV4RequestSelfScheduleErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV4RequestSelfScheduleResponses, SchedulingV4RequestSelfScheduleErrors, ThrowOnError>({
  url: '/api/v4/scheduling/schedule/request',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Verify a patient's identity before showing the self-scheduling UI.
 *
 * Checks the patient DOB against the order. Order status is not gated —
 * any status may verify. Returns context needed by the FE (state and
 * timezone for slot filtering).
 */
export const schedulingV4VerifyPatientBooking = <ThrowOnError extends boolean = false>(options: Options<SchedulingV4VerifyPatientBookingData, ThrowOnError>): RequestResult<SchedulingV4VerifyPatientBookingResponses, SchedulingV4VerifyPatientBookingErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV4VerifyPatientBookingResponses, SchedulingV4VerifyPatientBookingErrors, ThrowOnError>({
  url: '/api/v4/scheduling/schedule/verify',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Book or reschedule a telehealth appointment via order public ID.
 *
 * Looks up the order for DOB verification. Branches on whether the order
 * already has a Healthie ``booking_uid``:
 * - No booking (or prior booking already Occurred): books a new appointment via
 * the self-schedule path (b2b Healthie channel, matching ``/schedule``).
 * - Has an active booking: reschedules, deriving appointment_type_id and
 * patient_id from the stored booking via a Healthie lookup.
 *
 * Existing ``/schedule`` and ``/reschedule`` endpoints are not affected.
 */
export const schedulingV4ScheduleOrRescheduleAppointment = <ThrowOnError extends boolean = false>(options: Options<SchedulingV4ScheduleOrRescheduleAppointmentData, ThrowOnError>): RequestResult<SchedulingV4ScheduleOrRescheduleAppointmentResponses, SchedulingV4ScheduleOrRescheduleAppointmentErrors, ThrowOnError> => (options.client ?? client).post<SchedulingV4ScheduleOrRescheduleAppointmentResponses, SchedulingV4ScheduleOrRescheduleAppointmentErrors, ThrowOnError>({
  url: '/api/v4/scheduling/schedule/{order_public_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get available time slots from Healthie for the specified date range.
 */
export const schedulingV4GetSlots = <ThrowOnError extends boolean = false>(options?: Options<SchedulingV4GetSlotsData, ThrowOnError>): RequestResult<SchedulingV4GetSlotsResponses, SchedulingV4GetSlotsErrors, ThrowOnError> => (options?.client ?? client).get<SchedulingV4GetSlotsResponses, SchedulingV4GetSlotsErrors, ThrowOnError>({ url: '/api/v4/scheduling/slots', ...options });

export const trackingV4VerifyAndGetTracking = <ThrowOnError extends boolean = false>(options: Options<TrackingV4VerifyAndGetTrackingData, ThrowOnError>): RequestResult<TrackingV4VerifyAndGetTrackingResponses, unknown, ThrowOnError> => (options.client ?? client).post<TrackingV4VerifyAndGetTrackingResponses, unknown, ThrowOnError>({
  url: '/api/v4/tracking/{public_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV5ListActionReasons = <ThrowOnError extends boolean = false>(options?: Options<OrdersV5ListActionReasonsData, ThrowOnError>): RequestResult<OrdersV5ListActionReasonsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV5ListActionReasonsResponses, unknown, ThrowOnError>({ url: '/api/v5/orders/action-reasons', ...options });

/**
 * Billing order endpoint
 *
 * Send billing information to Candid Health.
 */
export const ordersV5Billing = <ThrowOnError extends boolean = false>(options: Options<OrdersV5BillingData, ThrowOnError>): RequestResult<OrdersV5BillingResponses, OrdersV5BillingErrors, ThrowOnError> => (options.client ?? client).post<OrdersV5BillingResponses, OrdersV5BillingErrors, ThrowOnError>({
  url: '/api/v5/orders/billing',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV5MessagesV5GetOrderMessage = <ThrowOnError extends boolean = false>(options: Options<OrdersV5MessagesV5GetOrderMessageData, ThrowOnError>): RequestResult<OrdersV5MessagesV5GetOrderMessageResponses, OrdersV5MessagesV5GetOrderMessageErrors, ThrowOnError> => (options.client ?? client).get<OrdersV5MessagesV5GetOrderMessageResponses, OrdersV5MessagesV5GetOrderMessageErrors, ThrowOnError>({ url: '/api/v5/orders/messages/{order_id}/{channel}', ...options });

export const ordersV5MessagesV5CreateMessage = <ThrowOnError extends boolean = false>(options: Options<OrdersV5MessagesV5CreateMessageData, ThrowOnError>): RequestResult<OrdersV5MessagesV5CreateMessageResponses, OrdersV5MessagesV5CreateMessageErrors, ThrowOnError> => (options.client ?? client).post<OrdersV5MessagesV5CreateMessageResponses, OrdersV5MessagesV5CreateMessageErrors, ThrowOnError>({
  url: '/api/v5/orders/messages/{order_id}/{channel}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV5MessagesV5MarkMessagesSeen = <ThrowOnError extends boolean = false>(options: Options<OrdersV5MessagesV5MarkMessagesSeenData, ThrowOnError>): RequestResult<OrdersV5MessagesV5MarkMessagesSeenResponses, OrdersV5MessagesV5MarkMessagesSeenErrors, ThrowOnError> => (options.client ?? client).patch<OrdersV5MessagesV5MarkMessagesSeenResponses, OrdersV5MessagesV5MarkMessagesSeenErrors, ThrowOnError>({
  url: '/api/v5/orders/messages/{order_id}/{channel}/seen',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV5MessagesV5DeleteMessage = <ThrowOnError extends boolean = false>(options: Options<OrdersV5MessagesV5DeleteMessageData, ThrowOnError>): RequestResult<OrdersV5MessagesV5DeleteMessageResponses, OrdersV5MessagesV5DeleteMessageErrors, ThrowOnError> => (options.client ?? client).delete<OrdersV5MessagesV5DeleteMessageResponses, OrdersV5MessagesV5DeleteMessageErrors, ThrowOnError>({ url: '/api/v5/orders/messages/{order_id}/{channel}/{message_id}', ...options });

export const ordersV5NotificationsV5ListNotifications = <ThrowOnError extends boolean = false>(options?: Options<OrdersV5NotificationsV5ListNotificationsData, ThrowOnError>): RequestResult<OrdersV5NotificationsV5ListNotificationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV5NotificationsV5ListNotificationsResponses, unknown, ThrowOnError>({ url: '/api/v5/orders/notifications', ...options });

export const ordersV5NotificationsV5MarkNotificationsSeen = <ThrowOnError extends boolean = false>(options: Options<OrdersV5NotificationsV5MarkNotificationsSeenData, ThrowOnError>): RequestResult<OrdersV5NotificationsV5MarkNotificationsSeenResponses, OrdersV5NotificationsV5MarkNotificationsSeenErrors, ThrowOnError> => (options.client ?? client).patch<OrdersV5NotificationsV5MarkNotificationsSeenResponses, OrdersV5NotificationsV5MarkNotificationsSeenErrors, ThrowOnError>({
  url: '/api/v5/orders/notifications/seen',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

export const ordersV5TimelineV5GetOrderTimeline = <ThrowOnError extends boolean = false>(options: Options<OrdersV5TimelineV5GetOrderTimelineData, ThrowOnError>): RequestResult<OrdersV5TimelineV5GetOrderTimelineResponses, OrdersV5TimelineV5GetOrderTimelineErrors, ThrowOnError> => (options.client ?? client).get<OrdersV5TimelineV5GetOrderTimelineResponses, OrdersV5TimelineV5GetOrderTimelineErrors, ThrowOnError>({ url: '/api/v5/orders/timeline/{order_id}', ...options });

export const ordersV5TriggerRentalClaimsEndpoint = <ThrowOnError extends boolean = false>(options: Options<OrdersV5TriggerRentalClaimsEndpointData, ThrowOnError>): RequestResult<OrdersV5TriggerRentalClaimsEndpointResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV5TriggerRentalClaimsEndpointResponses, unknown, ThrowOnError>({
  url: '/api/v5/orders/trigger-rental-claims',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Uncancel orders in bulk.
 *
 * Moves each cancelled order to the requested target status. Orders that are
 * not in the CANCELLED state are skipped with a failure reason and do not
 * block the rest of the batch. When a note is provided it is added to every
 * order that is successfully uncancelled.
 */
export const ordersV5UncancelOrders = <ThrowOnError extends boolean = false>(options: Options<OrdersV5UncancelOrdersData, ThrowOnError>): RequestResult<OrdersV5UncancelOrdersResponses, unknown, ThrowOnError> => (options.client ?? client).post<OrdersV5UncancelOrdersResponses, unknown, ThrowOnError>({
  url: '/api/v5/orders/uncancel',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Order Details (v5)
 *
 * Identical response shape to GET /v1/orders/<order_id> with metadata.version = 5.
 * Replaces per-item product queries with two batch queries (Product + HCPC prefetch),
 * eliminating the N+1 pattern for orders with UUID product references.
 *
 * v1 remains live for orders with legacy product_id values.
 */
export const ordersV5OrderDetails = <ThrowOnError extends boolean = false>(options: Options<OrdersV5OrderDetailsData, ThrowOnError>): RequestResult<OrdersV5OrderDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV5OrderDetailsResponses, unknown, ThrowOnError>({ url: '/api/v5/orders/{order_id}', ...options });

export const ordersV5CancelOrder = <ThrowOnError extends boolean = false>(options: Options<OrdersV5CancelOrderData, ThrowOnError>): RequestResult<OrdersV5CancelOrderResponses, OrdersV5CancelOrderErrors, ThrowOnError> => (options.client ?? client).patch<OrdersV5CancelOrderResponses, OrdersV5CancelOrderErrors, ThrowOnError>({
  url: '/api/v5/orders/{order_id}/cancel',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Create a new catalog product.
 */
export const productsV5CreateProductRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV5CreateProductRouteData, ThrowOnError>): RequestResult<ProductsV5CreateProductRouteResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProductsV5CreateProductRouteResponses, unknown, ThrowOnError>({
  url: '/api/v5/products/',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Remove a child product from a parent bundle.
 */
export const productsV5DeleteBundleItemRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV5DeleteBundleItemRouteData, ThrowOnError>): RequestResult<ProductsV5DeleteBundleItemRouteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProductsV5DeleteBundleItemRouteResponses, unknown, ThrowOnError>({ url: '/api/v5/products/bundle_items', ...options });

/**
 * Add a child product to a parent bundle.
 */
export const productsV5CreateBundleItemRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV5CreateBundleItemRouteData, ThrowOnError>): RequestResult<ProductsV5CreateBundleItemRouteResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProductsV5CreateBundleItemRouteResponses, unknown, ThrowOnError>({
  url: '/api/v5/products/bundle_items',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * All product bundle types for the admin bundle item picker.
 *
 * Returns every type regardless of active/visible status — the flags are
 * included so the caller can present them. Ordered by label.
 */
export const productsV5GetBundleTypesRoute = <ThrowOnError extends boolean = false>(options?: Options<ProductsV5GetBundleTypesRouteData, ThrowOnError>): RequestResult<ProductsV5GetBundleTypesRouteResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV5GetBundleTypesRouteResponses, unknown, ThrowOnError>({ url: '/api/v5/products/bundle_types', ...options });

/**
 * Paginated admin product catalog with search, catalog, state, and plan filters.
 */
export const productsV5GetAdminCatalog = <ThrowOnError extends boolean = false>(options?: Options<ProductsV5GetAdminCatalogData, ThrowOnError>): RequestResult<ProductsV5GetAdminCatalogResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV5GetAdminCatalogResponses, unknown, ThrowOnError>({ url: '/api/v5/products/catalog', ...options });

/**
 * All product categories with catalog memberships for the admin product UI.
 *
 * Returns categories ordered by label, each enriched with its catalog
 * label memberships and parent info. Used to populate the multi-select
 * category picker in EditItemPanel, grouped by catalog.
 */
export const productsV5GetAdminCategories = <ThrowOnError extends boolean = false>(options?: Options<ProductsV5GetAdminCategoriesData, ThrowOnError>): RequestResult<ProductsV5GetAdminCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV5GetAdminCategoriesResponses, unknown, ThrowOnError>({ url: '/api/v5/products/categories', ...options });

/**
 * Admin plan listing — paginated, filterable, sortable.
 *
 * Supports filtering by plan_uuid, state, catalog, name, plan_type,
 * is_active, is_visible, HCPC code, and free-text q.
 * Supports sorting by name, state, catalog, plan_type, is_active,
 * is_visible, created_at, modified_at.
 */
export const productsV5GetAdminPlans = <ThrowOnError extends boolean = false>(options?: Options<ProductsV5GetAdminPlansData, ThrowOnError>): RequestResult<ProductsV5GetAdminPlansResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV5GetAdminPlansResponses, unknown, ThrowOnError>({ url: '/api/v5/products/plans', ...options });

/**
 * Get active coverage zones for the catalog state filter dropdown.
 */
export const productsV5GetAdminProductStates = <ThrowOnError extends boolean = false>(options?: Options<ProductsV5GetAdminProductStatesData, ThrowOnError>): RequestResult<ProductsV5GetAdminProductStatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV5GetAdminProductStatesResponses, unknown, ThrowOnError>({ url: '/api/v5/products/states', ...options });

/**
 * Delete a product (hard delete with is_active fallback).
 *
 * Attempts a hard DELETE. If FK constraints prevent deletion, the product
 * is deactivated (is_active=False) instead. Always returns 200.
 */
export const productsV5DeleteProductRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV5DeleteProductRouteData, ThrowOnError>): RequestResult<ProductsV5DeleteProductRouteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProductsV5DeleteProductRouteResponses, unknown, ThrowOnError>({ url: '/api/v5/products/{product_uuid}', ...options });

/**
 * Partial update of a catalog product.
 */
export const productsV5UpdateProductRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV5UpdateProductRouteData, ThrowOnError>): RequestResult<ProductsV5UpdateProductRouteResponses, unknown, ThrowOnError> => (options.client ?? client).patch<ProductsV5UpdateProductRouteResponses, unknown, ThrowOnError>({
  url: '/api/v5/products/{product_uuid}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Return the bundle items (child components) of a product.
 */
export const productsV5GetProductBundleItems = <ThrowOnError extends boolean = false>(options: Options<ProductsV5GetProductBundleItemsData, ThrowOnError>): RequestResult<ProductsV5GetProductBundleItemsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV5GetProductBundleItemsResponses, unknown, ThrowOnError>({ url: '/api/v5/products/{product_uuid}/bundle_items', ...options });

/**
 * Clone a product's HCPC configurations onto one or more plans.
 *
 * Creates one submission record per target plan and ingests each immediately.
 * Each clone reads the product's template configurations for the resolved
 * source carrier coverage zone and repoints them at the target plan's fee
 * schedule for the same code.
 *
 * Returns 200 even when individual plans land partially — inspect each row's
 * ``status`` and ``errors``. 404 when the product does not exist; 422 when no
 * submitted plan id resolves to an active plan.
 */
export const productsV5CloneProductToPlansRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV5CloneProductToPlansRouteData, ThrowOnError>): RequestResult<ProductsV5CloneProductToPlansRouteResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProductsV5CloneProductToPlansRouteResponses, unknown, ThrowOnError>({
  url: '/api/v5/products/{product_uuid}/clone_to_plans',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Replace dimension_settings in product.properties.
 *
 * Full replacement — the supplied list overwrites all existing dimension
 * settings on the product. [] clears all dimensions.
 *
 * Returns 200 + saved settings.
 * 404 if product not found.
 * 422 if schema invalid (empty key, duplicate key, depends_on references nonexistent key).
 */
export const productsV5PutProductDimensionSettingsRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV5PutProductDimensionSettingsRouteData, ThrowOnError>): RequestResult<ProductsV5PutProductDimensionSettingsRouteResponses, unknown, ThrowOnError> => (options.client ?? client).put<ProductsV5PutProductDimensionSettingsRouteResponses, unknown, ThrowOnError>({
  url: '/api/v5/products/{product_uuid}/dimension-settings',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Return all PHC rows for a product, grouped by variant key.
 *
 * Admin surface — includes active and inactive PHCs. Entries within each
 * variant group are ordered by phc.properties["order"] ascending.
 * Returns empty hcpcs_by_variant (not an error) when the product has no PHC rows.
 */
export const productsV5GetProductHcpcsRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV5GetProductHcpcsRouteData, ThrowOnError>): RequestResult<ProductsV5GetProductHcpcsRouteResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV5GetProductHcpcsRouteResponses, unknown, ThrowOnError>({ url: '/api/v5/products/{product_uuid}/hcpcs', ...options });

/**
 * Full-replace bulk save for a product's PHC rows.
 *
 * Reconciles submitted hcpcs_by_variant against DB in one atomic transaction:
 * updates entries with phc_uuid, inserts entries without, deletes omitted PHCs,
 * rebuilds ProductPlanJunction from active PHC plan_uuids.
 *
 * Returns 200 + same shape as GET on success.
 * 404 if product not found; 422 if any code/FeeSchedule/status lookup fails.
 */
export const productsV5PutProductHcpcsRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV5PutProductHcpcsRouteData, ThrowOnError>): RequestResult<ProductsV5PutProductHcpcsRouteResponses, unknown, ThrowOnError> => (options.client ?? client).put<ProductsV5PutProductHcpcsRouteResponses, unknown, ThrowOnError>({
  url: '/api/v5/products/{product_uuid}/hcpcs',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Upload a photo to a named slot on a catalog product.
 *
 * Accepts multipart/form-data with ``image`` (JPEG/PNG) and ``slot``
 * (``"square"`` or ``"thumbnail"``).  The file is proxied to S3 and the
 * resulting public URL is stored in ``product.media[slot]``.
 *
 * Returns the updated AdminCatalogItemSchema dict on success.
 * 404 if the product is not found, 422 if the slot or file type is invalid.
 */
export const productsV5PatchProductPhotosRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV5PatchProductPhotosRouteData, ThrowOnError>): RequestResult<ProductsV5PatchProductPhotosRouteResponses, unknown, ThrowOnError> => (options.client ?? client).patch<ProductsV5PatchProductPhotosRouteResponses, unknown, ThrowOnError>({
  ...formDataBodySerializer,
  url: '/api/v5/products/{product_uuid}/photos',
  ...options,
  headers: {
    'Content-Type': null,
    ...options.headers
  }
});

/**
 * Remove a photo slot from a catalog product.
 *
 * Clears ``product.media[slot]`` and returns the updated
 * AdminCatalogItemSchema dict on success.
 * 404 if the product is not found, 422 if the slot name is invalid.
 */
export const productsV5DeleteProductPhotoRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV5DeleteProductPhotoRouteData, ThrowOnError>): RequestResult<ProductsV5DeleteProductPhotoRouteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProductsV5DeleteProductPhotoRouteResponses, unknown, ThrowOnError>({ url: '/api/v5/products/{product_uuid}/photos/{slot}', ...options });

/**
 * Heartbeat
 */
export const ordersV6Heartbeat = <ThrowOnError extends boolean = false>(options?: Options<OrdersV6HeartbeatData, ThrowOnError>): RequestResult<OrdersV6HeartbeatResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrdersV6HeartbeatResponses, unknown, ThrowOnError>({ url: '/api/v6/orders/heartbeat', ...options });

/**
 * Get Order Details (v6)
 *
 * Same envelope as GET /v1/orders/<order_id> with metadata.version = 6.
 * Item variants are resolved from the first matching plan in plan-type priority
 * order and include product_hcpc_configuration_uuid. UUID product IDs only;
 * non-UUID items receive empty decoration.
 */
export const ordersV6OrderDetails = <ThrowOnError extends boolean = false>(options: Options<OrdersV6OrderDetailsData, ThrowOnError>): RequestResult<OrdersV6OrderDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<OrdersV6OrderDetailsResponses, unknown, ThrowOnError>({ url: '/api/v6/orders/{order_id}', ...options });

/**
 * Return the v3 product-list contract using plan assignments.
 */
export const productsV6GetProducts = <ThrowOnError extends boolean = false>(options: Options<ProductsV6GetProductsData, ThrowOnError>): RequestResult<ProductsV6GetProductsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV6GetProductsResponses, unknown, ThrowOnError>({ url: '/api/v6/products/', ...options });

/**
 * Return the v4 catalog-list contract using plan configurations.
 */
export const productsV6GetCatalogProducts = <ThrowOnError extends boolean = false>(options: Options<ProductsV6GetCatalogProductsData, ThrowOnError>): RequestResult<ProductsV6GetCatalogProductsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV6GetCatalogProductsResponses, unknown, ThrowOnError>({ url: '/api/v6/products/catalog', ...options });

/**
 * Return the v4 catalog-detail contract using plan configurations.
 */
export const productsV6GetCatalogProduct = <ThrowOnError extends boolean = false>(options: Options<ProductsV6GetCatalogProductData, ThrowOnError>): RequestResult<ProductsV6GetCatalogProductResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV6GetCatalogProductResponses, unknown, ThrowOnError>({ url: '/api/v6/products/catalog/{product_uuid}', ...options });

/**
 * Return the v3 coverage-zone contract using plan assignments.
 */
export const productsV6GetCoverageZones = <ThrowOnError extends boolean = false>(options?: Options<ProductsV6GetCoverageZonesData, ThrowOnError>): RequestResult<ProductsV6GetCoverageZonesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProductsV6GetCoverageZonesResponses, unknown, ThrowOnError>({ url: '/api/v6/products/coverage_zones/', ...options });

/**
 * Return the fee schedule configured on one ProductHcpcConfiguration.
 *
 * Payload entries match ``GET /v1/orders/<order_id>/fee_schedules`` field for field.
 * The envelope differs: ``metadata`` is ``BaseMetadataSchema`` here, matching the
 * sibling ICD route, so it carries ``timestamp`` / ``count`` rather than the order
 * endpoint's ``version`` / ``function_profile``.
 *
 * The PHC already names its fee schedule via ``fee_schedule_uuid``, so this endpoint
 * takes no ``code`` parameter and runs no insurance cascade -- the carrier and
 * coverage zone come from the fee schedule row itself. The payload therefore holds at
 * most one entry, but stays a list to keep the payload contracts interchangeable.
 *
 * Returns 200 with an empty payload when the PHC uuid does not exist or carries no
 * fee schedule, mirroring the order endpoint's no-match behaviour and the sibling
 * ICD route. The role list matches that route for the same reason: any caller that
 * can list the v6 catalog needs to resolve pricing for the rows it returned.
 */
export const productsV6GetPhcFeeSchedulesRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV6GetPhcFeeSchedulesRouteData, ThrowOnError>): RequestResult<ProductsV6GetPhcFeeSchedulesRouteResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV6GetPhcFeeSchedulesRouteResponses, unknown, ThrowOnError>({ url: '/api/v6/products/hcpcs/{product_hcpc_configuration_uuid}/fee_schedules', ...options });

/**
 * Return the ICD-10 codes configured on one ProductHcpcConfiguration.
 *
 * Reads ``json_data["icd10_codes"]`` off the PHC row and resolves each entry
 * against the icd_codes table. Codes with no matching record are omitted.
 * Returns an empty payload (200) when the PHC uuid does not exist.
 *
 * The role list must stay a superset of get_catalog_products': these codes used to
 * ship inline on the catalog payload, so any role that can list the catalog has to
 * be able to load them here.
 */
export const productsV6GetQualifyingIcdsRoute = <ThrowOnError extends boolean = false>(options: Options<ProductsV6GetQualifyingIcdsRouteData, ThrowOnError>): RequestResult<ProductsV6GetQualifyingIcdsRouteResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsV6GetQualifyingIcdsRouteResponses, unknown, ThrowOnError>({ url: '/api/v6/products/hcpcs/{product_hcpc_configuration_uuid}/icds', ...options });
